// Auto-generated by scripts/processVerbatims.mjs — do not edit manually
// Source: conjoint raw data + verbatims CSV, 1000 respondents

export interface VerbatimRespondent {
  date: string;
  goals: string;
  priceObjection: string;
  wtpFactors: string;
  brandPerception: string;
  otherBrand: string;
  otherDevice: string;
  otherGoal: string;
  noneCount: number;
  segment: 'always-none' | 'never-none' | 'selective';
  avgChosenPrice: number | null;
  priceDistribution: Record<string, number>;
  featureChoiceRates: Record<string, number>;
  gender: string;
  age: number;
  income: string;
  race: string;
  education: string;
  employmentStatus: string;
  relationshipStatus: string;
  region: string;
  monthlySpend: string;
  purchaseApproach: string;
  primaryGoal: string;
  seekFrequency: string;
  paymentPreference: string;
  featureImportance: Record<string, string>;
  featureRanking: Record<string, number>;
  attitudes: Record<string, string>;
  purchaseFactorRanking: Record<string, number>;
  brandConsideration: string[];
  wearableDevices: string[];
}

export const VERBATIM_DATA: VerbatimRespondent[] = [
  {
    "date": "Feb 18, 2026 9:30 PM UTC",
    "goals": "get better control of my blood pressure",
    "priceObjection": "",
    "wtpFactors": "make it more affordable",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1426,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 9:31 PM UTC",
    "goals": "I focus on cardio fitness & lower my cholesterol",
    "priceObjection": "I can research myself",
    "wtpFactors": "Nothing would influence me",
    "brandPerception": "I never heard of it before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1292,
    "priceDistribution": {
      "499": 2,
      "999": 5,
      "1499": 3,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:32 PM UTC",
    "goals": "Put on size.",
    "priceObjection": "",
    "wtpFactors": "If its affordable and i feel I am getting value.",
    "brandPerception": "DNA",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:32 PM UTC",
    "goals": "Stay a healthy weight, get enough exercise and sleep and medatation",
    "priceObjection": "This is an insane price",
    "wtpFactors": "Would have to include something I cant get anywhere else - or do the exercise for me!",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch",
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 9:32 PM UTC",
    "goals": "I want to eat better and just feel better in my clothes and take up less space.",
    "priceObjection": "",
    "wtpFactors": "Knowing it will work and fit with my lifestyle and goals.",
    "brandPerception": "Change me and make me better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 18, 2026 9:32 PM UTC",
    "goals": "just be physically active",
    "priceObjection": "",
    "wtpFactors": "price",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 892,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 9:33 PM UTC",
    "goals": "I AM LOOKING TO MAINTAIN MY HEALTH AND IMPROVE MY SLEEP",
    "priceObjection": "",
    "wtpFactors": "A PLAN THAT MEETS ALL OF MY NEEDS BUT IS STILL AFFORDABLE",
    "brandPerception": "SOME TYPE OF VIDEO GAME",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 649,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:33 PM UTC",
    "goals": "Just maintaining my current strength and weight",
    "priceObjection": "This is entirely out of my price range",
    "wtpFactors": "If I was in dire need of losing weight",
    "brandPerception": "Nothing the phrase doesn't ring a bell",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:34 PM UTC",
    "goals": "I would like to lose 40 pounds.",
    "priceObjection": "To expensive",
    "wtpFactors": "If the price is right.",
    "brandPerception": "I am not familiar.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.2
    },
    "gender": "Female",
    "age": 50,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:34 PM UTC",
    "goals": "To lose 10 pounds and maintain my overall fitness levels",
    "priceObjection": "",
    "wtpFactors": "Something tailored to my specific goals",
    "brandPerception": "Never heard of it before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:35 PM UTC",
    "goals": "i currently  want to lose 4 to 8 more pounds",
    "priceObjection": "",
    "wtpFactors": "an educated  program  plan with guidance",
    "brandPerception": "change my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.643,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.357,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.429
    },
    "gender": "Male",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:36 PM UTC",
    "goals": "I am looking to maintaine my health and weight",
    "priceObjection": "I would not pay this much",
    "wtpFactors": "It would have to have a free trial",
    "brandPerception": "It sounds like a cult",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 18, 2026 9:36 PM UTC",
    "goals": "I'd like to build up my strength energy and activity levels",
    "priceObjection": "I can't afford this",
    "wtpFactors": "very low cost",
    "brandPerception": "some type of program that will change you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Tonal"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:37 PM UTC",
    "goals": "I’m in really good health",
    "priceObjection": "",
    "wtpFactors": "What’s included in the program",
    "brandPerception": "Nothing at the moment",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1026,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 3,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.267,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:38 PM UTC",
    "goals": "Eating healthy breakfast everyday",
    "priceObjection": "",
    "wtpFactors": "It helps you to be healthy",
    "brandPerception": "I dont know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 28,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:38 PM UTC",
    "goals": "to gain muscle",
    "priceObjection": "",
    "wtpFactors": "it would have a sale",
    "brandPerception": "it comes after me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 959,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:38 PM UTC",
    "goals": "I want to exercise more.  I want to lose weight and get strong.",
    "priceObjection": "",
    "wtpFactors": "Which ones offer the most and have the longest and best payment plan option",
    "brandPerception": "That it would help alter my physical condition",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1499,
    "priceDistribution": {
      "499": 0,
      "999": 4,
      "1499": 4,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:38 PM UTC",
    "goals": "Ideal weight through diet and exercise  is 155 lbs. within 3 months.",
    "priceObjection": "",
    "wtpFactors": "Comprehensiveness, affordability, efficiency and effectiveness.",
    "brandPerception": "A Call to be a better you.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.25,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Male",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:39 PM UTC",
    "goals": "I would like to take more supplements and lose some weight this year",
    "priceObjection": "I wouldn't pay this amount",
    "wtpFactors": "the price and what it offers",
    "brandPerception": "something that is going to change me",
    "otherBrand": "just research and buy what seems good and affordable",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.875,
      "Personalized Wellness Plan": 0.375,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.375,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 57,
    "income": "$200,000 or more",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Other",
      "just research and buy what seems good and affordable"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:40 PM UTC",
    "goals": "Continue to eat mostly clean and continue to keep my workout routine thorough and consistent.",
    "priceObjection": "These expensive programs are not what I mean when I say I look for health and wellness programs.",
    "wtpFactors": "I likely would not pay for them. I have always made my own food and workout programs, but I do use free apps and the like to help me keep things organized.",
    "brandPerception": "I've never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:40 PM UTC",
    "goals": "Fix the slipped disc in my back, strengthen my body, lose weight, eat healthier.",
    "priceObjection": "",
    "wtpFactors": "Offers a lot of different things for every area of wellness.",
    "brandPerception": "A crappy scifi movie title",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "Fixing back issues before I can do anything",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Other",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 18, 2026 9:41 PM UTC",
    "goals": "To lose weigjt",
    "priceObjection": "That is insane and I would never pay that much. All of the options are too expensive even with payments.",
    "wtpFactors": "Nothing because all those tools I can find for free online.",
    "brandPerception": "I have never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 34,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:41 PM UTC",
    "goals": "I just wish to maintain my health and my age and trying to fight off any illness",
    "priceObjection": "That's too pricey for me",
    "wtpFactors": "One that is reasonable and does what I want",
    "brandPerception": "I've never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 624,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.25,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.625
    },
    "gender": "Male",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:42 PM UTC",
    "goals": "I want to gain more muscle in the gym.",
    "priceObjection": "Way too expensive.",
    "wtpFactors": "It needs to be a good deal.",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:42 PM UTC",
    "goals": "Reaching my goal weight",
    "priceObjection": "",
    "wtpFactors": "Coaching",
    "brandPerception": "Changing yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:43 PM UTC",
    "goals": "Lose weight and maintain healthy eating",
    "priceObjection": "",
    "wtpFactors": "Cost of the program",
    "brandPerception": "Change yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:44 PM UTC",
    "goals": "Daily exercise and low sugar diet.",
    "priceObjection": "",
    "wtpFactors": "Price and benefits.",
    "brandPerception": "Making changes to the body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:44 PM UTC",
    "goals": "I want to lose weight, but also be stronger and take better care of my body as I get older.",
    "priceObjection": "",
    "wtpFactors": "I would want it to be individualized and maybe something that I could have add-ons. I want something with workouts that I can pull up whenever I want, as well as able to track my progress.",
    "brandPerception": "I've never heard of this brand before, so the only thing that comes to mind is that band, AlterBridge.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 5,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.867,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:45 PM UTC",
    "goals": "I want to continue to lose weight back to a level that I feel comfortable. I aim to get a better grasp on my stress levels",
    "priceObjection": "I would never spend that much on a wellness plan. I could cobble together a sufficient program myself for that kind of money",
    "wtpFactors": "It needs to be adaptive to me, have enough variety that I'm continually interested",
    "brandPerception": "Getting surgery to change something on my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 737,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.625
    },
    "gender": "Female",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 9:46 PM UTC",
    "goals": "i  want  to eat in moderation and exerscie daily",
    "priceObjection": "",
    "wtpFactors": "wide  varietof workout machine and friendely staff",
    "brandPerception": "it means  we really care  about ur health and well  being",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 1799,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:47 PM UTC",
    "goals": "My goal is to maintain a healthy weight and prevent any major health issues by watching my food intake and anything else that could effect my body in a harmful nature.",
    "priceObjection": "",
    "wtpFactors": "The benefits and timeframe, personally would suffice for me.",
    "brandPerception": "I find this to be a brand that is devoted to achieving the best results for one’s health journey.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Google Pixel Watch",
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 9:48 PM UTC",
    "goals": "Lose weight, eat better, reduce stress",
    "priceObjection": "",
    "wtpFactors": "Payments spread out overt",
    "brandPerception": "Cosmetic sur",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1342,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.357,
      "Workout Sessions": 0.357,
      "Recovery Sessions": 0.643,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:48 PM UTC",
    "goals": "I need to loose weight",
    "priceObjection": "",
    "wtpFactors": "Too expensive",
    "brandPerception": "Something that would make me feel active",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 9:49 PM UTC",
    "goals": "I am healthy I cannot complain at all very thankful",
    "priceObjection": "",
    "wtpFactors": "I wouldn’t need much at all like dealing with my health and wellness",
    "brandPerception": "Good company",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1239,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 18, 2026 9:49 PM UTC",
    "goals": "I would like to eat more probiotics.",
    "priceObjection": "",
    "wtpFactors": "Nutrition meals, workouts with popular music, etc.",
    "brandPerception": "Workout",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1119,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:49 PM UTC",
    "goals": "Weight loss",
    "priceObjection": "",
    "wtpFactors": "Proven results",
    "brandPerception": "Change something about yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 624,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 44,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 9:50 PM UTC",
    "goals": "Staying more consistent at working out along with eating healthier on a regular basis.",
    "priceObjection": "",
    "wtpFactors": "I know I would get a lot of benefits out of it and it sounds very appealing",
    "brandPerception": "Changing to a better you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1392,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 5,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:55 PM UTC",
    "goals": "Want to maintain a healthy weight, lower chances of disease and chronic illness",
    "priceObjection": "",
    "wtpFactors": "Variety of plans available, variety of exercises and nutrition plans, trustworthy counselors, payment options",
    "brandPerception": "Never heard of it",
    "otherBrand": "Samsung health",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.833,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.833,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Other",
      "Samsung health"
    ],
    "wearableDevices": [
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:55 PM UTC",
    "goals": "My main goal is to stay generally healthy and avoid any major health issues.\nI want to maintain my current condition, keep my energy stable, and manage things like blood sugar and cholesterol so they don’t get worse.",
    "priceObjection": "",
    "wtpFactors": "I’d be more willing to pay if the program actually reduced my mental load, not added to it. If it made healthy choices automatic instead of giving me more things to track, that would matter more than flashy promises",
    "brandPerception": "personal change, growth, and upgrading yourself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 928,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.286,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.714
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:55 PM UTC",
    "goals": "Pay off debt and build savings",
    "priceObjection": "",
    "wtpFactors": "Affordability and money back if no results",
    "brandPerception": "I’ve never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 2,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.778,
      "Smart Biometrics Ring": 0.556,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.778,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 9:57 PM UTC",
    "goals": "I am trying to exercise more and eat better",
    "priceObjection": "",
    "wtpFactors": "Affordability and variety",
    "brandPerception": "I'm not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 1049,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 9:59 PM UTC",
    "goals": "i hope to lose about 40 lbs",
    "priceObjection": "",
    "wtpFactors": "what are the outcomes",
    "brandPerception": "it will change my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 6,
      "999": 2,
      "1499": 2,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 10:00 PM UTC",
    "goals": "Save and improve!",
    "priceObjection": "",
    "wtpFactors": "Positive reviews and feedback from industry experts.",
    "brandPerception": "Nothing specific.",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1352,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 4,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.2
    },
    "gender": "Male",
    "age": 40,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 10:03 PM UTC",
    "goals": "My goal is to strength my leg and walk better. That may require physical activity and therapy",
    "priceObjection": "",
    "wtpFactors": "If it was to make my health better than what it is now",
    "brandPerception": "Not really sure about that",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1432,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 3,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 10:06 PM UTC",
    "goals": "I have good health but it can always be improved",
    "priceObjection": "",
    "wtpFactors": "If they were effective",
    "brandPerception": "A product that would change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 10:08 PM UTC",
    "goals": "Just want to get healthier for myself and my family",
    "priceObjection": "Overpriced garbage",
    "wtpFactors": "The price for this is insanity lol",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 1,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 10:08 PM UTC",
    "goals": "Im just getting myself motivated to start losing weight and start eating healthier",
    "priceObjection": "",
    "wtpFactors": "I need help getting started so I feel a health and wellness program would be very beneficial",
    "brandPerception": "Make me look and feel better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 713,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.857,
      "Smart Biometrics Ring": 0.857,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 10:09 PM UTC",
    "goals": "My current health goals are to gain muscle and lose fat",
    "priceObjection": "",
    "wtpFactors": "Daily workout plans at work",
    "brandPerception": "Changing your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1132,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 4,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 50,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 18, 2026 10:10 PM UTC",
    "goals": "Eat right and exercise to build muscle and strength",
    "priceObjection": "",
    "wtpFactors": "It depends on if I feel I needed it",
    "brandPerception": "Change to your appearance",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1119,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.067,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 10:16 PM UTC",
    "goals": "I want to have my muscles and joints feel better and not creak",
    "priceObjection": "I am not paying that for anything",
    "wtpFactors": "It has to use plain language.  I have NO IDEA what you were trying to sell me in these ads!",
    "brandPerception": "I don't know what this refers to",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 10:19 PM UTC",
    "goals": "I really want to lose weight. I would like to lose around 100lbs. I would also like to be able to increase my my cardio and be able to run a 5K.",
    "priceObjection": "",
    "wtpFactors": "If I could do monthly payments and if it included the health monitoring ring device.",
    "brandPerception": "I’ve never heard of it, but maybe a program to change parts of yourself and improve?",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1119,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 10:20 PM UTC",
    "goals": "I want to stay healthy",
    "priceObjection": "",
    "wtpFactors": "I think that it is the way that you try to live your life",
    "brandPerception": "It is a different word maybe a video game",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 939,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Ladder",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:30 PM UTC",
    "goals": "I want to drink more water and I would like to gain about 10-20 pounds",
    "priceObjection": "",
    "wtpFactors": "I smart ring with no monthly fees to use it. Personalized meal plans to help me reach my specific goals. Affordable monthly payments with little to no interest.",
    "brandPerception": "I have never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1090,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 5,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.545,
      "Smart Biometrics Ring": 0.909,
      "Personalized Wellness Plan": 0.364,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.545,
      "Recovery Sessions": 0.455,
      "Nutrition Tracking": 0.364
    },
    "gender": "Female",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:30 PM UTC",
    "goals": "my personal health goal is to maintain my physique and diet.",
    "priceObjection": "",
    "wtpFactors": "the importance of maintaining my health.",
    "brandPerception": "to change myself or someone for the better or worse.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1486,
    "priceDistribution": {
      "499": 0,
      "999": 4,
      "1499": 4,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:31 PM UTC",
    "goals": "To lose 20lbs of fat and put on muscle.",
    "priceObjection": "",
    "wtpFactors": "As long as it works then I’m willing to pay the amount so I can hit my goals",
    "brandPerception": "It means to change myself when I read it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:33 PM UTC",
    "goals": "I would like to lose 20 lbs. so that my cholesterol numbers decrease.",
    "priceObjection": "",
    "wtpFactors": "The price is the most important factor because many apps and videos are available for free.",
    "brandPerception": "I have never heard of it. Changing yourself comes to mind.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:33 PM UTC",
    "goals": "Eat healthier and move more",
    "priceObjection": "",
    "wtpFactors": "Exoenses",
    "brandPerception": "New you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:34 PM UTC",
    "goals": "I'm working on losing weight and building strength",
    "priceObjection": "",
    "wtpFactors": "If it would help me get to my healthiest self faster.",
    "brandPerception": "Changing myself for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:34 PM UTC",
    "goals": "stick to a more regular exercise routine to be more fit/lose some weight",
    "priceObjection": "",
    "wtpFactors": "proven results tailored to me",
    "brandPerception": "sounds like something that is intended to alter one in hopefully beneficial ways",
    "otherBrand": "",
    "otherDevice": "generic smart watch",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "generic smart watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:36 PM UTC",
    "goals": "Maintain a healthy weight",
    "priceObjection": "",
    "wtpFactors": "Motivation, custom plan, compassionate trainer, results",
    "brandPerception": "It seems like I want to change myself instead of just improve myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1159,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 3,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:37 PM UTC",
    "goals": "I do a lot of physical work throughout the day",
    "priceObjection": "",
    "wtpFactors": "A good result",
    "brandPerception": "Make you a new oerson",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:37 PM UTC",
    "goals": "I want lean body mass. tight waistline .sorrta like stallone in Rambo 2",
    "priceObjection": "",
    "wtpFactors": "its and awesome investmeant",
    "brandPerception": "Nothing really",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1422,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 4,
      "1699": 0,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.385,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.462,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.462,
      "Recovery Sessions": 0.385,
      "Nutrition Tracking": 0.692
    },
    "gender": "Male",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Google Pixel Watch",
      "WHOOP"
    ]
  },
  {
    "date": "Feb 18, 2026 11:40 PM UTC",
    "goals": "i’d like to go up in weight on my bench and bicep curl.",
    "priceObjection": "",
    "wtpFactors": "the price, that it’s not collecting my literal DNA, and that it’s not promoting unhealthy weight loss",
    "brandPerception": "never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1292,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.133,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 28,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 11:40 PM UTC",
    "goals": "I want to be healthy and active",
    "priceObjection": "I would not purchase any of these programs.",
    "wtpFactors": "Getting the program for free.",
    "brandPerception": "Changing your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:40 PM UTC",
    "goals": "I want to manage or reverse some chronic health conditions. I also want to have healthspan for as long as I can.",
    "priceObjection": "",
    "wtpFactors": "If it provides things outside of what I'm already doing for the right price.",
    "brandPerception": "A major transformation in one's self.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 954,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.727,
      "Smart Biometrics Ring": 0.727,
      "Personalized Wellness Plan": 0.545,
      "Body Composition Analysis": 0.636,
      "Workout Sessions": 0.545,
      "Recovery Sessions": 0.727,
      "Nutrition Tracking": 0.727
    },
    "gender": "Male",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 11:41 PM UTC",
    "goals": "Exercise even more. Sleep properly. Get",
    "priceObjection": "",
    "wtpFactors": "W discount",
    "brandPerception": "Transgender transitioned",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1372,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 5,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 1,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:42 PM UTC",
    "goals": "I would like to lose 10 more pounds",
    "priceObjection": "",
    "wtpFactors": "The quality of the service.",
    "brandPerception": "Losing weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1239,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 11:42 PM UTC",
    "goals": "To be more active. Exercise. Eat better.",
    "priceObjection": "",
    "wtpFactors": "Knowing that I'm paying for a program that gives results",
    "brandPerception": "I can't tell to be honest. Maybe change me? I'm not sure.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1152,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:42 PM UTC",
    "goals": "Lose 20 lbs",
    "priceObjection": "",
    "wtpFactors": "Health problems",
    "brandPerception": "Change in positive ways",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1259,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 3,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.867,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:43 PM UTC",
    "goals": "I want to resume exercising every day for at least 10 minutes a day mainly cardio.",
    "priceObjection": "",
    "wtpFactors": "The monthly payments instead of paying in full.",
    "brandPerception": "It would be for Loing weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 649,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 11:45 PM UTC",
    "goals": "My current wellness strategy focuses on refining my nutrition by significantly reducing my intake of processed sugars and sodium to improve my overall metabolic health. I am also prioritizing hydration by increasing my daily water consumption and ensuring I remain physically active through consistent walking to maintain a caloric deficit. By making these sustainable shifts, I aim to improve my cardiovascular endurance and achieve a more balanced, energized state of being",
    "priceObjection": "",
    "wtpFactors": "The most significant factor is the proven efficacy and personalization of the plan, ensuring that the strategies for reducing sugar, salt, and increasing hydration are tailored to my specific metabolic needs. I would also prioritize programs that offer seamless integration into a daily routine, such as providing structured walking schedules or tracking tools that make calorie burning easier to monitor.",
    "brandPerception": "\"AlterMe\"suggests a concept of personal transformation, aligning with a journey to \"alter\" one's current physical state through healthier habits like reducing sugar and salt.",
    "otherBrand": "Samsung health",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.375,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.375,
      "Nutrition Tracking": 0.375
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Other",
      "Samsung health"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:45 PM UTC",
    "goals": "I am currently on a weight loss journey and hope to loose 30 pounds within the next 10 months . I’m also making a point to eat cleaner and avoid too much processed foods.",
    "priceObjection": "",
    "wtpFactors": "I’m very interested in getting the ring for tracking sleep, stress etc.  the DEXA scan would be exciting to receive and also the DNA testing.",
    "brandPerception": "It sounds like someone asking  to fix their life.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 979,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 4,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:47 PM UTC",
    "goals": "Working on losing the last 10 pounds and trying to get my cholesterol down. I walk 5-6 miles a day",
    "priceObjection": "",
    "wtpFactors": "I wouldn’t be interested in it. It’s too expensive for something I can do myself.",
    "brandPerception": "A program to change your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 11:48 PM UTC",
    "goals": "I am 57 now well maintained body and weight . I want maintain it the same way until 70 and above",
    "priceObjection": "",
    "wtpFactors": "Low interest or no interest long term",
    "brandPerception": "Phelton",
    "otherBrand": "",
    "otherDevice": "Smart watch which is only $9",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1432,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 4,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 57,
    "income": "$200,000 or more",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Smart watch which is only $9"
    ]
  },
  {
    "date": "Feb 18, 2026 11:50 PM UTC",
    "goals": "Reduce stress",
    "priceObjection": "",
    "wtpFactors": "That provides something I could not get anywhere else",
    "brandPerception": "I've never heard ot before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 992,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.357,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.786,
      "Workout Sessions": 0.357,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.357
    },
    "gender": "Female",
    "age": 33,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 18, 2026 11:53 PM UTC",
    "goals": "I want to live a long and healthy life with as being pain free as possible. I want to see my child grow.",
    "priceObjection": "",
    "wtpFactors": "A variety of different products that can expand your life span.",
    "brandPerception": "I have never heard of this brand.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1146,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.733
    },
    "gender": "Male",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:54 PM UTC",
    "goals": "Staying active and eating healthier. Maintaining a healthy weight",
    "priceObjection": "",
    "wtpFactors": "Committing with the family for a healthier lifestyle",
    "brandPerception": "A trusted brand",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1339,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:56 PM UTC",
    "goals": "Losing weight and working on my brain InVision health",
    "priceObjection": "",
    "wtpFactors": "Reviews",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1066,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:56 PM UTC",
    "goals": "I've achieved my wellness goals and currently just maintain.",
    "priceObjection": "Not at all interested in these programs",
    "wtpFactors": "No factors. I don't feel I have a need for any of these programs.",
    "brandPerception": "It sounds like someone in need of change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:57 PM UTC",
    "goals": "I have to stick with a strict diet for my well being",
    "priceObjection": "",
    "wtpFactors": "The details and pros and cons of the product wellness",
    "brandPerception": "Fit",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1019,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.2,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 18, 2026 11:58 PM UTC",
    "goals": "My personal wellness goal is to lose 70 pounds by the summer",
    "priceObjection": "",
    "wtpFactors": "To help me keep track of my weight loss",
    "brandPerception": "I'm not sure what this one is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1412,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 3,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 18, 2026 11:59 PM UTC",
    "goals": "I definitely want to lose weight to help my overall health and cholesterol, blood pressure, thyroid, and AIC levels. I would like to eat healthier and cut out more sweets and processed foods.",
    "priceObjection": "",
    "wtpFactors": "The cost would be one of the most important factors. I would want to program to be perosonalized to me as much as possible.",
    "brandPerception": "It sounds like you want to change yourself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1319,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 18, 2026 11:59 PM UTC",
    "goals": "I'm trying to be more active and get 10,000 steps daily. I also want to lift weights more often.",
    "priceObjection": "",
    "wtpFactors": "The program is effective and helps me reach my goals",
    "brandPerception": "To change something about yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:00 AM UTC",
    "goals": "Lose weight that I gained while pregnant",
    "priceObjection": "",
    "wtpFactors": "If it gave customized work outs and meal plans",
    "brandPerception": "Losing weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.583,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.417,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.417,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 29,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:03 AM UTC",
    "goals": "To live a long time, have energy, maintain my weight, and build muscle",
    "priceObjection": "",
    "wtpFactors": "The DNA testing and body composition piqued my interest most",
    "brandPerception": "A brand that could change your body composition",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1246,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 29,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:05 AM UTC",
    "goals": "I would like to lose about 25 pounds and eat less processed foods and start a strength training routine",
    "priceObjection": "",
    "wtpFactors": "The price is would need it to be less than $1000 but include comparable amen",
    "brandPerception": "I dont like it it makes me think of being unhappy with who you are and wanting to be different.  You can want to.get in better shape but still love who you are before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 946,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 0,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:05 AM UTC",
    "goals": "3 years smoke free and now I'm trying to lose weight and work on my fitness.",
    "priceObjection": "In this economy that price is crazy.",
    "wtpFactors": "If it was affordable for one and if it was something that didn't become outdated over time and have to be upgraded.",
    "brandPerception": "It's a little vain and makes one sound as if they need changing or fixin. Like a plastic surgery business.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:06 AM UTC",
    "goals": "Tone and gain muscle and be all over heal",
    "priceObjection": "",
    "wtpFactors": "Great fitness and nutrition plan",
    "brandPerception": "Not fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 0,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.625
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:06 AM UTC",
    "goals": "Eat well, move often, sleep easy and stay drug and alcohol free.",
    "priceObjection": "",
    "wtpFactors": "Condition",
    "brandPerception": "Change thy self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 1,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:06 AM UTC",
    "goals": "Nothing comes to mind",
    "priceObjection": "",
    "wtpFactors": "Nothing comes to mind",
    "brandPerception": "Nothing comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1472,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 2,
      "1699": 5,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 39,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:11 AM UTC",
    "goals": "My Goals including getting 10k steps a day and losing about 29 pounds along with getting in shape again.",
    "priceObjection": "",
    "wtpFactors": "I'd say benefits vs cost analysis. Return on investment in myself for cost. I like being to to diagnose myself and get in shape.",
    "brandPerception": "I Hear get me better now.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1330,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.692,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.692,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.615,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.462
    },
    "gender": "Male",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:11 AM UTC",
    "goals": "My current goals are mostly about how I feel and my energy levels.  I get enough sleep, drink enough water, exercise at a gym several days a week.",
    "priceObjection": "",
    "wtpFactors": "Some of these choices are fairly pricey.  I would really need to do my due diligence on these programs.  If it included everything I found helpful then I would get one.  Some of the choices are easy to manage without paying for a program.",
    "brandPerception": "What comes to mind is something that is going to change me, hopefully for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:14 AM UTC",
    "goals": "Losing weight. Better sleep",
    "priceObjection": "",
    "wtpFactors": "Benefits included that I would actually want to use.",
    "brandPerception": "Don't know not sure.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1646,
    "priceDistribution": {
      "499": 0,
      "999": 2,
      "1499": 4,
      "1699": 2,
      "1899": 7
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:14 AM UTC",
    "goals": "Lose weight and lower my cholesterol",
    "priceObjection": "",
    "wtpFactors": "Proof that it works",
    "brandPerception": "Completely change how you.look",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1306,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 5,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 12:15 AM UTC",
    "goals": "Loose 10 lbs",
    "priceObjection": "",
    "wtpFactors": "How effective it is",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 866,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:16 AM UTC",
    "goals": "Would like to lose weight and start exercising",
    "priceObjection": "",
    "wtpFactors": "I would get the best price for the things that are appealing",
    "brandPerception": "A program that transforms",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:16 AM UTC",
    "goals": "Walking 10,000 steps a day, eating healthy and drink more water",
    "priceObjection": "Too much money",
    "wtpFactors": "A very low price or My insurance is willing to pay",
    "brandPerception": "nothing comes to mind, I have never heard of",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 713,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:16 AM UTC",
    "goals": "I would like to lose a few pounds, or at least avoid gaining anymore wait. I would like to implement a new exercise regimen to tighten my abs, make me feel more energized and more mentally focused. I want to alleviate stress and worry on a daily basis and take more time to develop healthy coping strategies that entail interacting with others, physical activity and/or spiritual/emotional wellness.",
    "priceObjection": "",
    "wtpFactors": "It has to be affordable and fit into my budget. I want the best bang for my buck. It would need to be something that is beneficial to my daily wellness, not something that I can only take advantage of occasionally.",
    "brandPerception": "It involves overall improvement, mind and body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 816,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.833,
      "Recovery Sessions": 0.833,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:17 AM UTC",
    "goals": "To lose weight and get in shape.",
    "priceObjection": "",
    "wtpFactors": "The cost would have to be reasonable, and worth what is offered.",
    "brandPerception": "Nothing, I have no idea what that is.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:17 AM UTC",
    "goals": "To gain weight and be happy",
    "priceObjection": "",
    "wtpFactors": "Nothing at all",
    "brandPerception": "Changing something about it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1492,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 4,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 7,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:18 AM UTC",
    "goals": "I’m getting older so I’m thinking about my health more. I’d like to do things to prevent aging or disease.",
    "priceObjection": "",
    "wtpFactors": "If it really was beneficial",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 852,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 1,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:19 AM UTC",
    "goals": "Lose 55 pounds and to quit smoking",
    "priceObjection": "",
    "wtpFactors": "Affordable",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 946,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.267
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:19 AM UTC",
    "goals": "I have outstanding health, I am a long time vegan and live a clean healthy lifestyle. The goal is to always stay on course",
    "priceObjection": "I am not in the market for a pricey wellness program. I have no health issues and haven't been to a western doctor in over 30 years, I can teach wellness",
    "wtpFactors": "It is not something I need, I am a vegan for 40 years, zero sugar diet, notissues at all thank god.",
    "brandPerception": "I never heard of that but change  of some kind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:20 AM UTC",
    "goals": "I'm trying to eat healthier this year and as such, ive taken a break from alcohol for February. I also will intermittent fast a few times a month",
    "priceObjection": "I would not purchase",
    "wtpFactors": "I can't think of any",
    "brandPerception": "making changes to my body",
    "otherBrand": "",
    "otherDevice": "iPhone fitness tracker",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "iPhone fitness tracker"
    ]
  },
  {
    "date": "Feb 19, 2026 12:20 AM UTC",
    "goals": "I enjoy doing cardio and strength.  I use an exercise bike and rower along with kettlebells, dumbells and barbells",
    "priceObjection": "I dont want to spend 1,499 on a memership",
    "wtpFactors": "Value, experience, atmosphere quality of service",
    "brandPerception": "I have  no idea what AlterMe is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:20 AM UTC",
    "goals": "stay alive",
    "priceObjection": "",
    "wtpFactors": "reviews for effectiveness\ncost\nwhat is included",
    "brandPerception": "What is AlterMe?  It sounds like a plastic surgeon.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1029,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 0,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.7,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.8
    },
    "gender": "Male",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:20 AM UTC",
    "goals": "i am activly working out and i eat clean",
    "priceObjection": "i would not pay that",
    "wtpFactors": "this is all too expensive for me",
    "brandPerception": "i have no idea what this is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.833,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:20 AM UTC",
    "goals": "Want to loose weight.",
    "priceObjection": "",
    "wtpFactors": "The cost.",
    "brandPerception": "Change.",
    "otherBrand": "",
    "otherDevice": "Max go.",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Max go."
    ]
  },
  {
    "date": "Feb 19, 2026 12:21 AM UTC",
    "goals": "Maintain my healthy weight eat healthy and exercise",
    "priceObjection": "",
    "wtpFactors": "None at all",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 892,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:21 AM UTC",
    "goals": "I am working to maintain a consistent exercise routine that includes regular cardiovascular activity, strength training, and daily movement to support heart health, blood sugar control, and overall well-being. Those are my goals.",
    "priceObjection": "",
    "wtpFactors": "How effective with evidence, it is, whether it’s tailored to my personal health goals (like heart disease and diabetes prevention), and cost.",
    "brandPerception": "Change my body for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:22 AM UTC",
    "goals": "My personal health and wellness goals at this time are to loose weight and lower my blood pressure.",
    "priceObjection": "",
    "wtpFactors": "The price and the features that will meet my need like nutrition and exercise.",
    "brandPerception": "That means get me where I need to be.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1228,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:22 AM UTC",
    "goals": "Remain the health in the time of the inflation and unemployment.",
    "priceObjection": "",
    "wtpFactors": "In the bad time, the health is most important for me.",
    "brandPerception": "AlterMe uses a smart ring to take the DNA testing.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 785,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.357,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.357,
      "Recovery Sessions": 0.357,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 37,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "WHOOP"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 12:22 AM UTC",
    "goals": "Get my stomach issues under control along with gaining weight and muscle.",
    "priceObjection": "",
    "wtpFactors": "Security of my data. Many options for workouts and recovery sessions so I can pick what I need and increase the intensity as needed.",
    "brandPerception": "Before this survey, I would think it is some sort of prosthetic company, but now it seems like improving oneself through strength training.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1161,
    "priceDistribution": {
      "499": 2,
      "999": 6,
      "1499": 3,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.615,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.385,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.615,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.615
    },
    "gender": "Male",
    "age": 45,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:23 AM UTC",
    "goals": "I want to gain more muscle.I want to get more energy.",
    "priceObjection": "This is way to much for me",
    "wtpFactors": "Having really good reviews",
    "brandPerception": "Getting in better shape",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:24 AM UTC",
    "goals": "I need to lose weight and increase my flexibility",
    "priceObjection": "That is too expensive given other options available",
    "wtpFactors": "If it was reasonably priced and provided some guidance on health plans",
    "brandPerception": "That maybe it’s more mindfulness driven wellness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:24 AM UTC",
    "goals": "My is to eat right exercise",
    "priceObjection": "",
    "wtpFactors": "Good price for program what offer for the service that can happen me",
    "brandPerception": "A good product that me with my fitness routine",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1286,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:25 AM UTC",
    "goals": "Get off some medications that have some bad side effects, strt exercissing and get in shape",
    "priceObjection": "",
    "wtpFactors": "My need to get into better shape, a workout program, and a way of tracking progress.",
    "brandPerception": "nothing, maybe to change a person",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:25 AM UTC",
    "goals": "I plan together back fit. I gained a few pounds but I plan on pushing back on the junk food and start increasing Whole Foods and exercising a few minutes a day.",
    "priceObjection": "",
    "wtpFactors": "Getting deals like having points add up after completing a work out and the points be for getting 10% or 20% off on a healthy snack like protein bar.",
    "brandPerception": "I dont know what that is but sound scary.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1452,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 3,
      "1699": 2,
      "1899": 6
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.067,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 28,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Student",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:26 AM UTC",
    "goals": "I would like  to get in a little bit better shape and lose some more weight",
    "priceObjection": "",
    "wtpFactors": "If it give me all the data I need it in a very comprehensive plan That was well-thought-out.",
    "brandPerception": "DNA testing that is personalized to your needs and is helpful for your health goals.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 46,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:26 AM UTC",
    "goals": "Continue to lose weight, lower A1C, lower blood pressure, improve flexiblity for better sex with my wife., Imporive cardio for the same reason. I need to have a good 30 to 40m minutes of breating stamina. Improve diet",
    "priceObjection": "To expemsive, i would never spend that much",
    "wtpFactors": "DNA, and body compasition, sleep tracking, niometric tracking",
    "brandPerception": "A sytem that alerts me to needed action helthwidse",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 52,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:26 AM UTC",
    "goals": "I would like to maintain my weight and increase my physical strength. I’d like to work out twice per week and walk everyday.",
    "priceObjection": "I would not pay that much for what I could mostly find on the internet.",
    "wtpFactors": "It would have to be affordable and add value beyond what I could craft using AI. I’m not impressed with the price options in this study.",
    "brandPerception": "It sounds like plastic surgery.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.143,
      "Smart Biometrics Ring": 0.857,
      "Personalized Wellness Plan": 0.286,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.714
    },
    "gender": "Male",
    "age": 36,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:27 AM UTC",
    "goals": "Lose 15 lbs",
    "priceObjection": "",
    "wtpFactors": "I don’t have any debt",
    "brandPerception": "Easy",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Ladder",
      "Fitbit",
      "AlterMe"
    ],
    "wearableDevices": [
      "Fitbit",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 12:27 AM UTC",
    "goals": "I am trying to keep my blood pressure down and lose some weight. I am watching the amount of sodium I intake.",
    "priceObjection": "",
    "wtpFactors": "I would need to be sold on features or services that I am unable to accomplish on my own without joining a wellness program.",
    "brandPerception": "I have never heard of AlterMe. Sounds like a fitness program.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 699,
    "priceDistribution": {
      "499": 7,
      "999": 2,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.3,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.7,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:28 AM UTC",
    "goals": "I need to lose weight . I’m pre-diabetic from my results and have skin cancer",
    "priceObjection": "",
    "wtpFactors": "The overall consistency of man and nutritional tracking",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1368,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.615,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.385,
      "Body Composition Analysis": 0.615,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.538
    },
    "gender": "Female",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:30 AM UTC",
    "goals": "My current personal health goals really need to fit me very well right now.",
    "priceObjection": "",
    "wtpFactors": "I really need to trust the brand and product before moving on.",
    "brandPerception": "Help me change my diet and health wellness.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1232,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 4,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:30 AM UTC",
    "goals": "My current personal health goals is to exercise on a regular basis, to drink water consistently throughout the day. I also have a goal of maintaining my current weight of 115 lbs. I don't want to lose or gain weight, only to maintain my weight. I want to eat less processed foods and more plant based foods as well",
    "priceObjection": "",
    "wtpFactors": "Health is very important to me. What would most influence my willingness to pay for health and wellness program is the motivation to feel good on a consistent basis. Without good health I'm not able to work or pretty much do anything conducive to maintaining my lifestyle, so that would be my biggest motivator",
    "brandPerception": "It sounds like something that can help you change your lifestyle. Something that can help with making changes in your lifestyle for the betterment of your wellness. It sounds to me like a program that helps to encourage change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.833,
      "Smart Biometrics Ring": 0.167,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:31 AM UTC",
    "goals": "To have great younger looking skin",
    "priceObjection": "",
    "wtpFactors": "The benefits seeing before and afters",
    "brandPerception": "Better skin",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 892,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 12:31 AM UTC",
    "goals": "My current health goal in to include more raw vegetables in my diet and walk more.",
    "priceObjection": "",
    "wtpFactors": "An effective program that gives results",
    "brandPerception": "Change me into a healthier person",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1106,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 4,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:31 AM UTC",
    "goals": "Goals include loosing weight. A goal is to increase my strength. Another goal is to incorporate a fitness routine in my daily routine",
    "priceObjection": "",
    "wtpFactors": "Access on my schedule, professional assistance and accessible resources for those with disabilities",
    "brandPerception": "No idea",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1432,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 1,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.583,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:33 AM UTC",
    "goals": "Drink more water.  Lose 6 more lbs and maintain",
    "priceObjection": "",
    "wtpFactors": "If it was a good value.",
    "brandPerception": "Alter me for the better with a fitness routine",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 687,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:33 AM UTC",
    "goals": "To lose weight and eat healthier",
    "priceObjection": "",
    "wtpFactors": "The quality of the program and results from clients",
    "brandPerception": "Weight loss",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1170,
    "priceDistribution": {
      "499": 3,
      "999": 6,
      "1499": 0,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:34 AM UTC",
    "goals": "I need to lose 30 pounds. I need to keep my blood sugar low",
    "priceObjection": "",
    "wtpFactors": "Having the ability to track everything in one place",
    "brandPerception": "Fixing my body",
    "otherBrand": "",
    "otherDevice": "Samsung Health",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 826,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 2,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Samsung Health"
    ]
  },
  {
    "date": "Feb 19, 2026 12:38 AM UTC",
    "goals": "I want to be able to maintain.y current weight and to prevent future health issues from ever happ",
    "priceObjection": "",
    "wtpFactors": "The quality of the program. Regardless of cost, you want to feel like you are getting your money's worth. You want to get what you are pa",
    "brandPerception": "It is changing yourself for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 884,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.615,
      "Smart Biometrics Ring": 0.385,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.769,
      "Workout Sessions": 0.692,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.846
    },
    "gender": "Male",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:39 AM UTC",
    "goals": "I want to get more in shape since hitting menopause.  I want health goals that are realistic for me. I am also trying to eat more healthy.",
    "priceObjection": "",
    "wtpFactors": "I like all the factors included and looks like a complete program.",
    "brandPerception": "I think of maintaining and changing the body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:39 AM UTC",
    "goals": "To lose 10 lbs, exercise more, and stop va",
    "priceObjection": "",
    "wtpFactors": "To get more fit and have it more personalized",
    "brandPerception": "Make someone more fit",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 956,
    "priceDistribution": {
      "499": 5,
      "999": 6,
      "1499": 2,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.643,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.786
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:39 AM UTC",
    "goals": "To lose wieight and eat healthy",
    "priceObjection": "",
    "wtpFactors": "The factors are that I want to live a long life and a healthy lifestyle",
    "brandPerception": "I think of a alter me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:39 AM UTC",
    "goals": "Honestly I'm just trying to tone up I've lost the weight",
    "priceObjection": "",
    "wtpFactors": "Nothing at this time",
    "brandPerception": "Nothing at this time",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1572,
    "priceDistribution": {
      "499": 0,
      "999": 3,
      "1499": 3,
      "1699": 5,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:40 AM UTC",
    "goals": "I like it more",
    "priceObjection": "",
    "wtpFactors": "I like the video",
    "brandPerception": "I love it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1319,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 12:40 AM UTC",
    "goals": "To stay healthy and exercise. I try to exercise daily and get over 10,000 steps a day. I tried to drink plenty of water and sleep.",
    "priceObjection": "",
    "wtpFactors": "Do you have a personal trainer. I don’t like to pay for my exercise. I have a treadmill at home in free weights and use that and I use my step aerobics DVDs.",
    "brandPerception": "I have no idea what that means. I’ve never heard it before.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 9,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:41 AM UTC",
    "goals": "I would like to lose some weight",
    "priceObjection": "",
    "wtpFactors": "That it will work fast",
    "brandPerception": "Healthy living",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1386,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:41 AM UTC",
    "goals": "To lose weight and gain muscle. Need to make changes to stabilize blood pressure and prevent other ailments.",
    "priceObjection": "Too expensive",
    "wtpFactors": "Features and reasonable price",
    "brandPerception": "Nothing; never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.778,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.444,
      "Body Composition Analysis": 0.778,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:41 AM UTC",
    "goals": "I WANNA LOSE AT LEAST 10 POUNDS AND BUILD MORE MUSCLE MASS",
    "priceObjection": "",
    "wtpFactors": "WILL IT FIT WITHIN MY BUDGET AND WHAT ARE THE PERKS AND ADVANTAGES CAN I RECEAVE",
    "brandPerception": "RESHAPING A PERSONS BODY MASS AND WEIGHT TO FIT THEIR BODY WEIGHT",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1386,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 2,
      "1699": 7,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tonal",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:43 AM UTC",
    "goals": "I want to exercise at least an hour a day to be more toned.",
    "priceObjection": "",
    "wtpFactors": "I would want DEXA scans and a workout plan definitely included. Anything else is nice to have, but those are non-negotiables.",
    "brandPerception": "Makes me think of plastic surgery.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:43 AM UTC",
    "goals": "I want to get my health issues improved",
    "priceObjection": "I wouldn't use this",
    "wtpFactors": "Nothing, not willing to pay",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:44 AM UTC",
    "goals": "I am actually currently 26 weeks pregnant, so not as active as I normally am but I still go on walks daily. I was a college athlete before kids and am excited to get back into shape after giving birth.",
    "priceObjection": "I have been active and healthy for a very long time. I know what works for me and don’t really need to purchase anything for extra help.",
    "wtpFactors": "I would consider purchasing for a friend or family member that might need help, but wouldn’t need for myself.",
    "brandPerception": "A program to help alter your health.",
    "otherBrand": "I use a Fitbit to track my workouts.",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Other",
      "I use a Fitbit to track my workouts."
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:45 AM UTC",
    "goals": "I’m in good health but want to be at peak health and feel great.",
    "priceObjection": "No way I’m paying that much.",
    "wtpFactors": "Price, period. It’s not rocket science and most of this can be done with pen and paper and a mild understanding of your body. Hard pass on anything over $200",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:45 AM UTC",
    "goals": "I want to do what I can to preserve my health. I don't want to get fat.",
    "priceObjection": "",
    "wtpFactors": "The perceived benefits",
    "brandPerception": "Nothing really",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:46 AM UTC",
    "goals": "To try to lose some weight",
    "priceObjection": "They're too expensive",
    "wtpFactors": "Cheaper prices",
    "brandPerception": "To make big changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:46 AM UTC",
    "goals": "I want to lose weight and be healthy",
    "priceObjection": "",
    "wtpFactors": "Needing to get healthy",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 1,
      "1699": 6,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:46 AM UTC",
    "goals": "I want to increase my strength and lose weight",
    "priceObjection": "way too expensive",
    "wtpFactors": "if I knew it would help",
    "brandPerception": "nothing in particular",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:47 AM UTC",
    "goals": "To lose 40lb by the end of the year. To get my hormones under control.",
    "priceObjection": "",
    "wtpFactors": "Seeing real reviews. If the workout look interesting and fun. Are the workouts something I can safely do",
    "brandPerception": "Changing something",
    "otherBrand": "",
    "otherDevice": "Generic watch tracker",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.643,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch",
      "Other smart ring or fitness tracker",
      "Generic watch tracker"
    ]
  },
  {
    "date": "Feb 19, 2026 12:48 AM UTC",
    "goals": "I work like to lose 30 pounds and gain muscle and work out more often",
    "priceObjection": "",
    "wtpFactors": "Workout in recovery included in payment plans with no interest",
    "brandPerception": "Change your self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 624,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.25,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:49 AM UTC",
    "goals": "I would like to maintain my current weight",
    "priceObjection": "",
    "wtpFactors": "If it helped me reach my goals",
    "brandPerception": "A program that helps you lose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1306,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "WHOOP",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:49 AM UTC",
    "goals": "I exercise daily, trying to lose weight, get lean, and grow muscles and strength.",
    "priceObjection": "",
    "wtpFactors": "The price and how often needs to be paid.",
    "brandPerception": "Sounds like a tracking program for weight loss.",
    "otherBrand": "",
    "otherDevice": "Google fit / Weward",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.462,
      "Smart Biometrics Ring": 0.769,
      "Personalized Wellness Plan": 0.692,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.615,
      "Recovery Sessions": 0.692,
      "Nutrition Tracking": 0.692
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit",
      "Other smart ring or fitness tracker",
      "Google fit / Weward"
    ]
  },
  {
    "date": "Feb 19, 2026 12:49 AM UTC",
    "goals": "My wellness goal is to exercise consistently. I also plan to change my diet as well.",
    "priceObjection": "I wouldn't want to pay for something I can do at home.",
    "wtpFactors": "None",
    "brandPerception": "Giving a reminder.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:50 AM UTC",
    "goals": "I hope to lose a few pounds",
    "priceObjection": "",
    "wtpFactors": "If there are proven results",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.643,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.357,
      "Nutrition Tracking": 0.786
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:50 AM UTC",
    "goals": "to lose some weight",
    "priceObjection": "",
    "wtpFactors": "rewards would help or promos",
    "brandPerception": "get info all the time on your phone",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1439,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 2,
      "1699": 5,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.2,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "WHOOP"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:50 AM UTC",
    "goals": "Eat healthier and exercise more often.",
    "priceObjection": "",
    "wtpFactors": "Its effectiveness and my need",
    "brandPerception": "Personalized programs",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1030,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.308,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.769,
      "Body Composition Analysis": 0.231,
      "Workout Sessions": 0.692,
      "Recovery Sessions": 0.615,
      "Nutrition Tracking": 0.615
    },
    "gender": "Male",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:51 AM UTC",
    "goals": "To lose weight and get in bette shape physically and mentally",
    "priceObjection": "",
    "wtpFactors": "If it was priced fairly",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 5,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:51 AM UTC",
    "goals": "Lose weight and build a strong immune system",
    "priceObjection": "",
    "wtpFactors": "The price",
    "brandPerception": "They give you a whole different body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:52 AM UTC",
    "goals": "To eat drink workout to stay healthy",
    "priceObjection": "",
    "wtpFactors": "Qualityvreat results",
    "brandPerception": "Great end results",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 1,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:53 AM UTC",
    "goals": "I eat a well balanced healthy diet. I exercise 5 days a week. I take vitamins regularly.",
    "priceObjection": "",
    "wtpFactors": "I would like to know my body better and learn things the right way.",
    "brandPerception": "DNA Testing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1426,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:54 AM UTC",
    "goals": "To walk at least 30 minutes a day and lose some weight",
    "priceObjection": "I have no interest in this type of service",
    "wtpFactors": "I still would not be interested in something like this",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "Something I bought off of Amazon, but I don’t remember the name",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 1899,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Something I bought off of Amazon, but I don’t remember the name"
    ]
  },
  {
    "date": "Feb 19, 2026 12:54 AM UTC",
    "goals": "Maintain weight, sleep better",
    "priceObjection": "",
    "wtpFactors": "Price, included features",
    "brandPerception": "Haven't heard of this brand me, seems positive - like a change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 6,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.267,
      "Nutrition Tracking": 0.867
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:55 AM UTC",
    "goals": "I'm trying to be consistent with exercising.",
    "priceObjection": "",
    "wtpFactors": "I would need to have a benefit that I don't have right now. I can get most of these benefits through other means (and for a much cheaper cost).",
    "brandPerception": "I've never heard of this brand or company.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 835,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.364,
      "Smart Biometrics Ring": 0.727,
      "Personalized Wellness Plan": 0.727,
      "Body Composition Analysis": 0.455,
      "Workout Sessions": 0.182,
      "Recovery Sessions": 0.364,
      "Nutrition Tracking": 0.636
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:55 AM UTC",
    "goals": "I am in good condition.",
    "priceObjection": "",
    "wtpFactors": "If it made sure that I actually did the program.",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 972,
    "priceDistribution": {
      "499": 5,
      "999": 7,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.133
    },
    "gender": "Female",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:55 AM UTC",
    "goals": "Not to good I'm low iron",
    "priceObjection": "",
    "wtpFactors": "Nothing",
    "brandPerception": "Thrj. Kfjrnr. Alter prayer",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 4,
      "999": 6,
      "1499": 1,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "WHOOP",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:58 AM UTC",
    "goals": "I want to build muscle mass and improve my mental health",
    "priceObjection": "Too expensive for me",
    "wtpFactors": "If I won the lottery",
    "brandPerception": "Some weird sci-fi movie rental from the 80s",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:58 AM UTC",
    "goals": "My current personal health and Wellness goal is to be less stressed and get better sleep.",
    "priceObjection": "",
    "wtpFactors": "I would have speak directly with someone who has used it to find out exactly how it works and if it is effective.",
    "brandPerception": "That sounds creepy, it reminds me I guess turning into a robot person or something like the Terminator.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:58 AM UTC",
    "goals": "Remain healthy through movement",
    "priceObjection": "",
    "wtpFactors": "Multiple ways to pay and or finance to affordable payments",
    "brandPerception": "Change yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 707,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.583,
      "Workout Sessions": 0.583,
      "Recovery Sessions": 0.583,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:59 AM UTC",
    "goals": "To gain muscle, stay active, keep weight the same.",
    "priceObjection": "",
    "wtpFactors": "Good reviews. What they offer.",
    "brandPerception": "I don’t like the sounds of it. I’ve never heard of this brand.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.444,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.444,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.889,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:01 AM UTC",
    "goals": "Eating better",
    "priceObjection": "I would never pay for anything like this",
    "wtpFactors": "I never would",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:02 AM UTC",
    "goals": "I would like to build muscle.",
    "priceObjection": "",
    "wtpFactors": "The things it provides",
    "brandPerception": "I have never heard of this, but I'm guessing it alters you to be better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1537,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 5,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.692,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.692,
      "Body Composition Analysis": 0.846,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.615,
      "Nutrition Tracking": 0.923
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:03 AM UTC",
    "goals": "Lose weight, stay in shape the best I can with a challenging schedule",
    "priceObjection": "Way too expensive for me personally.",
    "wtpFactors": "Sadly I would not pay for i",
    "brandPerception": "Nothin",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:03 AM UTC",
    "goals": "I need to lower my cortisol and sugar intake.",
    "priceObjection": "Still high.",
    "wtpFactors": "Price.",
    "brandPerception": "Change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.714,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.143,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:05 AM UTC",
    "goals": "Lose weight, get fit and kick my sugar and soda addiction",
    "priceObjection": "",
    "wtpFactors": "Price and what options are included with the program to make it work the money",
    "brandPerception": "Change who you are",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 624,
    "priceDistribution": {
      "499": 6,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.625
    },
    "gender": "Female",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:06 AM UTC",
    "goals": "My goal is Sue. Get all of my vitamins and hell. At optimal letters",
    "priceObjection": "I don't need to pay for a program.",
    "wtpFactors": "I probably wouldn't to be honest",
    "brandPerception": "I'm not sure. Maybe an app that monitors your nutrition",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:07 AM UTC",
    "goals": "Increase my endurance and muscle\nDecrease my body fat by about 10%\nGet 7-8",
    "priceObjection": "",
    "wtpFactors": "It would have to be one meant for how my lifestyle is currently. If it takes too much time and I need to track too much, then I know it would be too overwhelming and I wouldn't stick with it. It would need to be simple, have the most important features/track most important aspects to me",
    "brandPerception": "I think of someone that wants to change some things about themselves for the better. This could be their nutrition, fitness level, sleep, and/",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1057,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 1,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.583,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.583,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 39,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 1:08 AM UTC",
    "goals": "Im current trying to lose weight and eat healthier",
    "priceObjection": "",
    "wtpFactors": "Not sure",
    "brandPerception": "An app for physical health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 1,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:10 AM UTC",
    "goals": "I like to exercise to feel motivated",
    "priceObjection": "",
    "wtpFactors": "I need to stay in shape",
    "brandPerception": "This is a nice Worthy site",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1666,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 4,
      "1699": 5,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:10 AM UTC",
    "goals": "Lose weight, stay alive",
    "priceObjection": "Is this a yearly fee or total for 3 yrs, this isnt clear. What are the full terms?",
    "wtpFactors": "Terms and conditions. Cost per yr, per month and I definitely wouldnt pay interest on payment terms. Also could this be paid by insurance",
    "brandPerception": "Don't like it. Seems robotic and like a person is broken in some way. Sci-fi ish",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:11 AM UTC",
    "goals": "To be able to run a 5K in April under 35 minutes.\nTo eliminate processed foods \nDrink at least 64 oz of water a day",
    "priceObjection": "That is out of my budget range",
    "wtpFactors": "Anything under 500",
    "brandPerception": "I have never heard of it at all",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.375,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:11 AM UTC",
    "goals": "to lose weight and have more energy",
    "priceObjection": "",
    "wtpFactors": "knowing they work and are worth the money",
    "brandPerception": "make your self better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 610,
    "priceDistribution": {
      "499": 7,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.778,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.778,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.556
    },
    "gender": "Female",
    "age": 52,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:11 AM UTC",
    "goals": "I strive to exercise three to four days of week with a concentration of strength training at least 2 times a week.  I try to eat well and healthy 80% of the time and splurge on a sweet treat 5 times a week.  I would like to either maintain or lose up to 3 pounds over all",
    "priceObjection": "",
    "wtpFactors": "It has to be a lifetime program that includes an ongoing body composition system.",
    "brandPerception": "A life changing better version of myself  but maybe in a negative way.  Not sure I like the sound of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.167,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tonal",
      "Ladder",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:11 AM UTC",
    "goals": "Maintain a healthy body weight and possibly lose a little bit in the process",
    "priceObjection": "",
    "wtpFactors": "Make sure they maintain a consistent quality throughout the program",
    "brandPerception": "Nutritional supplements and dietary regiment",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1119,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:11 AM UTC",
    "goals": "Lose weight and get healthier overall",
    "priceObjection": "",
    "wtpFactors": "Price and effectiveness",
    "brandPerception": "I don’t know it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1212,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:12 AM UTC",
    "goals": "My goal is to exercise and lose weight.  This will help me to control my hypertension",
    "priceObjection": "",
    "wtpFactors": "A personalized plan that will help me meet my goals the quickest",
    "brandPerception": "A body changing regime",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:14 AM UTC",
    "goals": "I just want to simply lose about 25 pounds and try to stay as healthy as possible",
    "priceObjection": "",
    "wtpFactors": "Personal attention. Personalized plans",
    "brandPerception": "Don’t know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1432,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 3,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Never",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:16 AM UTC",
    "goals": "Lose a little weight and get more fit",
    "priceObjection": "",
    "wtpFactors": "If it has the right things",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1179,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.7,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tonal",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:16 AM UTC",
    "goals": "I want to eat healthier. I feel like I'm not eating enough fruits and vegetables and that is something that I really think that I need to be doing. I am trying to get back to a decent weight and by changing my health habits it will help me to improve my health. I don't have bad health but I just want to be better overall.",
    "priceObjection": "",
    "wtpFactors": "Just knowing that I'm able to get my health taken care of and that I will have a program that is specifically geared towards me",
    "brandPerception": "When I hear alter me I think about changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1432,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.867,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:17 AM UTC",
    "goals": "Lose weight. Improve cholesterol and triglycerides. Improve sleep. Reduce stress.",
    "priceObjection": "",
    "wtpFactors": "Affordability. Effectiveness. Ease of use.",
    "brandPerception": "Sounds like like science fiction or something creepy and controlling.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:17 AM UTC",
    "goals": "Loose weight",
    "priceObjection": "",
    "wtpFactors": "Proven results",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1019,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 1,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.867,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:18 AM UTC",
    "goals": "My personal health or wellness goals is to keep fit and healthy",
    "priceObjection": "",
    "wtpFactors": "the effectiveness for a  health and wellness program review",
    "brandPerception": "premium fitness system",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1606,
    "priceDistribution": {
      "499": 0,
      "999": 2,
      "1499": 4,
      "1699": 5,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 56,
    "income": "$200,000 or more",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:19 AM UTC",
    "goals": "I want to start eating healthier, excercising more and losing weight.",
    "priceObjection": "",
    "wtpFactors": "An affordable one, especially in today’s economy! I can’t afford over $10-15 a month",
    "brandPerception": "Alter my appearance and health.",
    "otherBrand": "",
    "otherDevice": "My online apps for walking.",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "My online apps for walking."
    ]
  },
  {
    "date": "Feb 19, 2026 1:19 AM UTC",
    "goals": "To lose a little bit of weight to get rid of my belly.",
    "priceObjection": "",
    "wtpFactors": "To have a reason.",
    "brandPerception": "To make a change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1306,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:20 AM UTC",
    "goals": "To look and feel better",
    "priceObjection": "",
    "wtpFactors": "Truly beneficial and effective",
    "brandPerception": "Change is what comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:21 AM UTC",
    "goals": "I am working towards running 10 miles for days a week. As well, I am working to strengthen my major muscle groups thru isometrics.",
    "priceObjection": "",
    "wtpFactors": "The completeness of the program without any extra fluff.  Having a workout and recovery program with some general fitness tracking is all I need.",
    "brandPerception": "I assume it is a fitness program",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1029,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 1,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.7,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:22 AM UTC",
    "goals": "Lose some belly fat",
    "priceObjection": "I’m not paying that much",
    "wtpFactors": "Needs to be a reasonable price",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:27 AM UTC",
    "goals": "To lose 13 lbs",
    "priceObjection": "",
    "wtpFactors": "I wouldn’t pay unless eligible by hsa",
    "brandPerception": "An app",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 34,
    "income": "$200,000 or more",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:29 AM UTC",
    "goals": "To keep my health as good as possible, stay rested and manage issues.",
    "priceObjection": "I wouldn't purchase this.",
    "wtpFactors": "Proven results, easy to follow, low price.",
    "brandPerception": "Something to change a part of yourself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:30 AM UTC",
    "goals": "Eat right and walk.",
    "priceObjection": "I can get this for free.",
    "wtpFactors": "None",
    "brandPerception": "Nothing to be honest.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 57,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:34 AM UTC",
    "goals": "I am actively trying to lose weight and just started using the ne GLP meds out there.",
    "priceObjection": "I would not spend that much.",
    "wtpFactors": "A crucial need for it.",
    "brandPerception": "Nothing.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 570,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.857,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:35 AM UTC",
    "goals": "i'm trying to eat right and exercise everyday to stay healthy and most importantly, go to bed before 11 pm",
    "priceObjection": "",
    "wtpFactors": "not that i can think of, i don't think i will ever pay for a wellness program",
    "brandPerception": "not that i'm aware of",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:36 AM UTC",
    "goals": "I want to both lose weight and get more exercise on a daily basis so I can live a fuller, healthier life.",
    "priceObjection": "",
    "wtpFactors": "If I could find one that was really tailored to my specific situation and needs, and had a clear outline on what I needed to do daily like exercising and working out in order to really be at my best in terms of overall health.",
    "brandPerception": "A system that helps you be at your peak health through a combination of smart health and fitness planning.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 972,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 1,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.733
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Google Pixel Watch",
      "Garmin",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:36 AM UTC",
    "goals": "Be as healthy as possible and age gracefully while still enjoying life.",
    "priceObjection": "Unnecessary and too expensive for this economy and real world. You don’t need to pay that to be healthy. Seems like a giant scam",
    "wtpFactors": "If I had a problem I couldn’t handle myself.",
    "brandPerception": "I’ve never heard of that.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:37 AM UTC",
    "goals": "My personal health is getting better. I'm watching what I eat and I exercise  and get plenty of rest.",
    "priceObjection": "",
    "wtpFactors": "If there was an Ai model and that it can communicate to the user.",
    "brandPerception": "Body sculpting comes to mind when I think of AlterMe.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1256,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.786,
      "Personalized Wellness Plan": 0.643,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:38 AM UTC",
    "goals": "My personal goals are to start tracking my calories so I can lose some weight.  I am also going to increase my daily movement so I can work on my cardiovascular health and increase my muscle mass.",
    "priceObjection": "",
    "wtpFactors": "I need to feel that the program is worth the money. I need to feel as though I will get a lot out of the program and that it will work for me.",
    "brandPerception": "I think of changing my body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1079,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:39 AM UTC",
    "goals": "My current goals is to avoid beverages with added sugar and sweeteners also.Trying to eat daily fruits and vegetables and avoid cold futs and nitrates.I also want to be active and walk 15-20000 steps daily.",
    "priceObjection": "",
    "wtpFactors": "We only live for so long.Paying for something that keeps me healthy for longer to enjoy life more os definately worth it.",
    "brandPerception": "Someone that is not me.my other self.a different person.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:39 AM UTC",
    "goals": "I plan to lose weight",
    "priceObjection": "",
    "wtpFactors": "Good reviews",
    "brandPerception": "I'm not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 812,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 40,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:41 AM UTC",
    "goals": "Would like to lose some weight. I want to eat healthier. I want to get my pain under control.",
    "priceObjection": "",
    "wtpFactors": "If I was told is really needed to do it by a health provider",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:42 AM UTC",
    "goals": "I want to build muscle and stay as fit as possible as I get older",
    "priceObjection": "",
    "wtpFactors": "How well it will work with my daily routine",
    "brandPerception": "Changing something",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1006,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:44 AM UTC",
    "goals": "I take hormonal supplements and eat as healthy as I can.  I also stand all day for work.",
    "priceObjection": "",
    "wtpFactors": "Personal sessions and biometric tracking ring along with fair lower cost",
    "brandPerception": "Nothing in particular",
    "otherBrand": "My fitness pal",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 866,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Other",
      "My fitness pal"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:44 AM UTC",
    "goals": "Be active and eat healthy",
    "priceObjection": "",
    "wtpFactors": "To maintain my discipline",
    "brandPerception": "Change my health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1212,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 56,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:46 AM UTC",
    "goals": "to lose twenty pounds and build strength.",
    "priceObjection": "",
    "wtpFactors": "The cost and the results and reviews from people who have used it.",
    "brandPerception": "Like a makeover",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:46 AM UTC",
    "goals": "I would like to lose weight and focus on a healthier diet",
    "priceObjection": "",
    "wtpFactors": "price and the perceived effectiveness",
    "brandPerception": "I have no idea, maybe change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:46 AM UTC",
    "goals": "Get healthy,  regular exercise, balanced healthy meals",
    "priceObjection": "",
    "wtpFactors": "Results",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Never",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:47 AM UTC",
    "goals": "i'm trying to exercise regularly",
    "priceObjection": "",
    "wtpFactors": "better pricing",
    "brandPerception": "It means to change yourself for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 861,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.538,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.692,
      "Workout Sessions": 0.769,
      "Recovery Sessions": 0.231,
      "Nutrition Tracking": 0.615
    },
    "gender": "Male",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 1:48 AM UTC",
    "goals": "My health and wellness goals, is to get physically healthy and lose weight",
    "priceObjection": "",
    "wtpFactors": "It helps me get healthier",
    "brandPerception": "Change you physically",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1366,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:49 AM UTC",
    "goals": "Gain mass",
    "priceObjection": "",
    "wtpFactors": "Cost",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.714
    },
    "gender": "Male",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:49 AM UTC",
    "goals": "I eat well and limit processed items from our daily meals and get enough sleep and exercise to manage daily stress.",
    "priceObjection": "not paying a cent for this garbage when I can find it free online",
    "wtpFactors": "if it's free",
    "brandPerception": "no clue never heard of it before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:51 AM UTC",
    "goals": "My current health and wellbeing goals are to eat more healthy. I would also like to loose fifteen pounds.",
    "priceObjection": "",
    "wtpFactors": "The factors that would influence me to purchase this would be for my health",
    "brandPerception": "Nothing comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1163,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.643,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.786,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:52 AM UTC",
    "goals": "I am working on losing weight by healthy eating and exercising",
    "priceObjection": "",
    "wtpFactors": "The effectiveness of the program. If it includes both nutrition and workouts . The overall cost is also important",
    "brandPerception": "A program that will help me achieve a better version of myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:52 AM UTC",
    "goals": "I exercise 5 times a week and I try to eat healthy and balanced meals.",
    "priceObjection": "",
    "wtpFactors": "Pay in full and receive 32% off",
    "brandPerception": "I think of a total body transformation.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1252,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:54 AM UTC",
    "goals": "i want to increase my strength in my arms and legs and pretty much everywhere, so i can decrease the chance of injury",
    "priceObjection": "",
    "wtpFactors": "it needs to be gentle - i'm not an athletic type i'm just trying to be healthy",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.25,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.25
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:55 AM UTC",
    "goals": "To lose weight and tone",
    "priceObjection": "",
    "wtpFactors": "A pay I. Four plan",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1392,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 1:56 AM UTC",
    "goals": "I want to increase my overall fitness and flexibility while trying to lose a few pounds in the process",
    "priceObjection": "",
    "wtpFactors": "Those prices were pretty high, but if I can pay with no interest that makes it easier",
    "brandPerception": "Making changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 44,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:57 AM UTC",
    "goals": "I want get in shape and slim down",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "Fix me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 713,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:58 AM UTC",
    "goals": "Stay lean and fit as i age.",
    "priceObjection": "",
    "wtpFactors": "Quality, product reviews and testimonials from users",
    "brandPerception": "Not familiar with this brand.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1166,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 4,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:59 AM UTC",
    "goals": "To lose weight and become more physically fit with diet and exercise",
    "priceObjection": "",
    "wtpFactors": "If i felt it would keep me in check with taking care of myself",
    "brandPerception": "Changing you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 49,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:59 AM UTC",
    "goals": "Start running, lose 5-10 pounds",
    "priceObjection": "",
    "wtpFactors": "I don’t want to pay anything for a program.  I would rather just join a cheap gym or go running outside.",
    "brandPerception": "It sounds like some weird dating site or something",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:00 AM UTC",
    "goals": "My goal is to lose 15lbs. I have started adding my cardio to my workouts. I also take vitamins and choose healthier meals.",
    "priceObjection": "",
    "wtpFactors": "I like knowing that as I use the wellness program it adapts to my body changes while using the wellness program.",
    "brandPerception": "Changing my appearance comes to mind. I new mindset and new body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1419,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.9,
      "Personalized Wellness Plan": 0.7,
      "Body Composition Analysis": 0.7,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Ladder",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:03 AM UTC",
    "goals": "Trying to cut about 15 lbs while maintaining same muscle mass and increasing endurance",
    "priceObjection": "",
    "wtpFactors": "Good consumer feedback and a commitment to longevity or some plan if the company is dissolved",
    "brandPerception": "Some kind of self-improvement program",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.267,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 36,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:04 AM UTC",
    "goals": "I'm trying to lose weight. I've lost 25 pounds and want to lose another 25. I've been eating at home and cooking more.",
    "priceObjection": "",
    "wtpFactors": "If it had wearable tech and I also like the yoga and stretching",
    "brandPerception": "Change me, like getting fit or losing weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 726,
    "priceDistribution": {
      "499": 8,
      "999": 1,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.727,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.455,
      "Body Composition Analysis": 0.455,
      "Workout Sessions": 0.818,
      "Recovery Sessions": 0.545,
      "Nutrition Tracking": 0.727
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:04 AM UTC",
    "goals": "Lose 2-5 pounds and get stronger and faster",
    "priceObjection": "Wouldn’t pay for it",
    "wtpFactors": "If something happened preventing me from doing my normal routine",
    "brandPerception": "First thought is “huh” but then looking harder I could see how this could be a wellness regime",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 2:06 AM UTC",
    "goals": "Right now I'm trying to lose weight to try and relieve back, knee, and ankle pain I've been having; which I associate with being a little overweight. I'm also trying to sleep better and I've made a huge effort to improve the types of food I'm eating; like increasing the use of fresh fruit and vegetables, as well as, cutting out unhealthy snacks and beverages.",
    "priceObjection": "",
    "wtpFactors": "First, it would need to include things I do not already get for free, like meal and calorie tracking. And, most important, virtual workout sessions never work for me. I keep up for a few weeks and then get bored and quit. For me, personally, I need real-life instruction in a group environment in order to stay focused and interested.",
    "brandPerception": "If it's a brand, I'm not familiar with it. But, the name alone makes me think someone will change something about me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:06 AM UTC",
    "goals": "I am doing more excercise and easting healthy foods",
    "priceObjection": "",
    "wtpFactors": "It should have a good reviews online",
    "brandPerception": "It means it will chnage your body for good",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1063,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 3,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.857,
      "Body Composition Analysis": 0.286,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.643
    },
    "gender": "Female",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:06 AM UTC",
    "goals": "Eat healtheir and get in more shape",
    "priceObjection": "",
    "wtpFactors": "Affordable and worth the time",
    "brandPerception": "Some type of altering of ones self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1172,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:11 AM UTC",
    "goals": "I am trying to get stronger, more defined,",
    "priceObjection": "I would never pay this much money",
    "wtpFactors": "It would have to be very very cheap",
    "brandPerception": "AI insoried",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 35,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:14 AM UTC",
    "goals": "Losw weight",
    "priceObjection": "",
    "wtpFactors": "No interest paid financing",
    "brandPerception": "First alert",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1086,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "WHOOP",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 2:14 AM UTC",
    "goals": "Lose stomach fat",
    "priceObjection": "At that price it’s not practical you could just eat healthier and exercise",
    "wtpFactors": "Currently, there is no way you would get me to pay for anything besides the gym member membership",
    "brandPerception": "Cosmetic surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 40,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:16 AM UTC",
    "goals": "I would say it has to be a new thing for people who need it for a great concept",
    "priceObjection": "",
    "wtpFactors": "I would say it has to be a great thing for people who have it",
    "brandPerception": "I would say it has to be a new thing for people who have a new thing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1146,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 34,
    "income": "$200,000 or more",
    "race": "",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:16 AM UTC",
    "goals": "loose weight",
    "priceObjection": "",
    "wtpFactors": "detailed",
    "brandPerception": "diet",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1352,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 4,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:17 AM UTC",
    "goals": "My personal health is average I try to work out when I can",
    "priceObjection": "",
    "wtpFactors": "It would come down to if I needed it and the cost",
    "brandPerception": "I think of like church I can’t think of anything else",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1259,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 4,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:20 AM UTC",
    "goals": "Just to be more in shape",
    "priceObjection": "Not interested in something I can do for free for mysef",
    "wtpFactors": "Some sort of guarantee",
    "brandPerception": "Changing of your body or mindset",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:20 AM UTC",
    "goals": "I would like to lose about 10 lbs",
    "priceObjection": "",
    "wtpFactors": "Details of the plan. How are goals tracked? What is my calorie count etc",
    "brandPerception": "Change me, fix me",
    "otherBrand": "My fitness pal\nLose it",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 1
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "My fitness pal\nLose it"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:21 AM UTC",
    "goals": "Stay fit and in shape.",
    "priceObjection": "",
    "wtpFactors": "The dna and personalized wellness plan.",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 32,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:21 AM UTC",
    "goals": "Keeping a healthy diet",
    "priceObjection": "",
    "wtpFactors": "Great p",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1292,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:22 AM UTC",
    "goals": "Right now I am trying to lose a few more pounds. I am currently trying to maintain my fitness level somewhat as I do that. After I finish losing the weight, I am hoping to ramp up training again for triathlon. I am prioritizing protein and am trying to eat cleaner.",
    "priceObjection": "",
    "wtpFactors": "It would have to include things that I don't already have access to. I have workout programs, so I wouldn't be overly interested in paying for more. The dexa scan and personalized features are more appealing to me because I can't just do those on my own. But the price would also have to be affordable. A lot of those programs seemed very expensive.",
    "brandPerception": "I have never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 2:22 AM UTC",
    "goals": "Staying fit and reactive to maintain overall health and wellness",
    "priceObjection": "",
    "wtpFactors": "Overall cost and benefits",
    "brandPerception": "Changing certain aspects of your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 9,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.444,
      "Smart Biometrics Ring": 0.444,
      "Personalized Wellness Plan": 0.444,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:22 AM UTC",
    "goals": "stay active",
    "priceObjection": "",
    "wtpFactors": "Guaranteed results",
    "brandPerception": "church",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1279,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 1,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:23 AM UTC",
    "goals": "I'd like to exercise regularly to improve my physical health and appearance. I work out at home and intend to increase my time each day.",
    "priceObjection": "",
    "wtpFactors": "decent price with good benefits from experts",
    "brandPerception": "never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 928,
    "priceDistribution": {
      "499": 8,
      "999": 2,
      "1499": 0,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.357,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:24 AM UTC",
    "goals": "My primary personal health goal is to become more active, and resist the lure of the computer. My diet needs work as well, but I think increasing my activity level is the bigger priority.",
    "priceObjection": "",
    "wtpFactors": "The level of personalized analysis and design in terms of what I need to do, and the genetic roadblocks I need to watch out for, would be very important. A smart ring would be nice, and could help justify the cost.",
    "brandPerception": "A plastic surgery company",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.25
    },
    "gender": "Male",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:25 AM UTC",
    "goals": "I would like to get healthy and lose weight",
    "priceObjection": "",
    "wtpFactors": "If my health declines",
    "brandPerception": "Fix me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1306,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:25 AM UTC",
    "goals": "Lower my blood sugar",
    "priceObjection": "",
    "wtpFactors": "Lots of extra amenities",
    "brandPerception": "Not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 2,
      "999": 6,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:26 AM UTC",
    "goals": "I don’t currently have any health goals. I live live day by day.",
    "priceObjection": "It is too expensive",
    "wtpFactors": "Something that is effective, affordable and a good value!",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:28 AM UTC",
    "goals": "Currently I am working on losing 15 lbs. I walk for an hour per day, 5 days a week. I also practice Tai Chi everyday.",
    "priceObjection": "",
    "wtpFactors": "If it’s affordable. Most people like me can afford maybe $30-40 a month so this program would be out of my reach.",
    "brandPerception": "Being altered by something.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:28 AM UTC",
    "goals": "Eat Healthy, Excersize and have fun",
    "priceObjection": "I would start small.",
    "wtpFactors": "If I could save long term, like going out to eat and removing other more expensive things",
    "brandPerception": "Basically change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:29 AM UTC",
    "goals": "My main goal is to lose weight, eat healthier and overall take better care of my body",
    "priceObjection": "",
    "wtpFactors": "If it had a lot to choose from or different things to do",
    "brandPerception": "An app that will help change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1239,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 28,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:29 AM UTC",
    "goals": "None currently.  Basic exercise",
    "priceObjection": "",
    "wtpFactors": "None",
    "brandPerception": "No ide",
    "otherBrand": "",
    "otherDevice": "Not sure of brans",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Other smart ring or fitness tracker",
      "Not sure of brans"
    ]
  },
  {
    "date": "Feb 19, 2026 2:30 AM UTC",
    "goals": "I want to build and maintain muscle as I age. \nI want to keep blood pressure and cholesterol in check.",
    "priceObjection": "",
    "wtpFactors": "Price and if weight lifting is included.",
    "brandPerception": "Change your weight and body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 859,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 1,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:30 AM UTC",
    "goals": "Focus on losing weight",
    "priceObjection": "",
    "wtpFactors": "To make sure i am cover for what i do need",
    "brandPerception": "Quality",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:31 AM UTC",
    "goals": "I would like to lose 20-30 pounds while also strength training to build muscle.",
    "priceObjection": "I would never spend money on this",
    "wtpFactors": "Price and offerings including exercise classes or a program to follow",
    "brandPerception": "I’ve never heard of this. It sounds like a brand people use to change something about themselves",
    "otherBrand": "Fitness apps like Moves or Stronger by the Day",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Other",
      "Fitness apps like Moves or Stronger by the Day"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:31 AM UTC",
    "goals": "I am overweight and recovering from some injuries. I need to do constant weight training and PT to maintain my state.",
    "priceObjection": "",
    "wtpFactors": "Whether I think I will get the value I want and need out of it. Like what is being offered and what I need at that moment.",
    "brandPerception": "Not much. Something that can “alter” me? Like make a better version of myself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.25,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.75
    },
    "gender": "Male",
    "age": 38,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:32 AM UTC",
    "goals": "I plan to go vegan for a while and focus on losing some weight",
    "priceObjection": "",
    "wtpFactors": "I would like to see different testing to determine issues that need to be addressed.",
    "brandPerception": "Changing oneself",
    "otherBrand": "",
    "otherDevice": "generic brand",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 919,
    "priceDistribution": {
      "499": 9,
      "999": 1,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "generic brand"
    ]
  },
  {
    "date": "Feb 19, 2026 2:34 AM UTC",
    "goals": "would like to ride my stationary bike more and go on more walks/hikes.",
    "priceObjection": "",
    "wtpFactors": "nutrition plan and workout plan",
    "brandPerception": "send an alert",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 1039,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 0,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:34 AM UTC",
    "goals": "Shed this perimenopause weight and get toned.",
    "priceObjection": "",
    "wtpFactors": "It would have to be in depth and personalized - including hormone balancing, what phase of life you're in.  Not cookie cutter.",
    "brandPerception": "Just what it says - I will be altered.  Meaning (hopefully that I alter my body comp in a positive way.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.7,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 51,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:35 AM UTC",
    "goals": "losing weight getting down to 154 pounds is my ideal",
    "priceObjection": "",
    "wtpFactors": "would make it easier with afforadable payments",
    "brandPerception": "notjhing really maybe a newme",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1386,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.267,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "WHOOP",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:36 AM UTC",
    "goals": "I am trying to lose weight and manage my type 2 diabetes. I am also hoping to do body compositioning in the future.",
    "priceObjection": "",
    "wtpFactors": "It has to include as many features as possible at a reasonable price. That is what I mainly look for.",
    "brandPerception": "I am not familiar with that term but it sounds like something that promises to change you.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:36 AM UTC",
    "goals": "My wellness goals are to lose weight and stay active.",
    "priceObjection": "",
    "wtpFactors": "A wearable and ways to track progress over time.",
    "brandPerception": "To change something or someone.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 1374,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 2,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.875,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:39 AM UTC",
    "goals": "I want to get my weight managed and eat better",
    "priceObjection": "",
    "wtpFactors": "I want it to cover all that it can with being affordable",
    "brandPerception": "Altering my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1419,
    "priceDistribution": {
      "499": 0,
      "999": 6,
      "1499": 2,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.267,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 31,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:39 AM UTC",
    "goals": "Lose 100 pounds within a year and drink less soda",
    "priceObjection": "",
    "wtpFactors": "Design and product",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 570,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.857,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:40 AM UTC",
    "goals": "Currently to eat more pimento burgers but damn are they good",
    "priceObjection": "",
    "wtpFactors": "The savings",
    "brandPerception": "Church",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 8,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 39,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:41 AM UTC",
    "goals": "I’m currently on Weight Watchers. I have a goal to be healthier and live better.",
    "priceObjection": "Too expensive",
    "wtpFactors": "If I can afford it",
    "brandPerception": "No sure what that means",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:43 AM UTC",
    "goals": "Lose a bit of weight, become more flexible and overall, healthier.",
    "priceObjection": "That price is way above what I would ever consider paying. Minuses if this is meant to be a once off or annual payment.",
    "wtpFactors": "Let’s get it to a point where it is affordable, then we can talk. \n\nAt a minimum, workouts, recovery plans and meal coaching/planning.",
    "brandPerception": "I read AfterMe at first and was very confused. \n\nThe name sounds like a plastic surgeon.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:44 AM UTC",
    "goals": "Lifting weights to make my bones stronger. Prioritizing sleep. Eating healthier to include more protein and fruits and vegetables.",
    "priceObjection": "I wouldn’t purchase a plan this expensive.",
    "wtpFactors": "Something more in my budget. $500 is more in line with my budget.",
    "brandPerception": "Something that will “change” me in some way.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:44 AM UTC",
    "goals": "I'm trying to lose around 20 pounds.  Trying to walk more.",
    "priceObjection": "",
    "wtpFactors": "The price and personal need for a program that would do what I cannot on my own",
    "brandPerception": "Something that would help in personal transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 52,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:45 AM UTC",
    "goals": "im trying to eat cleaner and be more active",
    "priceObjection": "i would never pay for something lie this",
    "wtpFactors": "excessive cost",
    "brandPerception": "change who i am",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 54,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:45 AM UTC",
    "goals": "I do what I can to stay physically and mentally healthy so that I can also be emotionally healthy too. In order to do this - I do what I can to keep up with my exercising every day which includes some sort of cardio, light weights and meditation. I also try and limit my snacking but I indulge my cravings every once in awhile so that I don't binge randomly.",
    "priceObjection": "",
    "wtpFactors": "I would definitely need to have had positive experiences with it  in the past or it would need to be a program that's recommended to me by someone I trust and who has seen results already. Also I would want to be able to have some sort of trial period before fully committing to the investment/payment (money back/refund guarantee or something).",
    "brandPerception": "Honestly it sounds like a clothing hemming service - like for alterations or something.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 50,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 AM UTC",
    "goals": "I am trying to lose 15lbs. Lower my blood pressure. Increase my testosterone level.",
    "priceObjection": "",
    "wtpFactors": "The most available perks for the most reasonable price.",
    "brandPerception": "I’ve never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 AM UTC",
    "goals": "I try my best to keep my health in good shape at all times. This is my priority.",
    "priceObjection": "",
    "wtpFactors": "If the program will fit my budget and the program is good for me.",
    "brandPerception": "There is active notification.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 AM UTC",
    "goals": "I’d like to lose about 30 pounds and get tone and gain a little bit of muscle — not life changing but day to day changing maybe.",
    "priceObjection": "",
    "wtpFactors": "Having enough resources I can deal with on my own without those front-loaded prices.",
    "brandPerception": "Changing your lifestyle",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.385,
      "Smart Biometrics Ring": 0.538,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.385,
      "Workout Sessions": 0.308,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.462
    },
    "gender": "Male",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Tempo",
      "Tonal",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 AM UTC",
    "goals": "I want to have a well toned body.",
    "priceObjection": "",
    "wtpFactors": "It should affect my health properly.",
    "brandPerception": "I dont",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1406,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 5,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 29,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 AM UTC",
    "goals": "I want to maintain a healthy weight and eat better so I can live longer.",
    "priceObjection": "",
    "wtpFactors": "The quality of the product and the low monthly fee",
    "brandPerception": "Its an alert system",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 5,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:49 AM UTC",
    "goals": "get healthier",
    "priceObjection": "",
    "wtpFactors": "effectiveness",
    "brandPerception": "no idea",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 866,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 34,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:50 AM UTC",
    "goals": "Be more active",
    "priceObjection": "",
    "wtpFactors": "Being more healthy and productive",
    "brandPerception": "Altering myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 906,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 2:50 AM UTC",
    "goals": "To have a balanced diet and to exercise regularly",
    "priceObjection": "",
    "wtpFactors": "If it betters my health to live a longer life",
    "brandPerception": "To alter the lifestyle and health journey",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1292,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.733
    },
    "gender": "Male",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:50 AM UTC",
    "goals": "My personal health is good. My wellness goal is to continue my exercise and try to eat healthier",
    "priceObjection": "",
    "wtpFactors": "Have a special price and include what I use.",
    "brandPerception": "Something that needs to be fixed",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.417,
      "Personalized Wellness Plan": 0.583,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.417,
      "Recovery Sessions": 0.583,
      "Nutrition Tracking": 0.583
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:50 AM UTC",
    "goals": "Trying to lose weight and sleep better",
    "priceObjection": "",
    "wtpFactors": "If it includes dexa scan and workouts.",
    "brandPerception": "Have never",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:52 AM UTC",
    "goals": "My health goals are to maintain my weight loss journey, keep my diabetes and blood pressure under control.",
    "priceObjection": "",
    "wtpFactors": "The features and options included in the program & the price.",
    "brandPerception": "Lifestyle brand",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.867,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:53 AM UTC",
    "goals": "to lose weigh",
    "priceObjection": "",
    "wtpFactors": "proven results",
    "brandPerception": "I am not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:54 AM UTC",
    "goals": "Get in better shape and lose a healthy amount of weight",
    "priceObjection": "",
    "wtpFactors": "Proven benefits and fits well with my routine and schedule so I can utilize it",
    "brandPerception": "No idea. Never heard of it so nothing specific triggers it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 874,
    "priceDistribution": {
      "499": 2,
      "999": 6,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.375,
      "Smart Biometrics Ring": 0.875,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.375,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.375,
      "Nutrition Tracking": 0.375
    },
    "gender": "Female",
    "age": 28,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:55 AM UTC",
    "goals": "I have osteoporosis. I am trying to build back bone and increase my overall strength. I also want to generally be active for overall health.",
    "priceObjection": "",
    "wtpFactors": "I like tiered systems (let me pick and choose what I need and don't want) and I want something backed by science. (Reputable doctors more than \"gym bros\".)",
    "brandPerception": "I haven't heard of it, but it kind of sounds like weight loss.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "Combating specific health challenges (osteoporosis, etc.)",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.167,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Other",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:58 AM UTC",
    "goals": "Goal is to be healthier.",
    "priceObjection": "",
    "wtpFactors": "Price would really be a factor.",
    "brandPerception": "When you do non-natural fix.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1086,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:00 AM UTC",
    "goals": "I mainly do a lot of walking throughout the day my day doesn’t consist much of running unless I’m playing with my children.",
    "priceObjection": "",
    "wtpFactors": "Paying that’s much would certainly be enough motivation to take care of myself properly",
    "brandPerception": "Will cause Change to  me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1252,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:00 AM UTC",
    "goals": "Maintain high level of physical and mental wellness.",
    "priceObjection": "",
    "wtpFactors": "How well the program can keep me on track and reach objectives effectively.",
    "brandPerception": "A fitness tracker with notifications that might be annoying.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 837,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.538,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.615,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.692
    },
    "gender": "Male",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:02 AM UTC",
    "goals": "LOSE SOME WEIGHT AND EAT BETTER FOODS",
    "priceObjection": "",
    "wtpFactors": "FREE SHIPPING ON ITEMS",
    "brandPerception": "ALTERING YOUR LIFESTYLE",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1312,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.267,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tonal",
      "Ladder",
      "Fitbit",
      "WHOOP",
      "Noom",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:02 AM UTC",
    "goals": "I take vitamins and I exercise.  I want to lose weight and eat healthier",
    "priceObjection": "The price is too expensive for a health and wellness program",
    "wtpFactors": "The most important factor is cost because if I can't afford it, I'm not going to purchase it",
    "brandPerception": "Changing myself to something different than what I am",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:03 AM UTC",
    "goals": "My goal is to get healthier and lose weight at the same time",
    "priceObjection": "",
    "wtpFactors": "Cheaper reasonable monthly plan",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.267,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:08 AM UTC",
    "goals": "Exercise more and increase muscle tone",
    "priceObjection": "",
    "wtpFactors": "Recommendations",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 892,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:08 AM UTC",
    "goals": "I want to lose 15 pounds and walk at least 12000 steps a day",
    "priceObjection": "",
    "wtpFactors": "The level of personalization and effectiveness to meet my goals",
    "brandPerception": "Altering my body in a good way",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1061,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.308,
      "Smart Biometrics Ring": 0.538,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.385,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.462
    },
    "gender": "Female",
    "age": 50,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:09 AM UTC",
    "goals": "I'm currently trying a clean bulk with a goal of adding a quarter to half a pound of muscle a week.  I work out 4-5 times a week on average doing cardio and weightlifting.",
    "priceObjection": "",
    "wtpFactors": "If it came with a DEXA scan to learn about my body composition.  If it offered an easy way to track calories and nutrition.",
    "brandPerception": "Body recomposition.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:09 AM UTC",
    "goals": "my personal health is not that well",
    "priceObjection": "",
    "wtpFactors": "the factors are to be good benefit and more options",
    "brandPerception": "I think of fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1232,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 4,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:10 AM UTC",
    "goals": "Lose weight. Get toned and fit. Strengthen my heart and my spine and hips.",
    "priceObjection": "",
    "wtpFactors": "Workouts adapted to what my needs and can handle to reach my goals. Nutrition that is specialized for my needs to reach my goals and keep me healthy.",
    "brandPerception": "Change me. Help me reach fitness and wellness goals.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:10 AM UTC",
    "goals": "My current health is somewhat good but could use some improvement.",
    "priceObjection": "",
    "wtpFactors": "The quality of service provided and the more I get for my money",
    "brandPerception": "Change in life",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1459,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:11 AM UTC",
    "goals": "I want to stay lean and build more muscle. I make sure to  take vitamins daily and stay physically fit",
    "priceObjection": "",
    "wtpFactors": "I would wanna make sure that I would get a lot of use out of it and that it has enough value for me to pay for it every month",
    "brandPerception": "Changing yourself or improving yourself in someway",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1079,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:14 AM UTC",
    "goals": "To maintain my fitness levels I have attained. Pure maintenance mode.",
    "priceObjection": "",
    "wtpFactors": "A reasonable price",
    "brandPerception": "That I'm nit good enough",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.857,
      "Nutrition Tracking": 0.286
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:15 AM UTC",
    "goals": "Lose body fat, maintain or increase muscle mass, improve cardiovascular endurance and flexibility",
    "priceObjection": "",
    "wtpFactors": "Reviews, before and afters, features, price, sustainability",
    "brandPerception": "Making changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.875,
      "Smart Biometrics Ring": 0.875,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.625
    },
    "gender": "Female",
    "age": 35,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:15 AM UTC",
    "goals": "I am very active but I’d like to be more targeted with strength training.",
    "priceObjection": "",
    "wtpFactors": "I’d have to really understand what I was getting and why it was worth it. “Personalized programs” generally fall flat. I have a strong knowledge base already and I’d want to be sure I was actually getting a product that would add value to me. I like the dexa scans, for example, because I know I’m getting solid data.",
    "brandPerception": "That sounds uncomfortable and creepy",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.833,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.167,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:19 AM UTC",
    "goals": "Lose 20 pounds and gain muscle defin",
    "priceObjection": "",
    "wtpFactors": "Affordability",
    "brandPerception": "I've never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 932,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 1,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:20 AM UTC",
    "goals": "I’m running a race in May and losing weight.",
    "priceObjection": "I would not buy that",
    "wtpFactors": "How much my company would cover",
    "brandPerception": "Plastic surgery or Hollywood.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:20 AM UTC",
    "goals": "I feel pretty good overall",
    "priceObjection": "",
    "wtpFactors": "If I felt it offered items that I really needed at an afofrable price",
    "brandPerception": "Getting married",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 812,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:21 AM UTC",
    "goals": "I need to start working out again, I haven’t done it for months. I used to do Pilates and a dumbbell workout, I need to start doing those again.",
    "priceObjection": "",
    "wtpFactors": "Price is the biggest one. Most of these programs are just way out of my budget.  I would be the most interested in the biometrics ring.  I’m not very interested in my DNA analysis; I am not like my parents and my approach to fitness is very different.  I know most people want to lose weight but I’m underweight. I don’t need to watch my calories; I just need more of them.",
    "brandPerception": "It sounds like you’re trying to change yourself. It also kind of sounds like plastic surgery.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 599,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.2,
      "Body Composition Analysis": 0.2,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:22 AM UTC",
    "goals": "To be overall in good health.",
    "priceObjection": "They are all too expensive.",
    "wtpFactors": "If I seriously needed it.",
    "brandPerception": "I've never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:22 AM UTC",
    "goals": "Stay away from processed sugars, maintain a healthy BMI, eat more fruits and veggies. Also stay hydrated with water filled with cucumbers, Chia seeds, etc.",
    "priceObjection": "",
    "wtpFactors": "For factors related to obesity for many years.",
    "brandPerception": "Apps to track the body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1312,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 4,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:25 AM UTC",
    "goals": "to lose weight and get into better shape. Be healthier.",
    "priceObjection": "",
    "wtpFactors": "It ot was something I thought would be effective and then I might want to use it.",
    "brandPerception": "What comes to mind is, \"I don't want to be altered.\"",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 44,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:25 AM UTC",
    "goals": "I would like to lose weight and have\nMore flexibility and energy",
    "priceObjection": "",
    "wtpFactors": "Biometrics ring recovery help work outs and help with nutrition",
    "brandPerception": "Exercise weight loss",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1006,
    "priceDistribution": {
      "499": 5,
      "999": 6,
      "1499": 2,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:26 AM UTC",
    "goals": "Getting more active physically by increasing my walking time and enjoying the outdoors more.Eating better by eating less processed foods and making more home-cooked meals.",
    "priceObjection": "",
    "wtpFactors": "The health and wellness program must be friendly to use and have goals that can be obtainable  for the user.",
    "brandPerception": "To make someone different then they are.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1092,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 4,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:27 AM UTC",
    "goals": "I am looking to maintain my health, my true health without medications. I am doing my best to eat balanced meals and exercise.",
    "priceObjection": "",
    "wtpFactors": "If the cost was $20 per month.",
    "brandPerception": "As the French woman that I am, when I  hear \"AlterMe\", I think about \"Altères\" in French which means: weight or lifting equipment. So working out comes to mind.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 599,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:27 AM UTC",
    "goals": "My personal health goal is to reduce my cholesterol levels. Unfortunately, I am on medication to lower my cholesterol but I would rather diet than use these medications with all of the side effects.",
    "priceObjection": "",
    "wtpFactors": "The real big factor is the cost and whether I could use a payment plan.",
    "brandPerception": "When I hear this term, I think altering in a positive healthy meaning.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1572,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 5,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:28 AM UTC",
    "goals": "Get in athletic condition",
    "priceObjection": "Too expensive",
    "wtpFactors": "An affordable price",
    "brandPerception": "Change your body shape",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 812,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:29 AM UTC",
    "goals": "Gain lean muscle",
    "priceObjection": "",
    "wtpFactors": "Not sure, never have",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1356,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.786,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.643,
      "Nutrition Tracking": 0.643
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:29 AM UTC",
    "goals": "Lean, strengthen, tone",
    "priceObjection": "Too much.",
    "wtpFactors": "Nothing.  Too much.",
    "brandPerception": "Tailor or wellness app",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:29 AM UTC",
    "goals": "I’m 47 so my main goal is just to be in optimal physical condition to prolong my life as long as possible.  I am trying to lose 5-10 pounds while also increasing my physical strength as well, strictly with calisthenics and no weights.",
    "priceObjection": "",
    "wtpFactors": "I would need to be 100% sure that I could be fully dedicated to it before thinking about committing.  I’m not quite there yet but I could see myself possibly being more interested in the future.  Right now I’m working out on my own schedule while trying to eat as healthy as possible.",
    "brandPerception": "I’ve never seen this term but I’m assuming it refers to changing yourself physically.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:34 AM UTC",
    "goals": "I am trying to eat better every day.",
    "priceObjection": "",
    "wtpFactors": "The customer support option.",
    "brandPerception": "I have never heard of that brand.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1416,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.417,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.417,
      "Recovery Sessions": 0.417,
      "Nutrition Tracking": 0.583
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:36 AM UTC",
    "goals": "I'd like to lose weight. I'd like to be stronger.",
    "priceObjection": "I wouldn't find value in any of these.",
    "wtpFactors": "If you could include more than one person.",
    "brandPerception": "It makes me think of changing something about myself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:37 AM UTC",
    "goals": "Maintain weight and get healthier with a better diet",
    "priceObjection": "",
    "wtpFactors": "Saves the most amount of money over time",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 924,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.375,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.25
    },
    "gender": "Male",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:37 AM UTC",
    "goals": "I would like to lose a little weight and be more toned.",
    "priceObjection": "",
    "wtpFactors": "Reading reviews from people who have completed the program",
    "brandPerception": "Change my size",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1092,
    "priceDistribution": {
      "499": 3,
      "999": 7,
      "1499": 4,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 3:38 AM UTC",
    "goals": "Gain muscle and to eat better",
    "priceObjection": "",
    "wtpFactors": "Affordability",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1026,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 4,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:38 AM UTC",
    "goals": "I use it to keep myself active and measure my vitals.",
    "priceObjection": "",
    "wtpFactors": "I just need a plan that works with my budget. I can't afford those higher amounts.",
    "brandPerception": "It makes me think of someone who wants to change their appearance.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.286,
      "Body Composition Analysis": 0.714,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.571
    },
    "gender": "Male",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:40 AM UTC",
    "goals": "I am seeking to build endurance and to lower my resting heart rate. A little weight loss wouldn't be bad either, but it's not a priority.",
    "priceObjection": "",
    "wtpFactors": "Monthly payments and interest rates. How many features it comes with. Generally I won't do anything that requires me submitting dna for analysis that's not to my doctor, so no price point works for me there.",
    "brandPerception": "I have never heard of this before now. But AlterMe has a connotation that kind of derides the prospective user's current body, so it feels kinda crummy.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0.455,
      "Personalized Wellness Plan": 0.818,
      "Body Composition Analysis": 0.455,
      "Workout Sessions": 0.545,
      "Recovery Sessions": 0.364,
      "Nutrition Tracking": 0.545
    },
    "gender": "Non-binary / Other",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:40 AM UTC",
    "goals": "lose weight",
    "priceObjection": "expensive",
    "wtpFactors": "proven results",
    "brandPerception": "surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:41 AM UTC",
    "goals": "I'm on a weight loss journey",
    "priceObjection": "",
    "wtpFactors": "To motivate me more to keep me on track",
    "brandPerception": "Change my body image or shape",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1386,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.867
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:41 AM UTC",
    "goals": "i want to gain muscle,cardio, and overall endurance for transitioning to another physical job",
    "priceObjection": "",
    "wtpFactors": "knowing its prepared by a professional, having a wide variety of benefits for my health and well being, and being convenient",
    "brandPerception": "changing for the better and healthy alternative work",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:41 AM UTC",
    "goals": "I'm trying to lose some weight",
    "priceObjection": "",
    "wtpFactors": "The cost",
    "brandPerception": "It makes me think of something that will change my appearance",
    "otherBrand": "",
    "otherDevice": "Coros",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Coros"
    ]
  },
  {
    "date": "Feb 19, 2026 3:42 AM UTC",
    "goals": "Eat healthy and non toxic utility",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1212,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 5,
      "1699": 0,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.267,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "AlterMe"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:43 AM UTC",
    "goals": "145 lb. Tone my body",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "Lose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 839,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:46 AM UTC",
    "goals": "Eat a Whole Food plant based starch diet",
    "priceObjection": "",
    "wtpFactors": "I would have to justify using it.",
    "brandPerception": "None",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:46 AM UTC",
    "goals": "I want to lose about 60 pounds and go to the gym with my son.",
    "priceObjection": "",
    "wtpFactors": "Everything is included within the final price without any extra fees",
    "brandPerception": "I can’t say because I would need more information to know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 50,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:47 AM UTC",
    "goals": "Build muscle with strength training. More walking. Trying and adding new foods to diet.",
    "priceObjection": "",
    "wtpFactors": "If I had a job that paid better.",
    "brandPerception": "Sounds and looks silly. Modern name.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:48 AM UTC",
    "goals": "As with a lot of people, I am shedding some winter weight. I walk and exercise regularly and occasionally lift weights",
    "priceObjection": "",
    "wtpFactors": "It would have to fit my budget. The bells and whistles are nice, but cost effectiveness is a major factor",
    "brandPerception": "A change for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:49 AM UTC",
    "goals": "I really do like this product",
    "priceObjection": "",
    "wtpFactors": "I really like that I can pay not in full",
    "brandPerception": "Is this really a thing?",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1406,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 3,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 32,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:49 AM UTC",
    "goals": "Stay physically fit and in sha",
    "priceObjection": "",
    "wtpFactors": "To help me get in the routine of working out and staying healthy.",
    "brandPerception": "When sugar level is to high",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 966,
    "priceDistribution": {
      "499": 5,
      "999": 6,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 3:49 AM UTC",
    "goals": "I'm trying to lose 20 lbs in a healthy way",
    "priceObjection": "",
    "wtpFactors": "Price, customizeabl",
    "brandPerception": "I haven't heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1086,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 2,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.867
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:49 AM UTC",
    "goals": "I want to lose weight and get healthy and try to stop taking some medications",
    "priceObjection": "",
    "wtpFactors": "Having a nutrition plan and a biometric ring",
    "brandPerception": "Making me into something different, changing what is unique about me, kind of negative",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 882,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 0,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.417,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:57 AM UTC",
    "goals": "My goal is to lose 15% of my weight, cut down my sugar and carbs int",
    "priceObjection": "",
    "wtpFactors": "My health con",
    "brandPerception": "When I hear “AlterMe,” I think of transformation or becoming a different version of myself. It sounds modern and personal, like something customizable that helps you improve or enhance yourself. It also makes me think of self-expression and change, maybe even a glow-up or upgrade.",
    "otherBrand": "Samsung health",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Other",
      "Samsung health"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:00 AM UTC",
    "goals": "My health and wellness goals are to loss about 50 pounds before June for my daughter's wedding to be able to look and feel better",
    "priceObjection": "",
    "wtpFactors": "If it was something affordable and able to paid for longer than needed if possible",
    "brandPerception": "Changing the way I am or my body is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 1456,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 1,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.857,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:03 AM UTC",
    "goals": "I would like to lose a few pounds and get toned",
    "priceObjection": "",
    "wtpFactors": "I would need to find something specific to my needs",
    "brandPerception": "Something virtual reality related",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:04 AM UTC",
    "goals": "I want to lose weight (like 20-30 lbs) and have more energy overall",
    "priceObjection": "",
    "wtpFactors": "small monthly fee, not a huge 1000 dollar cost, provides tangible benefits over free programs",
    "brandPerception": "changing myself, improving",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 29,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:04 AM UTC",
    "goals": "I want to feel better and live linger",
    "priceObjection": "",
    "wtpFactors": "Not too expensive and has something i can't or already don't do on my own",
    "brandPerception": "I think its an app, I assume",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.25,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Male",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 4:06 AM UTC",
    "goals": "More cardio, and less carbs.",
    "priceObjection": "",
    "wtpFactors": "Under $1000. Same trainer every session.",
    "brandPerception": "Never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 9,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.444,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.556,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.444
    },
    "gender": "Male",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:09 AM UTC",
    "goals": "I want to sleep better. I am working to achieve that goal by exercising more. I drink tea especially for that. I am trying to lose a couple of pounds.",
    "priceObjection": "Very expensive.",
    "wtpFactors": "To track calorie intake and workouts personalized for me.",
    "brandPerception": "I do not know anything about this.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:10 AM UTC",
    "goals": "My personal health and wellness goals include decrease my resting heart rate, losing weight, and increase my walking to 30 minutes 5-7 times a week. I want to walk at least half-mile every time I walk. I want to improve my upper and lower body strength, including tone my arms, stomach, and legs.",
    "priceObjection": "",
    "wtpFactors": "If the program measures my vitals (HR and BP), provides workout sessions, provides recovery sessions, and gives health advice/suggestions.",
    "brandPerception": "The goal of the program is completely change the individual in many areas.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:12 AM UTC",
    "goals": "Change",
    "priceObjection": "",
    "wtpFactors": "Price and accessibility",
    "brandPerception": "Weddings, not fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.286
    },
    "gender": "Female",
    "age": 32,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Never",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:18 AM UTC",
    "goals": "Better sleep and maintaining weight",
    "priceObjection": "",
    "wtpFactors": "Consistent results",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Noom"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 4:18 AM UTC",
    "goals": "My goal is to reach a healthy weight and feel comfortable in my own skin.",
    "priceObjection": "",
    "wtpFactors": "Reviews, credentials of those who created plan.",
    "brandPerception": "Change. Not necessarily in a positive light.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1274,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.417
    },
    "gender": "Female",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 AM UTC",
    "goals": "I want to stay healthy overall in general and build muscle",
    "priceObjection": "",
    "wtpFactors": "If there was a free trial",
    "brandPerception": "A health solution that alters your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.286,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 AM UTC",
    "goals": "I am looking to build muscle with weight training and improve flexibility and range of motion. Exercise, stretching, diet, sleep and nutrition are all of concern.",
    "priceObjection": "",
    "wtpFactors": "This survey is excruciatingly painful, and my head hurts too much to answer this. Whoever came up with this survey, should rethink it. Sorry just being very honest.",
    "brandPerception": "Change my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1359,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:20 AM UTC",
    "goals": "I started taking GLP1s about 8 months ago. I'm trying to actively lose weight by decreasing my carb intake and the shots have really helped curb my appetite and has also helped with not drinking alcohol.",
    "priceObjection": "",
    "wtpFactors": "One of my first factors would be reviews and testimonials. The second thing would be it has got to be way cheaper. I know different plans work better for different body types but I'm not willing to sacrifice $1,500 even though I get an individualized plan. I also did not see anywhere on there if that was the price per year or for 5 years or for 3 years. I don't know if I missed it.",
    "brandPerception": "Weight Watchers",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tempo",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:20 AM UTC",
    "goals": "Just trying to become healthier due to my age bc it's time take care of me",
    "priceObjection": "",
    "wtpFactors": "If I need it and if I can afford it",
    "brandPerception": "Dna testing reveals 13 key genetic insights and how it affects your health and what steps you need to do to be healthier",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1185,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:22 AM UTC",
    "goals": "I am hoping to get healthier this year by trying to eat better. I am using some different tools to try to treat my body. I have a lot of health problems and want to try to resolve them",
    "priceObjection": "",
    "wtpFactors": "Price and what’s included for the price",
    "brandPerception": "I don’t think of anything because I don’t know what this is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:23 AM UTC",
    "goals": "To have better healthier knees after surgery to have better heart h",
    "priceObjection": "",
    "wtpFactors": "Poor health that would cause an early",
    "brandPerception": "He",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1519,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 3,
      "1699": 4,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:24 AM UTC",
    "goals": "Trying to eat healthier and get some daily exercise to look better and feel better. Also to fit in smaller sized clothing.",
    "priceObjection": "",
    "wtpFactors": "I don't really find a lot of the offerings you show me to be something that I would be interested in, so I suppose the fact that we post influence my willingness to pay for the program would be it being very inexpensive.",
    "brandPerception": "It sounds like somewhere you would take your clothes to be altered.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:26 AM UTC",
    "goals": "I would like to not die.",
    "priceObjection": "",
    "wtpFactors": "Affordability and convenience.",
    "brandPerception": "Something that's going to change my habits.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1476,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 3,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.462,
      "Smart Biometrics Ring": 0.769,
      "Personalized Wellness Plan": 0.615,
      "Body Composition Analysis": 0.385,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.385,
      "Nutrition Tracking": 0.615
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Never",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:26 AM UTC",
    "goals": "Lose weight and keep it off",
    "priceObjection": "",
    "wtpFactors": "Price and if it’s on an app or in person.",
    "brandPerception": "Making me different in a good way!",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 846,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:26 AM UTC",
    "goals": "Maintain and track",
    "priceObjection": "",
    "wtpFactors": "Not sure",
    "brandPerception": "Changing",
    "otherBrand": "Oura",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tonal",
      "Other",
      "Oura"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 4:27 AM UTC",
    "goals": "I want to stay physically active. Maintain a good balanced life and stay mentally positive.",
    "priceObjection": "",
    "wtpFactors": "It offers many great features.",
    "brandPerception": "Improvements.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 3,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:29 AM UTC",
    "goals": "Maintaining health",
    "priceObjection": "",
    "wtpFactors": "If metrics were accurate",
    "brandPerception": "Change yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 1037,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.375,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.375,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:30 AM UTC",
    "goals": "Currently I am just trying to keep my weight down by monitoring how much food I am eating a day, but not being very strict on myself",
    "priceObjection": "",
    "wtpFactors": "I would prefer a plan that has nutritional tracking, personalized plans and no interest payments to consider purchasing the plan.",
    "brandPerception": "It’s a fitness app used to help get in shape and lose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 1,
      "1699": 5,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:30 AM UTC",
    "goals": "I would like to lose weight and lower my cholesterol.",
    "priceObjection": "",
    "wtpFactors": "The procedures and the price.",
    "brandPerception": "Change me for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1319,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 4,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.267
    },
    "gender": "Female",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:30 AM UTC",
    "goals": "I am currently overweight. I am loosing weight, so I can reach my goal overtime. I have made some changes in the way I eat and move.",
    "priceObjection": "",
    "wtpFactors": "1,500 is a considerable amount to pay. I would value accessibility to content, longevity of the program and action plan. To lose weight you need both exercise and nutrition. So I will expect at least that.",
    "brandPerception": "Change, a different version",
    "otherBrand": "Jillian Michaels",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 962,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.875,
      "Workout Sessions": 0.875,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers",
      "Other",
      "Jillian Michaels"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:32 AM UTC",
    "goals": "My personal goal is to get in shape and eat healthy",
    "priceObjection": "",
    "wtpFactors": "The price",
    "brandPerception": "I don't know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 777,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.556,
      "Smart Biometrics Ring": 0.556,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.889,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.778,
      "Nutrition Tracking": 0.111
    },
    "gender": "Female",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:35 AM UTC",
    "goals": "I would like to lose weight and improve my health overall.",
    "priceObjection": "",
    "wtpFactors": "I probably would not pay for one. I know enough about health, nutrition, and fitness to avoid paying these high costs.",
    "brandPerception": "I have never heard this before. It doesn’t make me think of health and wellness right away. It makes me think of altering my clothes.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:35 AM UTC",
    "goals": "I want to be stronger and eat healthier.",
    "priceObjection": "",
    "wtpFactors": "I want the best for my buck but am not willing to shell out top dollars especially if I’m not fully confident in the product.",
    "brandPerception": "It seems expensive.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 4,
      "999": 6,
      "1499": 2,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:36 AM UTC",
    "goals": "I would like to exercise regularly - for now I’m aiming for twice a week. I try to eat more whole grains, avoid sweetened beverages, and eat less junk food",
    "priceObjection": "I would not spend $1499 on this, or even $1000 if paying in full. But if I was going to, I would pay in full",
    "wtpFactors": "If I was anyway planning to buy a tracker, I might look into a program, otherwise I would not",
    "brandPerception": "Wanting to change yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 40,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:38 AM UTC",
    "goals": "Staying healthy reducing processed goods",
    "priceObjection": "",
    "wtpFactors": "Relevant to my needs and lifestyle",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 1,
      "1699": 6,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.267,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.933,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 57,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:39 AM UTC",
    "goals": "I intend to stay healthy and eat fresh food as much as possible",
    "priceObjection": "O wouldnt buy something like this",
    "wtpFactors": "I wouldnt buy it for any reason",
    "brandPerception": "nothing comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:40 AM UTC",
    "goals": "To lose weight with exercise and a balanced diet",
    "priceObjection": "",
    "wtpFactors": "Track record of proven results and doctor recommendations",
    "brandPerception": "Helps you get in healthier habits",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 5,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:40 AM UTC",
    "goals": "I want to maintain current weight",
    "priceObjection": "",
    "wtpFactors": "Minimum monthly payments and number of included features",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "Watch store brand",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1066,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Watch store brand"
    ]
  },
  {
    "date": "Feb 19, 2026 4:40 AM UTC",
    "goals": "I started strength training recently because I want to be stronger. I also have changed my eating habits. I eat more fruits, vegetable vegetables, fiber, protein, and less carbohydrates.",
    "priceObjection": "",
    "wtpFactors": "The factors that would influence my willingness to pay for health and wellness program would be Howard the availability of it and also the price I don’t have $500-$2000 worth of money when I can just go on YouTube for free",
    "brandPerception": "I am not familiar with alterme, but maybe it sounds like 23 me so maybe it’s something that’s going to check your DNA for history of chronic disease in the family line",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:41 AM UTC",
    "goals": "Trying to lose the baby weight while eating healthy and working out",
    "priceObjection": "",
    "wtpFactors": "Brand and type of cintent",
    "brandPerception": "Nothinv",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1153,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.615,
      "Smart Biometrics Ring": 0.538,
      "Personalized Wellness Plan": 0.769,
      "Body Composition Analysis": 0.385,
      "Workout Sessions": 0.615,
      "Recovery Sessions": 0.615,
      "Nutrition Tracking": 0.462
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:41 AM UTC",
    "goals": "I would like to get more muscle and lose fat. I would also like to increase my activity.",
    "priceObjection": "",
    "wtpFactors": "Affordable payment options, workout and nutrition plan",
    "brandPerception": "To be changed. To be different",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 812,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.25,
      "Personalized Wellness Plan": 0.375,
      "Body Composition Analysis": 0.875,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.625
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:42 AM UTC",
    "goals": "I need to get more water in and more protein but I’m also open to trying new things",
    "priceObjection": "",
    "wtpFactors": "I’m open to all of them but I need just a few more pieces of information to make an educated decision",
    "brandPerception": "Maybe change me? Never heard of them",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1439,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 41,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:42 AM UTC",
    "goals": "I want to lose about 10 pounds, eat a more balanced diet and stay consistent with physical activity.",
    "priceObjection": "",
    "wtpFactors": "Personalized plan and coaching. Biometrics ring.",
    "brandPerception": "I don’t like it. Alter doesn’t sound like an improvement- just a change, but not aspirational or motivational.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1292,
    "priceDistribution": {
      "499": 2,
      "999": 5,
      "1499": 2,
      "1699": 5,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 48,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:42 AM UTC",
    "goals": "I try to exercise from time to time for my health",
    "priceObjection": "",
    "wtpFactors": "I take my health & wellness serious",
    "brandPerception": "Focus on self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:45 AM UTC",
    "goals": "I try to eat clean and healthy food. I walk and ride my bicycle. I do cardio exercise and try to keep my stress level down. I also try to get a good night's sleep",
    "priceObjection": "",
    "wtpFactors": "There is nothing more important than health and sometimes we need some help and guidance",
    "brandPerception": "It's a personalized high tech fitness system with a workout specially made for you and uses DNA testing and a ring to track progress",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1392,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 2,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.2
    },
    "gender": "Male",
    "age": 57,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:46 AM UTC",
    "goals": "Stay healthy and eat organic food",
    "priceObjection": "",
    "wtpFactors": "Healthy well being",
    "brandPerception": "Training to be better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:46 AM UTC",
    "goals": "I am currently trying to lose weight, especially on my belly and I want to gain more tone and muscle",
    "priceObjection": "",
    "wtpFactors": "If it is fairly priced, things can be flexible and changed with the plan and I can utilize it enough in my weekly life",
    "brandPerception": "It makes me think of completely changing a person",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.556,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:51 AM UTC",
    "goals": "I need to loose weight badly",
    "priceObjection": "",
    "wtpFactors": "Not at this time",
    "brandPerception": "Time to change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 942,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.643,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.286
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "AlterMe"
    ],
    "wearableDevices": [
      "Oura Ring",
      "Polar"
    ]
  },
  {
    "date": "Feb 19, 2026 4:52 AM UTC",
    "goals": "I am currently trying to implement a weight loss regimen.",
    "priceObjection": "",
    "wtpFactors": "I would want the most for my money for something that expensive.",
    "brandPerception": "Changing yourself in major ways",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.25,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:55 AM UTC",
    "goals": "Lose weight--gain muscle.",
    "priceObjection": "",
    "wtpFactors": "Cost. Have you seen the price of groceries?!",
    "brandPerception": "Alter my DNA! Biohacking. Not sure I like that name...",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:56 AM UTC",
    "goals": "I am currently working to lose weight. I’m focusing on overall health to change my lifestyle for the better from eating healthier to mental health",
    "priceObjection": "",
    "wtpFactors": "Proven results",
    "brandPerception": "To change yourself. It sounds computerized",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:57 AM UTC",
    "goals": "I want to start eating healthier and eating less at night so I can digest better",
    "priceObjection": "it's way too expensive for me",
    "wtpFactors": "make it more affordable",
    "brandPerception": "changing how you currently are",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:57 AM UTC",
    "goals": "I want to remain healthy and plan for the future. It means I want to do what I can now to avoid any needless medical issues.",
    "priceObjection": "",
    "wtpFactors": "The first is the cost. The 15.\\n Pages of\\n Options that you showed are all too expensive for me. The primary thing I need is a fitness structure recommendation.",
    "brandPerception": "Honestly, it sounds like a Sci-Fi movie.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:00 AM UTC",
    "goals": "My goal is to gain more muscles and increase upper body str",
    "priceObjection": "",
    "wtpFactors": "I like making monthly payments without having to worry about interest rates.",
    "brandPerception": "Sounds like alternative me. I've never heard of this",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1439,
    "priceDistribution": {
      "499": 0,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.7,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:03 AM UTC",
    "goals": "Need to get rid of parasites",
    "priceObjection": "",
    "wtpFactors": "Time to get healthy!",
    "brandPerception": "Rape",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1459,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 2,
      "1699": 6,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tempo"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:06 AM UTC",
    "goals": "I would like to lose a few pounds and have a healthier diet.",
    "priceObjection": "",
    "wtpFactors": "Having recommended by people I trust.",
    "brandPerception": "Someone chasing me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1235,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 4,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.727,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.636,
      "Recovery Sessions": 0.545,
      "Nutrition Tracking": 0.636
    },
    "gender": "Male",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:07 AM UTC",
    "goals": "My current personal health is pretty good, particularly for someone in my age group. I walk about seven miles five to six times per week and occasionally supplement my fitness with yoga and stationary cycling. One of my wellness goals is to start eating better.",
    "priceObjection": "That price is insane",
    "wtpFactors": "I would never ever pay for a program like this.",
    "brandPerception": "Weird",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 1466,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 1,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:08 AM UTC",
    "goals": "to eat healthier and exercise more",
    "priceObjection": "",
    "wtpFactors": "pricing",
    "brandPerception": "change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1212,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:13 AM UTC",
    "goals": "Eating clean and staying away from alcohol.",
    "priceObjection": "",
    "wtpFactors": "Money back guarantee",
    "brandPerception": "Not sure",
    "otherBrand": "",
    "otherDevice": "Zapp",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1224,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.583,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.583,
      "Body Composition Analysis": 0.417,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.417,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Zapp"
    ]
  },
  {
    "date": "Feb 19, 2026 5:14 AM UTC",
    "goals": "workout more, eat less, drink less alcohol",
    "priceObjection": "",
    "wtpFactors": "Mostly having the money to do it. I just had a vehicle repair for $1800 so i can't even consider something that's 1200 or 1400 or whatever right now. Priorities, you know?",
    "brandPerception": "to change yourself into something else...ideally the best version you can be.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:16 AM UTC",
    "goals": "Lose 50 more lbs and not have type 2 diabetes",
    "priceObjection": "",
    "wtpFactors": "It would have to be fairly priced and there has to be a lot of features.",
    "brandPerception": "It reminds me of an alter at a church",
    "otherBrand": "garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1186,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "garmin"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:16 AM UTC",
    "goals": "I have high cholesterol and a family history of diabetes so I need to get focused on getting healthier.",
    "priceObjection": "",
    "wtpFactors": "Exciting new workouts, a range of different types of workouts. Recipes.",
    "brandPerception": "I've never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.636,
      "Smart Biometrics Ring": 0.818,
      "Personalized Wellness Plan": 0.636,
      "Body Composition Analysis": 0.727,
      "Workout Sessions": 0.364,
      "Recovery Sessions": 0.727,
      "Nutrition Tracking": 0.636
    },
    "gender": "Female",
    "age": 52,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:20 AM UTC",
    "goals": "I am generally healthy, I do a lot of cardio and I eat well. My current goal is to keep myself healthy and continue on the track I am already on with my health. Trying to stay as active as I get older and retain the healthy lifestyle I have worked to build my whole life.",
    "priceObjection": "",
    "wtpFactors": "Demonstrable benefits, ideally I would like to try it for free to see how much it works, then only pay if I see that it is providing dividends for myself and my health.",
    "brandPerception": "It seems like a futuristic name for a brand that would help you to alter your image or health.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 946,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 42,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:21 AM UTC",
    "goals": "I am currently trying to lose weight and gain muscle. I am also trying to eat healthier to stave off any future health issues that may occur.",
    "priceObjection": "",
    "wtpFactors": "It would be great if it included a biometric ring to help me gain insights into my health journey. It would also be great to have a daily personalized wellness plan with attainable goals to achieve and a series of rewards for achieving the goals.",
    "brandPerception": "I think of a notification system that will tell me when it's time to do something.",
    "otherBrand": "Withings",
    "otherDevice": "Withings",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1191,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.917,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.833,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.583
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers",
      "Other",
      "Withings"
    ],
    "wearableDevices": [
      "Fitbit",
      "Other smart ring or fitness tracker",
      "Withings"
    ]
  },
  {
    "date": "Feb 19, 2026 5:37 AM UTC",
    "goals": "Trying to stay as healthy as possible while dealing with a stressful life that makes it hard for recreational exercise",
    "priceObjection": "",
    "wtpFactors": "Quality of the provider, proven results, money back guarantee at these prices",
    "brandPerception": "Never heard of it, sounds weird. This Me is fine!",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 892,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.733
    },
    "gender": "Male",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:38 AM UTC",
    "goals": "Tone body and muscles, lose a few pounds",
    "priceObjection": "",
    "wtpFactors": "Effectiveness and results",
    "brandPerception": "Not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1359,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 5,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:39 AM UTC",
    "goals": "My personal health goals are to eat healthy and exercise more",
    "priceObjection": "I feel the price point for this program is too expensive",
    "wtpFactors": "I might choose it if it's a very detailed plan of what's involved at a lower price point",
    "brandPerception": "When complete overhaul of your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$200,000 or more",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:39 AM UTC",
    "goals": "I want to lose 30 lbs and start eating better",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "The band alter bridge",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 582,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tempo",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:40 AM UTC",
    "goals": "Lose weight, reduce blood pressure and reduce medication",
    "priceObjection": "",
    "wtpFactors": "How bad the Dr. tells me my health is",
    "brandPerception": "Never heard of it before but it sounds a little sinister. Like a sci-fi company up to something",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.25,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.25,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 1
    },
    "gender": "Male",
    "age": 53,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:40 AM UTC",
    "goals": "Lose weight eat better",
    "priceObjection": "",
    "wtpFactors": "Equipment and resources",
    "brandPerception": "Different you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1146,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tempo"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 5:42 AM UTC",
    "goals": "My wellness goals are to gain 5 to 10 lbs, gain more muscle and flexibility and be able to pull and push my own bodyweight.",
    "priceObjection": "",
    "wtpFactors": "I am not really willing to pay for a health and wellness program.",
    "brandPerception": "I don't know what that is, it makes me think of drugs.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:43 AM UTC",
    "goals": "5000 steps every day",
    "priceObjection": "",
    "wtpFactors": "The cost and types of workouts. My personal preference is doing Pilates.",
    "brandPerception": "A fitness tracker.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:43 AM UTC",
    "goals": "Staying as healthy as possible.",
    "priceObjection": "",
    "wtpFactors": "It ensures I have all the data to maintain optimal health.",
    "brandPerception": "The phrase \"change me\" comes to mind.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1246,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 5,
      "1699": 0,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:49 AM UTC",
    "goals": "I am hoping to lose some weight. I also would like to get better. And I woudl like to get better sleep.",
    "priceObjection": "",
    "wtpFactors": "If I thought it would be worth it, I might be willing to pay for the program. It depends on the benefits that are involved.",
    "brandPerception": "I think of a program that would change a person.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 46,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:57 AM UTC",
    "goals": "I'm planning on joining a gym that recently opened in my area.  Also working on drinking more water and eating more fruit.",
    "priceObjection": "I would not pay this much for a program.",
    "wtpFactors": "A lower price and lots of items included.",
    "brandPerception": "Nothing, I've never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 57,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 5:57 AM UTC",
    "goals": "My personal health or wellness goals for this year are strengthen my respiratory system after having COVID, maintaining a health and balance diet and remembering to take time for myself. Also, to not stress over things I cannot control.",
    "priceObjection": "The benefits of these programs sound great but they’re beyond my budget.",
    "wtpFactors": "The factor that would influence me the most is the price. If it’s affordable for my income and it’s not going to break the bank, I may consider a program.",
    "brandPerception": "When I hear that phrase, I think of things that change the way your body looks and feels.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Student",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:58 AM UTC",
    "goals": "Maintain physical and mental health as I age and progress through hormonal changes",
    "priceObjection": "",
    "wtpFactors": "If it provided real usable data that I could use to benefit health and wellness",
    "brandPerception": "Help me make changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1226,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 5,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:02 AM UTC",
    "goals": "My goal is to get down to pre-pregnancy weight which is to lose 30 pounds.",
    "priceObjection": "",
    "wtpFactors": "No interest, monthly payments, discount if paid in full.",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:17 AM UTC",
    "goals": "I would like to start running more and lose 10 or 15 pounds",
    "priceObjection": "",
    "wtpFactors": "I would want to know the type of equipment they offer and how close the location is",
    "brandPerception": "An app that updates and changes your health profile as you exercise or meet goals",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1459,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 6:19 AM UTC",
    "goals": "I'm perimenopausal and have gained weight in the last few years. I'd like to drop about 30 pounds to be comfortable again.",
    "priceObjection": "",
    "wtpFactors": "I'd insist on a configuration that provided all of the functions available on the higher tiers. Some arrangements removed features on higher priced tiers, which makes no sense.",
    "brandPerception": "Sounds creepy, like it refers to spaying an animal. It seems hyperbolic.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1135,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 2,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.636,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.727,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.545,
      "Recovery Sessions": 0.818,
      "Nutrition Tracking": 0.455
    },
    "gender": "Female",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:22 AM UTC",
    "goals": "To gain muscle and get rid of fat",
    "priceObjection": "",
    "wtpFactors": "I don't know I really don't want to pay at all",
    "brandPerception": "No never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tempo",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:26 AM UTC",
    "goals": "I want to lose weight and get into shape and reduce my bad cholesterol",
    "priceObjection": "",
    "wtpFactors": "If it's cheap",
    "brandPerception": "Sounds weird",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:26 AM UTC",
    "goals": "I am looking to boost my energy levels, lower my stress levels, maintain a healthy weight, and eat healthy wholesome foods.",
    "priceObjection": "",
    "wtpFactors": "Price, payment terms, whether it includes workouts, nutrition tracking, and a wearable device, brand, user reviews",
    "brandPerception": "Changing the body in some way",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 991,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.583,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.583,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:28 AM UTC",
    "goals": "Want to be able to look better than I did the day before. I don’t want to put a timeline to it but I want to constantly improve myself",
    "priceObjection": "",
    "wtpFactors": "Want to look and feel my best it’s important I put myself in a good situation",
    "brandPerception": "Changing yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 949,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 1,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.643
    },
    "gender": "Female",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:33 AM UTC",
    "goals": "My personal goal is to lose weight naturally through exercise and nutrition.",
    "priceObjection": "",
    "wtpFactors": "I like the support that programs provide as long as they are genuine and not money hungry.",
    "brandPerception": "Artificial altering",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1159,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 4,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.267
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:45 AM UTC",
    "goals": "I'd like to get in more water, move more, and eat more natural foods.",
    "priceObjection": "at this price??? nawwww",
    "wtpFactors": "the value for the price, quality, ease of use",
    "brandPerception": "it sounds like sewing, or an app to find a seamstress or tailor",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:50 AM UTC",
    "goals": "Well, as I get older, since I am now officially past middle aged, I notice that it takes me a bit longer to do certain tasks than it did when I was younger, & I find that I’m more cautious simply because of a randomly developed irrational fear of injury.  However, oddly enough, I also have noticed that when my body has aches & pains, I am surprisingly more tolerant and take less medication than I may have when I was younger, which would suggest that despite the lower muscle density, the increase in effort to achieve the same physical result, and the larger calorie deficit necessary to simply maintain a consistent size due to slower metabolism, my stamina has actually increased, and my threshold for pain has gone up as well.  That being said, my ultimate health, fitness and wellness goals?   These I put into three separate actions needed:\nA) health = I would prefer to live the rest of my life as naturally as possible. Meaning, all of the products I put in & on my body (well, as much as possible, anyway) shall be free of synthetic dyes, fragrances, and harsh chemicals. Only pure essential oils for scent, and ingredients that I can pronounce and are sustainable, plant based and edible.  Also, no medications as much as humanly possible. The human body is truly an amazing machine. It can and does heal itself - without as much as a thought from you! - instinct kicking in well ahead of our brains ability to comprehend the mechanics of it; \nB) fitness = I have heard and had confirmed both by personal knowledge, and by second hand personal knowledge (some folks I know personally & others I know through another friend) that especially women, and especially as we age, if we lose any muscle mass, it’s that much harder to get it back, and eventually if we lose any muscle mass, it’s just gone.  Poof. No more. So, as the saying goes, it IS “use it or lose it!” In that way, one fitness goal is to lose as little muscle mass as possible for as long as possible!  Even if I have to work myself until I’m literally too tired to do anything more, I want to remain in strength! The other fitness goal?  I want to walk, stretch, bend myself into yoga positions, and dance until I literally am ready to leave this earth. I know I can - my grandma & grandpa did - so can I; and\nC) wellness = so, there’s this guy, perhaps you’ve heard of him, perhaps not - Anthony William. The medical medium. He has a book that I tell folks about all the time. It’s called “Life Changing Foods.”  Basically? Every single “problem” - be it disease, malaise, illness, injury, real or imagined, can be CURED with the proper foods. Not just symptoms alleviated, nor just a temporary bandage. CURED. HEALED. ERADICATED. I know that this has started to become more readily known in the past five years or so, but before this kind of thing was almost taboo!  I believe that he’s right. And so far, I’m fairly sure I can prove it, given my own personal experiences of healing. Additionally, this applies to more than just our physical selves. This idea that the body, given the right foods in the right amounts and combinations, coupled with cognitive calisthenics, if you will, such as therapy, meditation, mindfulness  and/or a combination thereof, can and does inherently heal itself, goes even further and, I believe, correlates directly to the brains own ability to rewire itself. Neuroscience has now proven what I’ve actually known my whole life (I just didn’t have the words for it before, and didn’t remember how…) - and that is that our brain, should it have a few pathways go berserk, run amok, and deviate from their original route, causing any number of chaotic instinctual responses, the brain, given the space, and time, in calm and deliberate mindful meditation, can achieve a state, almost liminal, yet still cognitive and not in an actual trance state, where one can intentionally reroute those pathways that have gone awry. I am living proof as I’ve done it.  Interestingly enough, the pharmaceutical companies have known this for some time now - I gander to say decades, in fact - yet have failed to even mention it as a remote possibility!  Why?  Well, think about it. People who can , with their own bodies, and without really thinking about it, and with their own brains, simply by eating the foods that the body and brain actually want (if you listen really close? Your body and brain will tell you exactly what they want for optimal performance!) and without ANY medications of any kind, even advil, inherently, efficiently and completely, heal themselves, and restore their own brains, to live longer, more physically healthful, less riddled with pain, and ultimately happier, lives, well, they are simply bad for business. The drug companies want to keep us SICK. & dependent upon them and all the synthetic chemicals they have concocted to alter our world to “fit” us. When truly?  We don’t need to alter ourselves, nor does our physical natural environment...",
    "priceObjection": "",
    "wtpFactors": "The DNA report hands down. That (I’ve had my own done before the current treatment I’m utilizing with my therapist, who is a neuroscientist and innovative healer, using a combination of methods, both modern, and ancient, in his practice. Also, the ease of use - the more personalized info the better, as well as more interactive and on demand materials.",
    "brandPerception": "It’s either alluding to a fake me, or an alternate me. Or is it that I can alter me with the assistance of said whatever product is being sold?",
    "otherBrand": "",
    "otherDevice": "It’s generic. I also have a nuropod.",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "It’s generic. I also have a nuropod."
    ]
  },
  {
    "date": "Feb 19, 2026 6:54 AM UTC",
    "goals": "None",
    "priceObjection": "",
    "wtpFactors": "None",
    "brandPerception": "Nothing much",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1452,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 4,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:58 AM UTC",
    "goals": "stay fit and mentally balanced",
    "priceObjection": "",
    "wtpFactors": "number of benefits",
    "brandPerception": "nothing specific",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:01 AM UTC",
    "goals": "My goal is to keep my back safe and keep my health on target through physical activity and mental health support",
    "priceObjection": "",
    "wtpFactors": "The perceived benefit outways the cost and if has proven to work then it makes sense",
    "brandPerception": "That it’s a program is  in alignment and will result in changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:08 AM UTC",
    "goals": "Get out of bed and do something outside of work for myself. Lose weight.",
    "priceObjection": "",
    "wtpFactors": "Good support and warranty",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1207,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.583,
      "Personalized Wellness Plan": 0.583,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:15 AM UTC",
    "goals": "My current health goal is to walk 8,000 steps daily and incorporate two 30-minute strength training sessions per week to improve cardiovascular health",
    "priceObjection": "None are appealing",
    "wtpFactors": "Programs emphasizing sustainable habit change",
    "brandPerception": "Personal transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:17 AM UTC",
    "goals": "I am currently trying to lose 20 pounds. I just signed up for BODI to help me with this goal",
    "priceObjection": "",
    "wtpFactors": "if it has enough aspects to keep me motivated but I doubt I would ever pay 1499",
    "brandPerception": "it will alert you about workouts, nutrition, etc",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:25 AM UTC",
    "goals": "I would like to lose weight",
    "priceObjection": "",
    "wtpFactors": "If it really helped me reach my goals and if the plan was covered by my health insurance",
    "brandPerception": "making me into something i am not",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:27 AM UTC",
    "goals": "My current goals are to maintain a consistent gym routine three times a week and improve my overall cardiovascular health through regular hiking. I also aim to stay disciplined with my multivitamin intake and keep a balanced diet.",
    "priceObjection": "",
    "wtpFactors": "The most important factors for me would be the overall cost-effectiveness and the ability to see measurable results in my fitness levels. I also value programs that offer flexibility to fit into my busy work schedule.",
    "brandPerception": "It sounds like a brand focused on personal transformation or self-improvement, possibly through technology or health services. The name suggests a way to change or better oneself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1079,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 31,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:29 AM UTC",
    "goals": "I would like to lose about 40 lbs. I would like to really start eating better and being more active because I'm getting older and it worries me that years of not taking care of myself like that will catch up to me",
    "priceObjection": "",
    "wtpFactors": "If it allowed me to make payments for 12 months with no interest with the most amount of features",
    "brandPerception": "I love that name. It is the perfect name for a wellness app because it explains exactly what you are trying to do.....\"alter yourself\"",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:30 AM UTC",
    "goals": "to lose 70 pounds",
    "priceObjection": "",
    "wtpFactors": "great variety of benefits.",
    "brandPerception": "changing things for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1419,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 4,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 39,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:32 AM UTC",
    "goals": "My main goal is to lose a lot of weight. My goal is to get down to 199 or less pounds  by time i turn 50. i am taking a GLP-1 medication, eating healthy, dieting and exercising.",
    "priceObjection": "",
    "wtpFactors": "Well, after seeing the prices of these programs, I changed my mind, i would not consider them at all. Even with the financing/stretch pays, i can't afford another bullet point on my budget.",
    "brandPerception": "This is a fairly broad term. This could mean to change any part of a person, whether it's their personality, mental health, physical health, etc.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 1
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:37 AM UTC",
    "goals": "Pretty good. I exercise and watch what I eat",
    "priceObjection": "",
    "wtpFactors": "Aford",
    "brandPerception": "Never heard of ir",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:43 AM UTC",
    "goals": "I would like to start tracking my fitness. I'd like to gain strength. I'd also like to have a better state of mind.",
    "priceObjection": "",
    "wtpFactors": "All of the factors listed",
    "brandPerception": "Something that would help better me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 1,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 28,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:44 AM UTC",
    "goals": "I would like to continue to maintain walking and running 20,000 steps a day",
    "priceObjection": "",
    "wtpFactors": "If it was available at a discount or I could get a free trial.",
    "brandPerception": "A program that can help to change the way you look and feel.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 772,
    "priceDistribution": {
      "499": 5,
      "999": 6,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.636,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.455,
      "Body Composition Analysis": 0.727,
      "Workout Sessions": 0.545,
      "Recovery Sessions": 0.636,
      "Nutrition Tracking": 0.545
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:50 AM UTC",
    "goals": "I want to lose weight. I want to lose 15 lbs. I will do this through diet and exercise",
    "priceObjection": "",
    "wtpFactors": "It needs to track biometric, nutrition and workout aspect. Those are the most important things right now for me.",
    "brandPerception": "Something that would aim to change me for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1106,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 3,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.643,
      "Body Composition Analysis": 0.929,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.929,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:58 AM UTC",
    "goals": "Losing 20 pounds",
    "priceObjection": "Too expensive",
    "wtpFactors": "Cost",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 7,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:13 AM UTC",
    "goals": "long term health",
    "priceObjection": "",
    "wtpFactors": "Customized & personal support",
    "brandPerception": "change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1222,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.538,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.308,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.692,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.615
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:15 AM UTC",
    "goals": "Personal health is very good and I'd like to keep using prevented measures to keep it that way.",
    "priceObjection": "",
    "wtpFactors": "The accuracy of the item and the wellness items I'm willing to track.",
    "brandPerception": "Fix my nutritional plans to make a greater version of myself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 777,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.444,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.556,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.444
    },
    "gender": "Female",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:29 AM UTC",
    "goals": "Ideally, I would like to alleviate stress and remove myself from my current home situation, focusing on eating healthier, losing flabby weight",
    "priceObjection": "",
    "wtpFactors": "Perks, benefits, and pricing structure",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1379,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:30 AM UTC",
    "goals": "none at this time",
    "priceObjection": "",
    "wtpFactors": "none",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 7,
      "999": 7,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 9:12 AM UTC",
    "goals": "To try to stay more consistent lifting weights and possibly try pilates as well. I would like to lose more body fat while maintaining muscle too",
    "priceObjection": "",
    "wtpFactors": "Getting a customized plan i actually need rather than a set plan that may have things I dont need and end up paying for wasting money in the long",
    "brandPerception": "Change someone",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 9:24 AM UTC",
    "goals": "To get healthy and be able to fully enjoy life again.",
    "priceObjection": "I would never pay this amount of money for this program I wouldn't pay 499 either.",
    "wtpFactors": "Nothing I will do this on my own if I want to accomplish a health goal I'll discuss it with my doctor and go from there",
    "brandPerception": "I've never heard this term, company, or brand before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "Just trying to stay alive, keep moving, do what I can when I'm able",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Other",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 9:41 AM UTC",
    "goals": "eating better and exercising more",
    "priceObjection": "",
    "wtpFactors": "if its really good",
    "brandPerception": "better health and fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1712,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 1,
      "1699": 5,
      "1899": 8
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 40,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 9:50 AM UTC",
    "goals": "My personal health and fitness goals is to gain a comfortable weight that is both healthy and fit for my body frame. My wellness includes a full circle of synchronicity wellness which includes physical, mental emotional and spiritual well being",
    "priceObjection": "",
    "wtpFactors": "The influence would primarily be about the flexible payment options and whether or not I have to pay interest with these payments.",
    "brandPerception": "AlterMe is a device that is able to provide a comprehensive plan of personalized health and fitness for each individual",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 9:54 AM UTC",
    "goals": "I am a healthy eating gym goer",
    "priceObjection": "",
    "wtpFactors": "reports",
    "brandPerception": "working out",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1279,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 1,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 39,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 9:55 AM UTC",
    "goals": "To lose some extra weight. Maintain my weight as I am losing. To live a healthier life style that includes nutrition, exercise, and mental well being.",
    "priceObjection": "",
    "wtpFactors": "For the prices you were showing, you should get all of the options. Testimonials from actual participants. Recommended by my physician. Affordable monthly plan. A plan that moves from weight loss/muscle development to maintenance.",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 10:11 AM UTC",
    "goals": "I'm trying to lose weight.",
    "priceObjection": "",
    "wtpFactors": "Proven results, reputable brand, good reviews.",
    "brandPerception": "Sounds futuristic",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 642,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.857,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 10:11 AM UTC",
    "goals": "I am looking to get healthier and lose some weight and gain strength.",
    "priceObjection": "",
    "wtpFactors": "The program would have to include nutrition and home workout sessions.",
    "brandPerception": "Altering mind and body.",
    "otherBrand": "Fitness Pal",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers",
      "Other",
      "Fitness Pal"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 10:18 AM UTC",
    "goals": "I try to eat high protein less processed foods. It’s important to me to reaf labels and know what I’m consuming.",
    "priceObjection": "",
    "wtpFactors": "I’m interested in the views of what people say about the program and also that it would be easy to follow and monthly payment plans that were interest free",
    "brandPerception": "I think capacitive change for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1259,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 7,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 10:20 AM UTC",
    "goals": "Trying to lose weight, boost metabolism, and start exercising to be healthy.",
    "priceObjection": "",
    "wtpFactors": "This is insane. Hundreds of- or even over a thousand dollars for a wellness plan? Why?! You can just google this stuff for free and track it yourself. I don’t understand.",
    "brandPerception": "That you’re not good enough the way you are and need to be changed. This is a horrible bar.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 10:22 AM UTC",
    "goals": "I'm focused on trying to get enough sleep, maintain my weight, be more flexible and increase muscle strength through increased physical activity, as well as keep myself well hydrated and consume a healthy, well-balanced diet.",
    "priceObjection": "",
    "wtpFactors": "It would depend on what it includes and if I felt it would be meaningful and allow me to quickly improve my health and wellbeing, would be easy and intuitive to use, and would be affordable.",
    "brandPerception": "I think of changing one's body or mindset or adapting it into something else.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 10:24 AM UTC",
    "goals": "I have been eating healthy and exercising trying to lose 40 pounds",
    "priceObjection": "",
    "wtpFactors": "To improve my health working out losing weight",
    "brandPerception": "To help alter the body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1012,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 4,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 10:25 AM UTC",
    "goals": "Trying to stay healthy and lose some weight",
    "priceObjection": "",
    "wtpFactors": "Results proven",
    "brandPerception": "Nothing much",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1412,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 4,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 53,
    "income": "$200,000 or more",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 10:30 AM UTC",
    "goals": "To stay healthy and syrong as I age.",
    "priceObjection": "",
    "wtpFactors": "Affordability",
    "brandPerception": "Premium",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1152,
    "priceDistribution": {
      "499": 3,
      "999": 6,
      "1499": 4,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Ladder",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 10:31 AM UTC",
    "goals": "I would like to exercise more consistently.",
    "priceObjection": "",
    "wtpFactors": "I don't think I would actually pay for any of these programs.",
    "brandPerception": "I've never heard of this before.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 40,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 10:32 AM UTC",
    "goals": "To lose fat and gain more muscle",
    "priceObjection": "",
    "wtpFactors": "If I got to customize my needs and was able to pay in full",
    "brandPerception": "Nothing in particular",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1442,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.143,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.643
    },
    "gender": "Male",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 10:32 AM UTC",
    "goals": "Lose weight, gain strength, stay hydrated, keep my heart in check.",
    "priceObjection": "",
    "wtpFactors": "There is no world I would pay those prices for those plans.",
    "brandPerception": "No clue what that is",
    "otherBrand": "I use Lose it for Food and Map my Run for workouts and Apple Health",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers",
      "Other",
      "I use Lose it for Food and Map my Run for workouts and Apple Health"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 10:47 AM UTC",
    "goals": "My wellness goal is to lose about 40 pounds.. It will help decrease my blood pressure",
    "priceObjection": "",
    "wtpFactors": "A price that I feel is reasonable.. Close to my home,",
    "brandPerception": "Change my body and mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1252,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 10:51 AM UTC",
    "goals": "To lose weight but also not affect my supply when nursing",
    "priceObjection": "",
    "wtpFactors": "Personalized plans",
    "brandPerception": "It means to change yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1086,
    "priceDistribution": {
      "499": 4,
      "999": 6,
      "1499": 1,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 10:55 AM UTC",
    "goals": "i want to run a half marathon",
    "priceObjection": "",
    "wtpFactors": "effectiveness and reviews",
    "brandPerception": "change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 7,
      "999": 7,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.357,
      "Workout Sessions": 0.357,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 10:56 AM UTC",
    "goals": "To gain muscle",
    "priceObjection": "",
    "wtpFactors": "Full composition analysis and workout sessions",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.375,
      "Workout Sessions": 0.875,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 34,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 11:02 AM UTC",
    "goals": "I aim to lose weight naturally without pills or injections.  I will do this by stretching, walking, strength training, and cardio combined with eating clean.",
    "priceObjection": "",
    "wtpFactors": "something that would include steps to improve your workouts and correct foods to eat",
    "brandPerception": "nothing really, never heard of this term, but if I would guess it would mean \"change\" me",
    "otherBrand": "Bowflex",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1322,
    "priceDistribution": {
      "499": 1,
      "999": 5,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.692,
      "Smart Biometrics Ring": 0.923,
      "Personalized Wellness Plan": 0.462,
      "Body Composition Analysis": 0.692,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.462
    },
    "gender": "Male",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Never",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Other",
      "Bowflex"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:06 AM UTC",
    "goals": "Juicing and working out",
    "priceObjection": "Free",
    "wtpFactors": "None",
    "brandPerception": "Never",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 11:07 AM UTC",
    "goals": "Be healthier",
    "priceObjection": "Too much",
    "wtpFactors": "My job and bills",
    "brandPerception": "Current me",
    "otherBrand": "",
    "otherDevice": "Motorola",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Motorola"
    ]
  },
  {
    "date": "Feb 19, 2026 11:09 AM UTC",
    "goals": "To be more active and exercise more",
    "priceObjection": "",
    "wtpFactors": "It included all the tools you need",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 11:10 AM UTC",
    "goals": "Reduce inflammation, lose weight, have more energy",
    "priceObjection": "",
    "wtpFactors": "The price, how effective it has been for others, if it is realistic for my daily routine long term",
    "brandPerception": "It is designed to change your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 11:16 AM UTC",
    "goals": "I will describe my personal health to find better way to stay healthy and find nutrition that would help me to keep my goal",
    "priceObjection": "",
    "wtpFactors": "how many elements that include in my wellness health such as exercise and nutrient associated with it",
    "brandPerception": "none I can think of",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1259,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 3,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 11:20 AM UTC",
    "goals": "I am trying to improve my health and wellness, especially now that im getting older",
    "priceObjection": "",
    "wtpFactors": "Getting great tesults",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1392,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 6,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 11:33 AM UTC",
    "goals": "I have recently been trying to loose weight but it hasn't been working so well",
    "priceObjection": "",
    "wtpFactors": "A good deal and a guarantees fixes rate",
    "brandPerception": "To change it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1012,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:36 AM UTC",
    "goals": "To get rid of the remaining visceral fat in my be",
    "priceObjection": "",
    "wtpFactors": "The body analysis and nutrition tracking",
    "brandPerception": "Changing you quality of life through nutrition and exercise.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 1287,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.375,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.875,
      "Nutrition Tracking": 1
    },
    "gender": "Male",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 11:37 AM UTC",
    "goals": "I am dieting and exercising. I hope to lose weight and improve both my physical and mental health.",
    "priceObjection": "Too expensive",
    "wtpFactors": "How much it cost",
    "brandPerception": "I've never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:39 AM UTC",
    "goals": "Get healrhy",
    "priceObjection": "",
    "wtpFactors": "Nutrition",
    "brandPerception": "Police",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1378,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 4,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.714,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:40 AM UTC",
    "goals": "Lose weight to take pressure off my body and feel better.",
    "priceObjection": "",
    "wtpFactors": "Programs that are tailored to my body and intensity needs",
    "brandPerception": "I have never heard of it. Sounds like self improve",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 919,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 1,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:40 AM UTC",
    "goals": "I want to be as healthy as possible a d .ake my growing old an easy transi",
    "priceObjection": "",
    "wtpFactors": "These programs are all very expensive and not what I look for.  I am not trying to lose weight at all.  Just get to ed and healthy.  I would never use a bio ring, it is not for me",
    "brandPerception": "I dont like it.  Its like change me.  How about som3thing that says strengthen",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 11:42 AM UTC",
    "goals": "maintain my weight, age gracefully, help prevent future health issues",
    "priceObjection": "i don't want to pay",
    "wtpFactors": "none.  i will not do it",
    "brandPerception": "nothing comes to mind.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 11:42 AM UTC",
    "goals": "manage stress and current fitness level",
    "priceObjection": "",
    "wtpFactors": "sleep tracking, stress, workouts, stretching",
    "brandPerception": "change, optimize",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 782,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.833,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 11:45 AM UTC",
    "goals": "My wellness goals is to exercise more to bring down my blood pressure and drink as much water as I can and also eat the right way",
    "priceObjection": "",
    "wtpFactors": "I most willing to pay for the the cheaper price that I can manage",
    "brandPerception": "Altered have everything that you need to stay on track",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 1313,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 0,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.714,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.286
    },
    "gender": "Female",
    "age": 33,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:50 AM UTC",
    "goals": "My goals are to walk everyday, it helps with my anxiety. My goal is 10,000 steps per day. I also try and do a simple exercise routine everyday.I've added spinach smoothies to my rotation to add more vegetables and fruit.  I focus on my mental health so I am able to focus on my physical health. I only drink water and try and rem9ve bread products from my meals as much as possible.",
    "priceObjection": "",
    "wtpFactors": "Workout plans, videos",
    "brandPerception": "It seems like its help",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1226,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.545,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.818,
      "Body Composition Analysis": 0.818,
      "Workout Sessions": 0.636,
      "Recovery Sessions": 0.727,
      "Nutrition Tracking": 0.727
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 11:54 AM UTC",
    "goals": "I'm looking to increase muscle energy and lose weight.",
    "priceObjection": "",
    "wtpFactors": "Th smart ríng and personalized wellness program.",
    "brandPerception": "Getting cosmetic surgery.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1499,
    "priceDistribution": {
      "499": 0,
      "999": 4,
      "1499": 4,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 11:55 AM UTC",
    "goals": "I am trying to eat healthier. My exercise is good.",
    "priceObjection": "It’s too expensive",
    "wtpFactors": "Nothing. I can’t afford it.",
    "brandPerception": "Changing my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 11:55 AM UTC",
    "goals": "I'm in a weight loss journey. I exercise 5 times a week and keep my diet low in sugar and carbohydrates.",
    "priceObjection": "",
    "wtpFactors": "A program that includes a personalized nutrition plan, a workout plan, and a coach.",
    "brandPerception": "Change your Lifestyle",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1439,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 3,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 33,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 11:56 AM UTC",
    "goals": "Most importantly I'm looking to feel the best I can, have more energy and lose weight.",
    "priceObjection": "I would absolutely not purchase anything. I know how to get in shape for free.",
    "wtpFactors": "If it were free",
    "brandPerception": "A fitness program",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 11:56 AM UTC",
    "goals": "Always doing my best to stay healthier",
    "priceObjection": "",
    "wtpFactors": "No money need up front",
    "brandPerception": "Just for me personalize",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1039,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 3,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:02 PM UTC",
    "goals": "to imtove my overall health",
    "priceObjection": "",
    "wtpFactors": "ease of use",
    "brandPerception": "never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1191,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 3,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.538,
      "Smart Biometrics Ring": 0.846,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.308,
      "Nutrition Tracking": 0.769
    },
    "gender": "Female",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tempo",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:03 PM UTC",
    "goals": "I would like to lose weight and exercise more",
    "priceObjection": "",
    "wtpFactors": "I am getting older",
    "brandPerception": "Make me better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 846,
    "priceDistribution": {
      "499": 7,
      "999": 6,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:04 PM UTC",
    "goals": "I'd like to lose a few pounds. And tone up my legs and arms.",
    "priceObjection": "",
    "wtpFactors": "If it was super cheap",
    "brandPerception": "Plastic surgery \nPaper dolls",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:07 PM UTC",
    "goals": "healthy eater, daily exercise",
    "priceObjection": "",
    "wtpFactors": "offers available to assist i. your goals",
    "brandPerception": "assists in the cha yes you’re looking for",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:09 PM UTC",
    "goals": "My goal is to increase strength and overall well being to decrease fatigue and symptoms.",
    "priceObjection": "",
    "wtpFactors": "Ensuring that I get the most out of my payments as budgets are tight.",
    "brandPerception": "I have not heard of this brand but it sounds like \"change me\" which I'm not sure I like",
    "otherBrand": "",
    "otherDevice": "From amazon",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 872,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "From amazon"
    ]
  },
  {
    "date": "Feb 19, 2026 12:10 PM UTC",
    "goals": "I want to maintain my weight and get into better health generally",
    "priceObjection": "",
    "wtpFactors": "What is included and what payment options they have",
    "brandPerception": "I have never heard of this",
    "otherBrand": "",
    "otherDevice": "Generic  Chinese model",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.357,
      "Personalized Wellness Plan": 0.643,
      "Body Composition Analysis": 0.714,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Generic  Chinese model"
    ]
  },
  {
    "date": "Feb 19, 2026 12:10 PM UTC",
    "goals": "I am working on eating healthier and making movement a priority",
    "priceObjection": "",
    "wtpFactors": "I would have to be able to afford it a lot more. I cannot right now.",
    "brandPerception": "Never heard of it, not sure what it refers to",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:13 PM UTC",
    "goals": "Id like to have more energy and be in sh",
    "priceObjection": "",
    "wtpFactors": "Cost and effective",
    "brandPerception": "To fix or ch",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:15 PM UTC",
    "goals": "Losing weight is a priority. Another priority is healthy eating habits. This would be the best solution for good overall health.",
    "priceObjection": "",
    "wtpFactors": "Proven success rates.",
    "brandPerception": "Body improvements.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:19 PM UTC",
    "goals": "I recently cut back on alcohol so that is my main focus right now",
    "priceObjection": "",
    "wtpFactors": "No interest. Everyone already has enough bills accumulating interest, why would I want another one",
    "brandPerception": "Nothing. Is that a transvestite program? It would not catch my atten",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1226,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.364,
      "Smart Biometrics Ring": 0.364,
      "Personalized Wellness Plan": 0.364,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.636,
      "Recovery Sessions": 0.455,
      "Nutrition Tracking": 0.545
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:19 PM UTC",
    "goals": "I want to continue to work out 5-6 days a week. I’m trying to limit sweets and packaged food.",
    "priceObjection": "",
    "wtpFactors": "Cost and exercise sessions offered.",
    "brandPerception": "I am not familiar with it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:20 PM UTC",
    "goals": "working out regularly and staying fit and healthy",
    "priceObjection": "expensive",
    "wtpFactors": "cost",
    "brandPerception": "change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:22 PM UTC",
    "goals": "Staying in shape and eating healthy",
    "priceObjection": "",
    "wtpFactors": "Nothing really. I would not pay that much to be honest. If I really had to, I would be I retested in the nutrition plan and recovery process",
    "brandPerception": "I have never heard of it but if I were to go by the name, it means a weight loss plan that will alter one’s body with the aid of all the various programs mentioned previously.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 920,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.643,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.643
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:22 PM UTC",
    "goals": "my current goals are losing weight, eating healthier, getting back to exercise routine, and getting better sleep.",
    "priceObjection": "",
    "wtpFactors": "Having well known trainers that I like and motivate me",
    "brandPerception": "Something about changing myself",
    "otherBrand": "Bodi",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.417,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.417,
      "Recovery Sessions": 0.583,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom",
      "Other",
      "Bodi"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:23 PM UTC",
    "goals": "Lose a few pounds and run a half marathon in April.",
    "priceObjection": "I’m not paying that.",
    "wtpFactors": "Price. Price is the biggest thing. It’s cheap to throw on some shoes and run.  The bells and whistles aren’t needed nor do they need to be paid for.",
    "brandPerception": "Someone getting changed. But not for the better. Like someone getting beat up.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 45,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:23 PM UTC",
    "goals": "My current health and wellness goals is to remain athletically in-shape by jogging and lifting weights four to five times a week.  I also maintain my weight by eating more protein and following a low-calorie diet.",
    "priceObjection": "",
    "wtpFactors": "It was recommended by a physician and I was considered extremely overweight that needed daily assistance to get around.",
    "brandPerception": "personalized, DNA-based, and biometric-driven approach to health.  Tailored workouts based on your genetic profile.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 1421,
    "priceDistribution": {
      "499": 0,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.778,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.444
    },
    "gender": "Male",
    "age": 54,
    "income": "$200,000 or more",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:25 PM UTC",
    "goals": "Keep my A1c and blood pressure under control",
    "priceObjection": "",
    "wtpFactors": "Accuracy",
    "brandPerception": "Nothing",
    "otherBrand": "Samsung fitness tracker",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1019,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Other",
      "Samsung fitness tracker"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:26 PM UTC",
    "goals": "Lose weight and then maintain",
    "priceObjection": "",
    "wtpFactors": "What's included",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Never",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:28 PM UTC",
    "goals": "I need to get healthier and with that lose weight",
    "priceObjection": "I’m not will to spend that much",
    "wtpFactors": "If I applied myself I’d be able to do this myself. I’m not willing to spend that much money on it",
    "brandPerception": "I don’t love it. Alter sounds cringe",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 57,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:30 PM UTC",
    "goals": "Too work out and excercise daily too feel good and get myself where I need to be health wise",
    "priceObjection": "",
    "wtpFactors": "Too have better gealth",
    "brandPerception": "I wanna know all it has to offer",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1106,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 1,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:30 PM UTC",
    "goals": "Lose weight, eat better",
    "priceObjection": "",
    "wtpFactors": "Nutrition help and accountability",
    "brandPerception": "Science",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:31 PM UTC",
    "goals": "To be healthy and eat good",
    "priceObjection": "",
    "wtpFactors": "Would pay for it only it showed results",
    "brandPerception": "Changing your life style for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1479,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 4,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:33 PM UTC",
    "goals": "I have to get 10,000 steps a day no matter what. I try my absolute hardest to eat in moderation and enjoy the foods I love without over doing it. I go for a walk almost every day.",
    "priceObjection": "This is way too expensive and more than I afford.",
    "wtpFactors": "If it’s very cheap and if it includes a lot of various things.",
    "brandPerception": "A 180 degree change of your body and appearance.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.167
    },
    "gender": "Female",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:35 PM UTC",
    "goals": "I really don't exercise or watch what I eat. Not big into fitness and healthy eating.",
    "priceObjection": "Not something I need",
    "wtpFactors": "if it was free",
    "brandPerception": "Change in habits and routines",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:38 PM UTC",
    "goals": "Manage ongoing chronic health conditions.",
    "priceObjection": "",
    "wtpFactors": "The cost",
    "brandPerception": "I think of bioengineering, which makes me apprehensive.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 50,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:42 PM UTC",
    "goals": "My main goal is to make sure I can maintain good muscle strength and endurance.",
    "priceObjection": "",
    "wtpFactors": "I like to have assurance that other people have used and highly recommend this service.",
    "brandPerception": "A way to change your lifestyle to be more healthy and energtic.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 4,
      "1699": 5,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 12:42 PM UTC",
    "goals": "My personal goals are to eat healthy and remember to take my vitamins. I am also trying to be more active on a daily basis and tracking my activity.",
    "priceObjection": "",
    "wtpFactors": "Price and payment plan would be the driving gator on whether I would or could purchase a program. In addition, I would want it to have built in programs I could choose from that could be tailored to me needs and current status.",
    "brandPerception": "That actually sounds pretty negative to me. It gives me the impression that you want to be charged instead on improved. Fitness plans to me are about getting better not about changing who I am.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 642,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.857,
      "Workout Sessions": 0.857,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:44 PM UTC",
    "goals": "to lose weight and to lose my stomach and to get into shape",
    "priceObjection": "",
    "wtpFactors": "I don't want no bills",
    "brandPerception": "I am doing something after me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 7,
      "999": 6,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 12:53 PM UTC",
    "goals": "I have type 2 diabetes & hashimotos. I’m overweight as well. Just turned 50 & really trying to lower my weight & blood sugars",
    "priceObjection": "",
    "wtpFactors": "Not much as I’m on a very tight budget as a single lady with a new mortgage",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 12:58 PM UTC",
    "goals": "To lose weight fast",
    "priceObjection": "",
    "wtpFactors": "Cashback",
    "brandPerception": "Lose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1252,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:00 PM UTC",
    "goals": "continue losing weight and eat healthier",
    "priceObjection": "",
    "wtpFactors": "illness",
    "brandPerception": "no idea",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:00 PM UTC",
    "goals": "My current personal health or wellness goal is trying to reduce stress.",
    "priceObjection": "",
    "wtpFactors": "The ability to see real time data and results. Also the ability to incur no interest when paying.",
    "brandPerception": "I think of an active program when I hear this term.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 979,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 4,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:02 PM UTC",
    "goals": "Gain muscle, lose weight",
    "priceObjection": "",
    "wtpFactors": "Coat and effectiveness",
    "brandPerception": "Na",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:04 PM UTC",
    "goals": "To lose 10 lbs. To continue to improve my endurance. Continue weightlifting every 3 days. To stretch and meditate/pray multiple times every day.",
    "priceObjection": "",
    "wtpFactors": "The ability to adapt to my changing health needs. Workout programs and nutrition tracking are a must.",
    "brandPerception": "It sounds like a transformation program. It does not inspire me to learn more. I want something that makes me better. Not completely change me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 1042,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.857,
      "Workout Sessions": 0.286,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.714
    },
    "gender": "Male",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:05 PM UTC",
    "goals": "At this time I'm looking to lose a small bit of weight perhaps 20 lb and continue maintaining my fitness routine as I am getting older it's important to retain my muscle mass.",
    "priceObjection": "",
    "wtpFactors": "I typically would not pay this much money for any fitness program it's way too expensive. The only thing that would make it worth it is if I receive valuable customized information pertaining to my specific body which would greatly improve my fitness and weight goals",
    "brandPerception": "This makes me think of a program design to change your",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:05 PM UTC",
    "goals": "To eat healthier and exercise regularly. I also want to work on meditation and have started a journal",
    "priceObjection": "",
    "wtpFactors": "If the programs will actually work and includes all the important tracking I need, I would be willing to pay a little more",
    "brandPerception": "I’ve never heard of it but it sounds like it would help me loose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:06 PM UTC",
    "goals": "To help w my mental health",
    "priceObjection": "",
    "wtpFactors": "If it works",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1279,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 28,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Ladder"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:06 PM UTC",
    "goals": "I want to lose a lot of weight and start feeling better about myself and fit better into my clothes",
    "priceObjection": "",
    "wtpFactors": "It would help me to lose weight l, give personalized meal planning and a coach to help me thro",
    "brandPerception": "It sounds like a way to change the way your vody",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.267
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:06 PM UTC",
    "goals": "To get more toned and stronger muscle",
    "priceObjection": "",
    "wtpFactors": "Affordability and n3ed for health",
    "brandPerception": "Changing of mind and body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 642,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.286,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.143,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:07 PM UTC",
    "goals": "I need to start exercising and eating healthier because I have a few medical issues that losing weight would help. I hope to accomplish this soon",
    "priceObjection": "",
    "wtpFactors": "None because I don't have the money to waste on this. I can exercise and eat right on my own if I want to",
    "brandPerception": "I have no clue what that is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:08 PM UTC",
    "goals": "To loose weight and eat more healthy.",
    "priceObjection": "I can’t afford to buy the healthy groceries. How would I afford the wellness program.?",
    "wtpFactors": "That it was covered by insurance",
    "brandPerception": "No idea never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:08 PM UTC",
    "goals": "I am training for my first half marathon",
    "priceObjection": "",
    "wtpFactors": "If it's actually beneficial and fits my goals",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "Training for a running event",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Other",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 1:09 PM UTC",
    "goals": "I have been fasting for years and I find that is making a huge change in my life and health for many positive reasons",
    "priceObjection": "",
    "wtpFactors": "the complete package the tips and tricks the tracking",
    "brandPerception": "It makes me think of a seemstress",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 699,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.7,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.2
    },
    "gender": "Male",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:09 PM UTC",
    "goals": "I'm trying to maintain my current weight but adjust my diet in such a way that I naturally build more muscle and pack less fat",
    "priceObjection": "",
    "wtpFactors": "Price and features. Comparative value against other options. Proven results/reviews and recommendations from ongoing and satisfied users",
    "brandPerception": "Me in an altered, and preferably better, state",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.167,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.833
    },
    "gender": "Male",
    "age": 33,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:11 PM UTC",
    "goals": "Working on small exercise spurts.  And eating fruits and veggies",
    "priceObjection": "",
    "wtpFactors": "Would need to be affordable.  Because money is tight and the prices shown I really wouldn't pay for.",
    "brandPerception": "I have never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 1088,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 1,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.556,
      "Personalized Wellness Plan": 0.556,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.556,
      "Recovery Sessions": 0.889,
      "Nutrition Tracking": 0.778
    },
    "gender": "Female",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Student",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 1:15 PM UTC",
    "goals": "use less bad products, eat healthier",
    "priceObjection": "",
    "wtpFactors": "the cost",
    "brandPerception": "help me be better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 986,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:16 PM UTC",
    "goals": "I want to gain weight and get toned while building muscle",
    "priceObjection": "",
    "wtpFactors": "the price",
    "brandPerception": "I have no idea",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:16 PM UTC",
    "goals": "Losing weight and gaining muscle to be stronger",
    "priceObjection": "",
    "wtpFactors": "Cost, nutrition and wearability",
    "brandPerception": "Wake up like an alarm",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1366,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:18 PM UTC",
    "goals": "Good stuff to try.",
    "priceObjection": "",
    "wtpFactors": "great program",
    "brandPerception": "Amazing product",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1132,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 4,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:18 PM UTC",
    "goals": "My goals are to find ways to eat healthier on an ever tightening budget due to the economy. Improve planning of workout activities instead of trying to squeeze them in",
    "priceObjection": "",
    "wtpFactors": "If it comes with workouts, nutrition advice, adjusts as needed, stretching because it is important especially as you get older. Mostly the accountability while receiving helpful health advice that is personalized.",
    "brandPerception": "Never heard of it",
    "otherBrand": "Personal trainer",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 624,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.25,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "Other",
      "Personal trainer"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:20 PM UTC",
    "goals": "Be clean and safe",
    "priceObjection": "",
    "wtpFactors": "Good consistent he’ll",
    "brandPerception": "It a great wellness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1346,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 3,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tonal",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:21 PM UTC",
    "goals": "my current goals are to lose weight, feel in shape and eat helathier",
    "priceObjection": "",
    "wtpFactors": "I am not paying that kind of money honestly.  the no interest is the only appealing piece",
    "brandPerception": "just another tag name that doesnt influen ce me to purchase anything",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.2,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.8
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:21 PM UTC",
    "goals": "I want to maintain good physical health as I age.",
    "priceObjection": "",
    "wtpFactors": "Price and benefits",
    "brandPerception": "Not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 1:22 PM UTC",
    "goals": "Please describe your current personal health or wellness goals in a few sentences.",
    "priceObjection": "",
    "wtpFactors": "What factors would most influence your willingness to pay for a health and wellness program.",
    "brandPerception": "When you hear aldermen what comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1232,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 50,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 1:22 PM UTC",
    "goals": "Trying to eat better, exercise regularly and stay healthy",
    "priceObjection": "",
    "wtpFactors": "My willinness to stick with the program is the biggest factor",
    "brandPerception": "transformation!",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:22 PM UTC",
    "goals": "To improve chronic pain and stamina",
    "priceObjection": "",
    "wtpFactors": "The price point vs value received",
    "brandPerception": "I've never heard of them",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 707,
    "priceDistribution": {
      "499": 9,
      "999": 1,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.417,
      "Body Composition Analysis": 0.417,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:23 PM UTC",
    "goals": "Lose weight and keep it off.",
    "priceObjection": "",
    "wtpFactors": "Cost and ease ofnuse",
    "brandPerception": "Never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.25,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:23 PM UTC",
    "goals": "Lose weight, have better flexibility",
    "priceObjection": "I'm not paying for anything.",
    "wtpFactors": "None.",
    "brandPerception": "Change my apperance",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 49,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:25 PM UTC",
    "goals": "I am working with NOOM through my employee insurance to lose over 40 lbs. in order to improve mobility.",
    "priceObjection": "Too expensive.",
    "wtpFactors": "None. I currently only use NOOM because it is free through employee health insurance.",
    "brandPerception": "Asking someone to change you. Do not like it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:26 PM UTC",
    "goals": "I’m trying to exercise three times a week.",
    "priceObjection": "",
    "wtpFactors": "The total cost.",
    "brandPerception": "Mental health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.167,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.167,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:27 PM UTC",
    "goals": "My personal health and wellness goal has been to lose about 30-35 pounds using the weight loss drug Zepbound.",
    "priceObjection": "",
    "wtpFactors": "It would have to work. Plain and simple.",
    "brandPerception": "Something that changes my phyiscal appearance.I don't like it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 861,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.385,
      "Smart Biometrics Ring": 0.308,
      "Personalized Wellness Plan": 0.615,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.385
    },
    "gender": "Male",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 1:27 PM UTC",
    "goals": "Would like to lose a few pounds and become more active as the weather begins to warm up.",
    "priceObjection": "Way too expensive.",
    "wtpFactors": "None. I think they are all way overpriced.",
    "brandPerception": "Sounds like you'd be joining a cult.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:28 PM UTC",
    "goals": "I just need to be more active, in general",
    "priceObjection": "",
    "wtpFactors": "I wouldn't pay for a plan",
    "brandPerception": "To change a person.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:28 PM UTC",
    "goals": "Losing weight exercising",
    "priceObjection": "",
    "wtpFactors": "Affordability and offering what i need to keep me on track",
    "brandPerception": "New company help getting fit",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1159,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:29 PM UTC",
    "goals": "I am currently trying to reverse type 2 diabetes",
    "priceObjection": "",
    "wtpFactors": "Nothing because I would not pay",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:29 PM UTC",
    "goals": "Adopting a more active lifestyle and improving overall",
    "priceObjection": "",
    "wtpFactors": "Good of tangible results",
    "brandPerception": "About meditation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1319,
    "priceDistribution": {
      "499": 2,
      "999": 5,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.867
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tempo",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch",
      "Garmin",
      "WHOOP",
      "Samsung Galaxy Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:29 PM UTC",
    "goals": "I watch what I eat and drink and am very active physically",
    "priceObjection": "I would not buy this",
    "wtpFactors": "none",
    "brandPerception": "none comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:29 PM UTC",
    "goals": "Staying healthy as healthy as I can",
    "priceObjection": "",
    "wtpFactors": "Health is wealth",
    "brandPerception": "Great health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1232,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 1,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.2,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:30 PM UTC",
    "goals": "To lose weight",
    "priceObjection": "",
    "wtpFactors": "Seeing that it actually worked on those i know.",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1512,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 4,
      "1699": 5,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:30 PM UTC",
    "goals": "I am in recovery and now i would like to be healthy as possible. Starting i am trying to make better choices with food and looking into low impact easy toning my body",
    "priceObjection": "",
    "wtpFactors": "I would pay if for whatever reason I could achieve the goals I was trying to achieve",
    "brandPerception": "Change changing what you don’t like",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 6,
      "999": 2,
      "1499": 2,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:30 PM UTC",
    "goals": "15k steps per day, train for marathon, weight lifting 4x/week",
    "priceObjection": "",
    "wtpFactors": "The cost benefit analysis",
    "brandPerception": "Seems like a very strange name",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 43,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:32 PM UTC",
    "goals": "i want to lose weight and i'm gonna start soon",
    "priceObjection": "",
    "wtpFactors": "i would not pay that much for anything.  I can do it on my own",
    "brandPerception": "maybe it tells you when you need to do things, like excerise, drink water, not eat anything more",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 570,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:32 PM UTC",
    "goals": "Reuduce 8 pounds and stay off proceed foods as much as possible",
    "priceObjection": "",
    "wtpFactors": "Fitness and nutrition tracking.",
    "brandPerception": "No",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 826,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 1,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:32 PM UTC",
    "goals": "I want to loose weight and to keep it off",
    "priceObjection": "",
    "wtpFactors": "The price of the plan and what is incliuded",
    "brandPerception": "change me",
    "otherBrand": "agelessrx",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Other",
      "agelessrx"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:33 PM UTC",
    "goals": "I want to lose weight",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "Lose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1212,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:34 PM UTC",
    "goals": "Maintain my glucose and body weight",
    "priceObjection": "",
    "wtpFactors": "Payment is most important",
    "brandPerception": "A body fitness app",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 979,
    "priceDistribution": {
      "499": 4,
      "999": 8,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:35 PM UTC",
    "goals": "More energy",
    "priceObjection": "",
    "wtpFactors": "The cost and program type",
    "brandPerception": "A change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1246,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:35 PM UTC",
    "goals": "great health",
    "priceObjection": "",
    "wtpFactors": "may be too expensive",
    "brandPerception": "keeping track of my health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:37 PM UTC",
    "goals": "bhdhs dnejje shejej nehej shjeje",
    "priceObjection": "",
    "wtpFactors": "hehsue eheuueue heeuei eheueu eheueue heueieie hejeieei dne",
    "brandPerception": "watch out",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1226,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 5,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:37 PM UTC",
    "goals": "Go to the gym with my daughter as a guest sometimes, but walk the golf course a few times a week",
    "priceObjection": "",
    "wtpFactors": "Because coming up with 1020 dollars at one time would be hard for me",
    "brandPerception": "Help me get my body to where I want it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1432,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 1,
      "1699": 5,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.417,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.583
    },
    "gender": "Female",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:39 PM UTC",
    "goals": "I want to lose weight while gain muscle.",
    "priceObjection": "",
    "wtpFactors": "This would use the exact science i need to get the best results possible.",
    "brandPerception": "I would assume a wellness program",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1359,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 3,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:42 PM UTC",
    "goals": "I want to lose weight and improve my endurance.",
    "priceObjection": "",
    "wtpFactors": "If using it works then it is worth the money.",
    "brandPerception": "I think change me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:42 PM UTC",
    "goals": "I want to\nMaintain my cardio and strength for as long as I can so I’m not a total scrub in life",
    "priceObjection": "",
    "wtpFactors": "Eliminating the guesswork of the day to day",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1179,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 4,
      "1699": 0,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 42,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:44 PM UTC",
    "goals": "Currently, I am simply trying to maintain my current weight, but build more muscle and endurance via cardio and sugar intake reduction",
    "priceObjection": "",
    "wtpFactors": "Customer reviews/satisfaction, customer retention, features+benefits+cost compared to equivocal options",
    "brandPerception": "An altered state of me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "AlterMe"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:45 PM UTC",
    "goals": "I need to lose 50 pounds",
    "priceObjection": "",
    "wtpFactors": "my financial health",
    "brandPerception": "health app",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1259,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 43,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:45 PM UTC",
    "goals": "My personal health and wellness goals are to keep walking twice a week for heart health, to bike more, and maintain a healthy diet",
    "priceObjection": "I wouldn’t pay this much for a wellness plan. I think it’s something I can do a lot cheaper with research, input from my doctors, and a plan of action on my own",
    "wtpFactors": "Overall price and features",
    "brandPerception": "Change but maybe not for self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 0,
      "999": 4,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:47 PM UTC",
    "goals": "I am currently working on gaining strength. My plan is to make it to the gym 4 times a week and work on weights.",
    "priceObjection": "It's out of the range I would be willing to pay for such a plan.",
    "wtpFactors": "First of all, some plans are way too expensive, so I disregarded those. $1400or $1600 is something I am not willing to pay. I tried to find balance between mid range plans",
    "brandPerception": "New and modern approach to fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 856,
    "priceDistribution": {
      "499": 2,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.857,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.714,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Male",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:48 PM UTC",
    "goals": "To lose a few pounds and get my sugar levels down",
    "priceObjection": "That’s pricey",
    "wtpFactors": "Nothing at all",
    "brandPerception": "It’s helping to change you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:49 PM UTC",
    "goals": "N/a",
    "priceObjection": "",
    "wtpFactors": "N/a",
    "brandPerception": "N/a",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1346,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:49 PM UTC",
    "goals": "I want to lose 20 pounds and be less stressed",
    "priceObjection": "",
    "wtpFactors": "If I believed it would get me better results than I could get on my own",
    "brandPerception": "I need to be fixed",
    "otherBrand": "Oura",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 599,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 38,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Other",
      "Oura"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 1:50 PM UTC",
    "goals": "I work out five days a week. This includes running 3-4 miles, and free weight lifting. I then have a protein shake and creatine post workout",
    "priceObjection": "",
    "wtpFactors": "It would have to enhance my current workout goals and improve my overall wellbeing, and save me time",
    "brandPerception": "It sounds like a health and wellness/fitness brand just based on the name",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 691,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.615,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.462,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.538,
      "Recovery Sessions": 0.385,
      "Nutrition Tracking": 0.538
    },
    "gender": "Male",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:50 PM UTC",
    "goals": "I am aiming to tone my body and improve my overall health, becoming stronger.",
    "priceObjection": "",
    "wtpFactors": "To get the most out of the program as possible",
    "brandPerception": "Alter how I look/feel",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Ladder",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:51 PM UTC",
    "goals": "I want to lose weight and tone",
    "priceObjection": "",
    "wtpFactors": "With the most things included",
    "brandPerception": "it makes me want to be a better version of myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 772,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.636,
      "Smart Biometrics Ring": 0.545,
      "Personalized Wellness Plan": 0.455,
      "Body Composition Analysis": 0.636,
      "Workout Sessions": 0.455,
      "Recovery Sessions": 0.636,
      "Nutrition Tracking": 0.818
    },
    "gender": "Female",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:52 PM UTC",
    "goals": "I have chosen to gain more weight as I am a little underweight",
    "priceObjection": "",
    "wtpFactors": "The ability to be able to use the free variety of new equipment.",
    "brandPerception": "My other version of myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1328,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.643,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.643
    },
    "gender": "Female",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:53 PM UTC",
    "goals": "Care-free eating",
    "priceObjection": "",
    "wtpFactors": "Health need, price, content of program",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1132,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 2,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:55 PM UTC",
    "goals": "exercising, more sleep and eating healthy",
    "priceObjection": "",
    "wtpFactors": "good quality and price",
    "brandPerception": "health and fitness platform",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1346,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 1,
      "1699": 5,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 34,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 1:55 PM UTC",
    "goals": "I’d like to get healthier, start a walking routine and lose some weight.",
    "priceObjection": "",
    "wtpFactors": "Affordability and the belief that it would actually help",
    "brandPerception": "I’ve never heard of this brand, but it sounds like something that is related to “fixing” a person",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1119,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 0,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 1:55 PM UTC",
    "goals": "I am currently trying to lose some weight and control my cholesterol levels.",
    "priceObjection": "",
    "wtpFactors": "The price is first and foremost and also a specific workout regime and nutrition tracking.",
    "brandPerception": "It sounds like something that changes who you are.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 1:57 PM UTC",
    "goals": "I would like to stay fit and healthy. I could lose 5-10lb",
    "priceObjection": "",
    "wtpFactors": "Something that has been proven to work",
    "brandPerception": "You are going to change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1339,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 6,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:00 PM UTC",
    "goals": "I would like to lose 50 pounds so that I can focus on minimizing health risks such as heart disease and acide reflux.",
    "priceObjection": "",
    "wtpFactors": "the interest free payment plan and the more benefits the better",
    "brandPerception": "nothing positive, that doesn't sound good to me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1086,
    "priceDistribution": {
      "499": 4,
      "999": 6,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 2:01 PM UTC",
    "goals": "I was recently diagnosed with several spinal conditions that are considered “chronic” and after 2 weeks of receiving the health news, I was laid off by my employer and replaced with Ai.",
    "priceObjection": "",
    "wtpFactors": "The overall cost is the most prohibitive, due to my current financial situation.",
    "brandPerception": "I don’t know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.875,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.625
    },
    "gender": "Male",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:03 PM UTC",
    "goals": "keep working on my strength training to grow more muscle, watch my diet so i can get more lean",
    "priceObjection": "i would not spend that kind of money on this",
    "wtpFactors": "if i thought it was worth the investment",
    "brandPerception": "something that will bring about change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:03 PM UTC",
    "goals": "keep health and happy",
    "priceObjection": "",
    "wtpFactors": "price",
    "brandPerception": "none",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.267,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:07 PM UTC",
    "goals": "I want to preserve my health to be there for my daughter.",
    "priceObjection": "I would not pay",
    "wtpFactors": "I would not pay",
    "brandPerception": "Robots and cyber men",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:09 PM UTC",
    "goals": "I'm trying to lose weight and control my blood pressure",
    "priceObjection": "It's too expensive",
    "wtpFactors": "The amount of features it includes",
    "brandPerception": "Losing weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:10 PM UTC",
    "goals": "I need to see a doctor about my menopause and get on something for all these hot flashes and all the other stuff going on with me. That’s my concern. right now.",
    "priceObjection": "",
    "wtpFactors": "I’ve been feeling really awful and I believe this will help me get back on track",
    "brandPerception": "Make me a different person",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:13 PM UTC",
    "goals": "I am trying to lose fat",
    "priceObjection": "I am not willing to pay such an exorbitant price",
    "wtpFactors": "Useful information, maybe",
    "brandPerception": "Not a thing comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 34,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Retired",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:15 PM UTC",
    "goals": "My current personal health and fitness goals are to just keep myself healthy and eat healthy as well.",
    "priceObjection": "",
    "wtpFactors": "That it has everything that I would need",
    "brandPerception": "nothing at this time",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 624,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.583,
      "Smart Biometrics Ring": 0.417,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.417,
      "Workout Sessions": 0.583,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:15 PM UTC",
    "goals": "I am in good health.",
    "priceObjection": "",
    "wtpFactors": "No much. I workout on my own.",
    "brandPerception": "Something that want to change me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:19 PM UTC",
    "goals": "Lose weight and gain muscle",
    "priceObjection": "",
    "wtpFactors": "Track record of results that would justify the cost",
    "brandPerception": "Have never heard of this before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 863,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.429
    },
    "gender": "Male",
    "age": 42,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:20 PM UTC",
    "goals": "I am looking to lose 10 pounds or more",
    "priceObjection": "",
    "wtpFactors": "For it to be affordable",
    "brandPerception": "Nothing really comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 1282,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.833
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 7,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:20 PM UTC",
    "goals": "Staying as healthy as I can",
    "priceObjection": "",
    "wtpFactors": "If I knew it worked",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:21 PM UTC",
    "goals": "my wellness goal is to eat healthy and to maintain my current weight",
    "priceObjection": "i have no interest in spending any amoun of money on this",
    "wtpFactors": "there are no factors",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:21 PM UTC",
    "goals": "I would like to lose weight by transforming my diet.  I would like to become more active.  I would like to get better sleep.",
    "priceObjection": "",
    "wtpFactors": "It would have to be all inclusive and offer exercise, diet, and lifestyle changes.",
    "brandPerception": "it makes me feel like I am understood and that it is all inclusive",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:21 PM UTC",
    "goals": "Lose weight and improve sleep and longevity",
    "priceObjection": "",
    "wtpFactors": "The value of the co",
    "brandPerception": "A new and improved me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:22 PM UTC",
    "goals": "Signa",
    "priceObjection": "",
    "wtpFactors": "Nil",
    "brandPerception": "Information",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 1,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:22 PM UTC",
    "goals": "Getting rid of my bleeding issues as a woman",
    "priceObjection": "",
    "wtpFactors": "If it was free",
    "brandPerception": "Nothing, sorry never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:22 PM UTC",
    "goals": "Just to be as healthy as I can by eliminating stress, junk food and adding better foods into my diet and being conscious about moving around more.",
    "priceObjection": "I wouldn't pay for something like this. I am doing just fine doing it on my own.",
    "wtpFactors": "I wouldn't pay for a health and wellness program. They're all fads. Just eat smarter and move more.",
    "brandPerception": "A program that helps you change your life",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:23 PM UTC",
    "goals": "to just overall improve my health",
    "priceObjection": "",
    "wtpFactors": "the overall benefits to cost",
    "brandPerception": "Change to yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1106,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.2,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:24 PM UTC",
    "goals": "I would like to lose ten more pounds with exercise and moderate lifestyle changes, and build my stamina and strength.",
    "priceObjection": "",
    "wtpFactors": "Honestly it would have to cost a lot less than that, and any interest is out of the question.",
    "brandPerception": "That sounds more plastic surgery related than wellness.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:25 PM UTC",
    "goals": "My goal is light daily physical activity to keep my joints moving without putting too much pressure in it",
    "priceObjection": "",
    "wtpFactors": "How high the price and the projected results",
    "brandPerception": "I think of change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 4,
      "999": 6,
      "1499": 2,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.867,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:27 PM UTC",
    "goals": "Lose 10 pounds and gain some muscle",
    "priceObjection": "",
    "wtpFactors": "I'd have to be dangerously obese and medically necessary to prevent death",
    "brandPerception": "Nothing",
    "otherBrand": "Google",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "Google"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:28 PM UTC",
    "goals": "Stay fit and eat healthy",
    "priceObjection": "",
    "wtpFactors": "Good ben",
    "brandPerception": "I'm not familiar with it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1292,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 0,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 28,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 2:28 PM UTC",
    "goals": "To lose weight and get in better overall health",
    "priceObjection": "",
    "wtpFactors": "If it had a ton of features I wanted at a low price",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:31 PM UTC",
    "goals": "I need to lose about 25 to 35 pounds but I want to retain as much muscle as possible. I want to lower my LDL chiley",
    "priceObjection": "",
    "wtpFactors": "If it is a premium experience and has a good personality trainer with follow along videos like Hannah Eden",
    "brandPerception": "It reminds me of those alerts when you've fallen and can't get up",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1019,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:31 PM UTC",
    "goals": "I want to eat healthier.  I want to lose 40 pounds. I want to get more sleep.  Drink more water.",
    "priceObjection": "",
    "wtpFactors": "The program works and well worth the money.  It comes with all the things that I am looking for.",
    "brandPerception": "To make a better version of yourself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1046,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 1,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.933,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:33 PM UTC",
    "goals": "Lose 7 lbs. Rebuild lower body and core.  Post surgery. Unassisted pull ups, stronger push ups and jump on a taller box.",
    "priceObjection": "",
    "wtpFactors": "Versatility of different styles of class workouts.  Variety and substantial amount of equipment at the facility.  I'm not buying some online health and wellness program, I want it offered at a facility.",
    "brandPerception": "Change for the better",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1026,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 2:33 PM UTC",
    "goals": "I have not really set any goals for myself",
    "priceObjection": "",
    "wtpFactors": "That it includes everything in one",
    "brandPerception": "It sounds like a good name for an app",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 1032,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:38 PM UTC",
    "goals": "Lose about 50 pounds, from muscle, be healthier",
    "priceObjection": "",
    "wtpFactors": "Price and access to workouts and recovery. Support at the ready and a good tracking system",
    "brandPerception": "Changing yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 785,
    "priceDistribution": {
      "499": 7,
      "999": 6,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.286,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.857,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.643
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:41 PM UTC",
    "goals": "I want to lose weight right now. I want to feel healthier. I want to eat better.",
    "priceObjection": "",
    "wtpFactors": "It would be dependent on the price and the content involved.",
    "brandPerception": "It means to change myself. I don't know of this brand or process though.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:42 PM UTC",
    "goals": "Meditation, continuously working on my growth mindset on all aspects of life, organic food consumption, HIIT, Pilates, Yoga, Barre, stretching, walking/running, weight training, beauty rituals, traveling, juicing and NEAT daily.",
    "priceObjection": "",
    "wtpFactors": "Comprehensive options and variety along with credentialed and scientific feedback.",
    "brandPerception": "Intuitive app",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1629,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 2,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.3,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 32,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Tempo",
      "Fitbit",
      "WHOOP",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:44 PM UTC",
    "goals": "Lose weight, increase how far I can walk without pain, increase my health so that I can be fertile and conceive a baby, decrease my fatigue by eating better, work out more.",
    "priceObjection": "",
    "wtpFactors": "I want to truly feel like it is personalized to me. The advice that works for other people is not always the advice that works for me. I don’t want one size fits all workouts. I want something that takes into account things like where I am in my monthly cycle, how well I slept, how my body is feeling, what I’ve been through lately. I also want everything to be in one place. I get tired of inputting nutrition info into one app and my period into another and my sleep being monitored by my wrist band and then I have to copy the info from each app into another. I don’t end up keeping up with it because it’s too much. And they say they sync but it’s not reliable.",
    "brandPerception": "Change me - which I feel like might be positive for some. But I sort of don’t like that a company or product feels like I need to change. It doesn’t feel super body positive. But most fitness products aren’t.",
    "otherBrand": "MyFitnessPal",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.857,
      "Recovery Sessions": 0.857,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Other",
      "MyFitnessPal"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 PM UTC",
    "goals": "I want to work out consistently. I also want to prioritize my mental health.",
    "priceObjection": "",
    "wtpFactors": "the price and what it actually includes",
    "brandPerception": "something is trying to change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:46 PM UTC",
    "goals": "I would love to lose my last 40lbs. I would like to get my hip pain under control so I can be more active.",
    "priceObjection": "",
    "wtpFactors": "Glowing reports from actual people that have used it and not influencers",
    "brandPerception": "Plastic surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.25,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.25,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:50 PM UTC",
    "goals": "Want to lose 20 pounds",
    "priceObjection": "",
    "wtpFactors": "Financial aspect",
    "brandPerception": "Change my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1059,
    "priceDistribution": {
      "499": 7,
      "999": 2,
      "1499": 2,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:52 PM UTC",
    "goals": "stay on a low carb and zero sugar diet",
    "priceObjection": "",
    "wtpFactors": "reviews from current users",
    "brandPerception": "change something",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 1,
      "999": 6,
      "1499": 1,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.417,
      "Smart Biometrics Ring": 0.583,
      "Personalized Wellness Plan": 0.417,
      "Body Composition Analysis": 0.583,
      "Workout Sessions": 0.583,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.583
    },
    "gender": "Male",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:56 PM UTC",
    "goals": "I'd like to get back down about 10 pounds lower than I weigh now, and I want to increase my strength. I'd like to be able to do pullups without pain.",
    "priceObjection": "",
    "wtpFactors": "I really just don't like the ring idea because I lift weights and it would get in the way. I prefer a watch. I would pay for a health and wellness program with guaranteed results.",
    "brandPerception": "It makes me think of changing myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 2:56 PM UTC",
    "goals": "Keeping a exercise routine and eating healthy",
    "priceObjection": "",
    "wtpFactors": "Price and workout",
    "brandPerception": "Change my",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:58 PM UTC",
    "goals": "To lost about 5pounds, continue to hike. Workout six days per week- two to three days focusing on strength. Get 11K steps daily. Cut out processed sugar",
    "priceObjection": "",
    "wtpFactors": "What all I’m getting in the plan and if it meets my goals",
    "brandPerception": "Changing yourself although I also think of plastic surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 919,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.7,
      "Nutrition Tracking": 0.7
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 2:59 PM UTC",
    "goals": "Would like to gain more muscle",
    "priceObjection": "",
    "wtpFactors": "Wide variety of workouts",
    "brandPerception": "Hanging yourself, mi d, body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1372,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 4,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 47,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 3:01 PM UTC",
    "goals": "I would like to be in a normal weight range. I would like to lose 30 lbs. by the end of the year.",
    "priceObjection": "",
    "wtpFactors": "A reasonable price.",
    "brandPerception": "Transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:04 PM UTC",
    "goals": "Stay active and maintain health.",
    "priceObjection": "",
    "wtpFactors": "I probably wouldn't pay for it.  I'm a former athlete in good shape, I don't need all that.",
    "brandPerception": "Nothing.  Never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 41,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 3:06 PM UTC",
    "goals": "Stick to an eating and exercising routine that is sustainable for the long term.",
    "priceObjection": "",
    "wtpFactors": "The features that you get for the money. some of these plans had everything I would want. I probably wouldn't pay over $1k for them, but I might pay up to $700.",
    "brandPerception": "I really am not a fan of this. It sounds too much focused on change in a negative way.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1459,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:07 PM UTC",
    "goals": "Lose weight and gain muscle and increase flexibility",
    "priceObjection": "",
    "wtpFactors": "cost versus benefits",
    "brandPerception": "Medical alert",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1099,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.643,
      "Body Composition Analysis": 0.357,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.857,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:10 PM UTC",
    "goals": "My personal health and wellness goals is to be able to get as clean as possible and smell the best without like nicking or cutting my skin",
    "priceObjection": "",
    "wtpFactors": "The fact that it is long-term and I feel like I get the most benefit out of it that will help to suit my needs",
    "brandPerception": "I have no idea as this sounds totally different from any type of health and fitness and I wouldn't even know where to begin to think about this",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1052,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:10 PM UTC",
    "goals": "I have currently entered menopause and just before I had lost 12 lb. Now I have gained the 12 lb back and I'm at the way I previous, which is okay because I'm not 12 pounds heavier from the weight I started at. I currently walk, use the stationary bike and do some free weights.",
    "priceObjection": "",
    "wtpFactors": "The factors that would influence my willingness to pay for health and wellness program would be if overweight, pre-diabetic, losing muscle, heart health, just staying fit and healthy.",
    "brandPerception": "A big change from what I once was, to who I'm going to be",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 972,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.727,
      "Smart Biometrics Ring": 0.545,
      "Personalized Wellness Plan": 0.727,
      "Body Composition Analysis": 0.727,
      "Workout Sessions": 0.818,
      "Recovery Sessions": 0.727,
      "Nutrition Tracking": 0.545
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:11 PM UTC",
    "goals": "id like to lose weight",
    "priceObjection": "",
    "wtpFactors": "discounts for paying in full",
    "brandPerception": "is someone in danger?",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1152,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.267,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:13 PM UTC",
    "goals": "I want to exercise more and build muscle cause im getting older",
    "priceObjection": "I wouldnt spend my money on this",
    "wtpFactors": "I dont think I would do this ever- not that important to me to spend my monehy on",
    "brandPerception": "never heard of me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:13 PM UTC",
    "goals": "I'd like to loose about 15 pounds and tone up.  I also want to learn better eating habits.",
    "priceObjection": "",
    "wtpFactors": "Price point is definitely a factor.",
    "brandPerception": "Chsnfec",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.857,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.857,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:13 PM UTC",
    "goals": "I am currently working on maintaining a healthy weight for my age and height. I am wanting to lower my blood pressure and find a way manage my stress levels",
    "priceObjection": "",
    "wtpFactors": "The cost of the monthly payments and everything that is included with the cost of the program",
    "brandPerception": "What comes to mind is the ability to change my health and wellness through strategy and routine.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1539,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 4,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:13 PM UTC",
    "goals": "Curently it is to maintain my current health level",
    "priceObjection": "",
    "wtpFactors": "How effective it is!",
    "brandPerception": "I think a negative.  Like why must we be altered?  \"Better me\" would be better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 681,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.545,
      "Smart Biometrics Ring": 0.818,
      "Personalized Wellness Plan": 0.455,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.455,
      "Recovery Sessions": 0.727,
      "Nutrition Tracking": 0.545
    },
    "gender": "Male",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Ladder",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 3:15 PM UTC",
    "goals": "Follow a calorie deficit",
    "priceObjection": "",
    "wtpFactors": "Being able to have personalized recommendations",
    "brandPerception": "It will tell you when you need to pay attention to something",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1235,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 1,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.786,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 3:18 PM UTC",
    "goals": "Eat more whole grains, fruits, and veggies. Move during the day",
    "priceObjection": "I'm not paying that much money",
    "wtpFactors": "Maybe having a personal trainer, but probably not even that",
    "brandPerception": "That I'm a problem and I need changing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:18 PM UTC",
    "goals": "Maintain and or lose a bit of weight. That’s about it.",
    "priceObjection": "",
    "wtpFactors": "Overall, price. And what I get for said price.",
    "brandPerception": "I immediately think of plastic surgery, but since this survey was based on fitness, I understand where the name is coming from.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 707,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.583,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.417,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:18 PM UTC",
    "goals": "I would like to quit vaping, lose 15 pounds, daily Pilates, eat healthier",
    "priceObjection": "",
    "wtpFactors": "Personal coach, equipmét",
    "brandPerception": "Something science fiction like",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 43,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:21 PM UTC",
    "goals": "my current goal is to maintain and build immunity, prevent future aging, and aim for a reasonable amount of exercise. at this stage in my life, preventing future issues is key for me.",
    "priceObjection": "",
    "wtpFactors": "i'm unsure. i found it too cumbersome to use a wearable and use the app and it just became so inconvenient. I suppose if using an app and wearable and making lifestyle changes all \"flowed\" together more easily than my experience, i think that would influence me to try it in the future. reading all the features that could be available with this, i love the bodyscan; i think that is a great starting point for someone to work with.",
    "brandPerception": "it sounds like \"begging.\" It evokes \"please fix me.\" But it's a cool name; the visual it gives me is not bad. it sounds like a bit of a surrender and looking for help.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 570,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.286,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.857
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:21 PM UTC",
    "goals": "to get as healthy as possible lose 20 pounds",
    "priceObjection": "",
    "wtpFactors": "if it is a good program",
    "brandPerception": "it cares about you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1366,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "WHOOP"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:22 PM UTC",
    "goals": "I want to stay healthy and build muscle while maintaining my current weight",
    "priceObjection": "",
    "wtpFactors": "What is included in the total package influces me",
    "brandPerception": "nothing really comes to mind with this name",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1379,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 2,
      "1699": 5,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.067,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:23 PM UTC",
    "goals": "I want to ton up, lose a few pounds, and boost my immune system.",
    "priceObjection": "",
    "wtpFactors": "the price and how much is being offered",
    "brandPerception": "change me",
    "otherBrand": "I don't have a specific brand",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 599,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Other",
      "I don't have a specific brand"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:24 PM UTC",
    "goals": "Try so stay as active as possible as I get older",
    "priceObjection": "",
    "wtpFactors": "Overall cost and if I think it is something I can stick with",
    "brandPerception": "No idea what it is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 37,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:25 PM UTC",
    "goals": "I want to be heathy, choose healthy food, be fit and active",
    "priceObjection": "",
    "wtpFactors": "If it has everything I want in a program, and is priced fairly",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1146,
    "priceDistribution": {
      "499": 5,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:25 PM UTC",
    "goals": "I must eliminate my use of addictive substances, continue my exercise regimen, deal with my abdominal hernia somehow, and be mindful of my eating/hydration/sleeping habits.",
    "priceObjection": "Not really appealing at that price. Would probably go for the savings if I could afford to drop that much at once.",
    "wtpFactors": "Cost, whether or not I can just do it myself (I can).",
    "brandPerception": "Change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:26 PM UTC",
    "goals": "My current goals are to lose about 25 pounds and live a more active lifestyle",
    "priceObjection": "",
    "wtpFactors": "If it feels like I’d get full value out of it",
    "brandPerception": "Changing my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 681,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.455,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.455,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.273,
      "Recovery Sessions": 0.545,
      "Nutrition Tracking": 0.545
    },
    "gender": "Male",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:27 PM UTC",
    "goals": "I am trying to lose weight and improve my overall fitness",
    "priceObjection": "I wouldn’t pay anywhere near that muc unless I was getting glp-1s",
    "wtpFactors": "I have no interest in purchasing plans like this",
    "brandPerception": "I’ve never heard of this before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:28 PM UTC",
    "goals": "Currently trying to lose 30 lbs",
    "priceObjection": "Too expensive",
    "wtpFactors": "I don’t know",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:29 PM UTC",
    "goals": "I would like to be 30 lbs lighter and have at least 3 days of exercise done by the end of the week.",
    "priceObjection": "",
    "wtpFactors": "The price would be what most influences me.",
    "brandPerception": "Make me new.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:30 PM UTC",
    "goals": "Lose weight",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "Alter",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1286,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 2,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.267,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 3:30 PM UTC",
    "goals": "I want to lose a few pounds, tone up, and continue training for races.",
    "priceObjection": "",
    "wtpFactors": "Lowest price and no interest.",
    "brandPerception": "It sounds a little intimidating and scary.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Non-binary / Other",
    "age": 31,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:34 PM UTC",
    "goals": "I'm trying to drop 10 pounds through increased exercising",
    "priceObjection": "",
    "wtpFactors": "The cost of any extra expenses during the tough times of our economy frighten me to start any new subscriptions.",
    "brandPerception": "Alter your appearance, alter your health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.643,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:36 PM UTC",
    "goals": "I currently deal with some health issues that sometimes affect my daily life such as diabetes and High blood pressure. My goal is to get my A1C under 6 and continue to help the regulation of my blood pressure by taking medications and eating the right things.",
    "priceObjection": "",
    "wtpFactors": "the pure benefits of the program, the greatness of the staff, and the results from everything going on in the program",
    "brandPerception": "Make alterations to my body by helping me to eat better, and make healthier lifestyle changes",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1466,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 3,
      "1699": 6,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:37 PM UTC",
    "goals": "To lose weight get stronger feel better in general",
    "priceObjection": "",
    "wtpFactors": "If I thought I'd truly see results from it",
    "brandPerception": "Altering your body and mindset",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 699,
    "priceDistribution": {
      "499": 8,
      "999": 2,
      "1499": 0,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.545,
      "Smart Biometrics Ring": 0.727,
      "Personalized Wellness Plan": 0.727,
      "Body Composition Analysis": 0.545,
      "Workout Sessions": 0.364,
      "Recovery Sessions": 0.545,
      "Nutrition Tracking": 0.727
    },
    "gender": "Male",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:37 PM UTC",
    "goals": "Gaining strength and maintaining proper balance, energy and overall wellbeing as I age",
    "priceObjection": "",
    "wtpFactors": "The features I cannot find elsewhere or everything on one platform that would be convenient. Assistance if needed is a must",
    "brandPerception": "health journey transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.625,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:45 PM UTC",
    "goals": "I just want to be able to have better endurance",
    "priceObjection": "",
    "wtpFactors": "Cost is the biggest, and I also wouldn’t subscribe to something using biometrics or private data",
    "brandPerception": "Some weird changeling type of product - doesn’t bode well for people loving their bodies as they are",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.267,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Non-binary / Other",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:46 PM UTC",
    "goals": "I’m hoping to lose a bit of weight and stay active as much as possible.",
    "priceObjection": "",
    "wtpFactors": "Price is most important and then what benefits am I getting out of it.",
    "brandPerception": "Nothing, never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:46 PM UTC",
    "goals": "Losing some weight and feeling healthier",
    "priceObjection": "",
    "wtpFactors": "Sleep analysis, workouts",
    "brandPerception": "Changing yourself for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 3,
      "999": 6,
      "1499": 1,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 29,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Student",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:48 PM UTC",
    "goals": "I'm in fairly good shape, but not as good as I was a couple years ago. My current goal is to lose another 15-20 pounds, mostly through exercise and trying to eat better, but not following anything strictly, just whatever feels good that day.",
    "priceObjection": "",
    "wtpFactors": "Price vs value. $1500 is a big ask for any wellness program, no matter what's included with it. I wouldn't pay for just a DNA test and body composition analysis, there has to be more to it to justify that kind of expense. Workouts and nutrition at a minimum. Even that is pushing it.",
    "brandPerception": "ChangeMe. Which is kind of a horrible answer, but was the first thing that came to mind. AlterMe as a company name, I'd definitely put into the fitness field, giving you a plan to change your body the way you want.",
    "otherBrand": "Samsung wearables",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 582,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.167,
      "Body Composition Analysis": 0.833,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Other",
      "Samsung wearables"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:48 PM UTC",
    "goals": "I’m trying to lose some weight in my belly and I’m trying to eat healthier foods and not eat junk",
    "priceObjection": "I would not pay that much for a wellness program",
    "wtpFactors": "Nothing would make me pay over $1,000 for a wellness program",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 9,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.556,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.556
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:50 PM UTC",
    "goals": "I want to get through perimenopause with a healthy body",
    "priceObjection": "",
    "wtpFactors": "if someone else paid for it, like my insurance company",
    "brandPerception": "it sounds like surgery to be transgender",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:51 PM UTC",
    "goals": "To lose weight to eat better and to exercise more",
    "priceObjection": "",
    "wtpFactors": "Something that can help me get physically fit in a great workout routine",
    "brandPerception": "A great workout routine and a good exercise plan",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 0,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 3:52 PM UTC",
    "goals": "My current goals are to lose approximately 20 pounds, improve my stress reactions and improve my energy levels.",
    "priceObjection": "",
    "wtpFactors": "It would have to be some extreme factor that would lead me to pay for a program - as in a serious detrimental disease/ailment",
    "brandPerception": "when I hear 'alterme\" I hear a desire for change from an outside source. a cry for help.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 699,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 3:53 PM UTC",
    "goals": "Live longer and be skinny",
    "priceObjection": "",
    "wtpFactors": "Free option",
    "brandPerception": "Changing yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:53 PM UTC",
    "goals": "I have genetically high total cholesterol, but have high HDL. I work to primarily keep my HDL high while keeping my A1c normal.",
    "priceObjection": "",
    "wtpFactors": "I’m not in a position to where I feel the need to pay for this type of support. I’m comfortable managing my own plan at no cost.",
    "brandPerception": "I am not familiar with this brand.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:54 PM UTC",
    "goals": "My personal health goal is to stop smoking",
    "priceObjection": "",
    "wtpFactors": "If it has a proven track record of success",
    "brandPerception": "That sounds a little strange",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1319,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:54 PM UTC",
    "goals": "I am wanting to lose weight.",
    "priceObjection": "I would not purchase a program at this price.",
    "wtpFactors": "I'm not sure. I don't think most of these programs are worth the price.",
    "brandPerception": "sounds like you are trying to change something",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:54 PM UTC",
    "goals": "To rehabilitate my ankle and foot from an injury I had and at the same time keep my weight steady by eating properly",
    "priceObjection": "Too expensive",
    "wtpFactors": "Priced reasonably",
    "brandPerception": "Sewing",
    "otherBrand": "",
    "otherDevice": "Don’t know the brand",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Don’t know the brand"
    ]
  },
  {
    "date": "Feb 19, 2026 3:54 PM UTC",
    "goals": "stay as healthy as possible, exercise every day and eat well",
    "priceObjection": "",
    "wtpFactors": "everything that is included at a low price",
    "brandPerception": "That doesn't sound like a fitness plan",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 872,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.267
    },
    "gender": "Female",
    "age": 51,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:54 PM UTC",
    "goals": "I want to lose weight and build my muscles. I'm looking toward the future and want to be healthy.",
    "priceObjection": "",
    "wtpFactors": "I need to know this is a value that will actually help me, I can't just waste $1500 on something I could get from a free app.",
    "brandPerception": "That I'm not good enough and need to be \"fixed\" or \"altered\" and changed.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:56 PM UTC",
    "goals": "To keep my arthritis under control",
    "priceObjection": "",
    "wtpFactors": "I wouldn’t because my insurance covers it",
    "brandPerception": "Nothing I don’t know this company",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1619,
    "priceDistribution": {
      "499": 0,
      "999": 2,
      "1499": 4,
      "1699": 4,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 52,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tonal"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:57 PM UTC",
    "goals": "Keeping a good healthy weight, active and strong.",
    "priceObjection": "",
    "wtpFactors": "Good reviews, before and after pictures, testimonies from reliable users,  free sample, a money-back guarantee, and a guarantee that it will work.",
    "brandPerception": "a better me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:57 PM UTC",
    "goals": "Lose weight and gain strength and some muscle",
    "priceObjection": "",
    "wtpFactors": "No additional",
    "brandPerception": "Unsure. \nMaybe something geared towards change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 939,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 3:58 PM UTC",
    "goals": "I am working towards losing weight and building muscle.  I currently use Wegovy to help those efforts.",
    "priceObjection": "I would never buy a fitness program that cost almost $2000.",
    "wtpFactors": "I would never pay that much for a program.  Considering there are a lot of free programs out there or ones that do not cost so much.",
    "brandPerception": "Trying to fix certain aspects of your body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 3:59 PM UTC",
    "goals": "Want to eat healthier, more consistently, and gradua",
    "priceObjection": "",
    "wtpFactors": "The features included and the personalization",
    "brandPerception": "Alterati",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1446,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 3,
      "1699": 5,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 27,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:02 PM UTC",
    "goals": "I am coming back from a foot injury. I am trying to get stronger so I can take long walks and hikes.  I try to work out 30 minutes 6 days a week.  I am taking a natural glp 1 and hope to lose some weight.",
    "priceObjection": "",
    "wtpFactors": "I would need to see real benefits like an example of the DNA report and how it would benefit me.",
    "brandPerception": "That there is something wrong me with me. I needed to be altered like a garment to be my best self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:03 PM UTC",
    "goals": "More natural herb intake.",
    "priceObjection": "Not interested",
    "wtpFactors": "No cost",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 1699,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:06 PM UTC",
    "goals": "Exercise and clean eating for health, balanced hormones, and good sleep.",
    "priceObjection": "",
    "wtpFactors": "Right now the price and how much I believe it will help me",
    "brandPerception": "Changing fitness and size",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:07 PM UTC",
    "goals": "To lose a little weight n the next coming months",
    "priceObjection": "",
    "wtpFactors": "Price and what it comes with",
    "brandPerception": "Help as soon as possible",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1186,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.933
    },
    "gender": "Male",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "WHOOP",
      "Oura Ring",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:08 PM UTC",
    "goals": "To eat healthy and lose weight",
    "priceObjection": "",
    "wtpFactors": "The benefits and the overall oackage",
    "brandPerception": "It changes you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 570,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Ladder"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:10 PM UTC",
    "goals": "I just want stability. Financial stability, mental stability, physical stability..",
    "priceObjection": "That is still far too expensive over 36 months. The interest? What is it, a student loan?",
    "wtpFactors": "Good workouts that stay on the platform, but also include new ones to rotate in. I love going back to my favorite old workout tapes & videos from the 2000s, and when they get deleted, I miss them so much! Nostalgia really helps to keep me motivated, because it's like having an old friend coaching you and keeping you company. Keep the old, but don't neglect new routines!",
    "brandPerception": "AI. Sounds too dystopian.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 34,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:11 PM UTC",
    "goals": "To stay fit without any major problems",
    "priceObjection": "",
    "wtpFactors": "Good in all aspects",
    "brandPerception": "In a good way",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 39,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tempo",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Google Pixel Watch",
      "Garmin",
      "Oura Ring",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:11 PM UTC",
    "goals": "i workout an hour a day everyday and i watch what i eat during the week but eat whatever i want on the weekends",
    "priceObjection": "",
    "wtpFactors": "if it's proven to be effective over anything",
    "brandPerception": "fixing yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:11 PM UTC",
    "goals": "I try to stay healthy by working out a few days a week and try to eat well.",
    "priceObjection": "",
    "wtpFactors": "I usually don't pay for this kind of service.  I prefer to download it on youtube",
    "brandPerception": "I have never heard of this.  I am thinking what is this.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 906,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:12 PM UTC",
    "goals": "My health goals are to support healthy aging as I become middle age. Im focused on weightloss and maintaining a good sleep schedule.  Im also focused more on my mental health.",
    "priceObjection": "",
    "wtpFactors": "If it includes ways to track my over all fitness and has plans that are special made for my health journey.",
    "brandPerception": "Changing yourself comes to mind when I hear AlterMe.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:12 PM UTC",
    "goals": "Would like to get back to eating healthier, regular exercise, and try to lose 20-30 pounds",
    "priceObjection": "",
    "wtpFactors": "It’s very unlikely I would pay fo a health and wellness program as I have had good success in the past doing this on my own",
    "brandPerception": "Never heard of it but it sounds like a program that would offer benefits to greatly improve someone’s health and wellness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:13 PM UTC",
    "goals": "I just wanna get more consistent with working out and more consistent with eating healthier",
    "priceObjection": "",
    "wtpFactors": "If I know it had direct benefits and be very appealing",
    "brandPerception": "Being a changed person for the better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 4,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:13 PM UTC",
    "goals": "Exercise more in lose weight",
    "priceObjection": "",
    "wtpFactors": "Probably the cost",
    "brandPerception": "I don't know what it is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1246,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 2,
      "1699": 1,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:14 PM UTC",
    "goals": "I need to loser weight and get healthy",
    "priceObjection": "",
    "wtpFactors": "It would depend on the payments and if they focus on nutrition over working out since I’m disabled",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1713,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 4,
      "1699": 5,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.286,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Ladder",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:14 PM UTC",
    "goals": "I feel like now that I'm getting older, I need to focus on my health so that going forward, I don't suffer more than I am now. I want to be able to function and enjoy life as I get older. I'm trying to commit myself to working out a few days a week and eating more whole foods and food with fiber.",
    "priceObjection": "",
    "wtpFactors": "I honestly don't know. I don't really have any extra money to put towards this, so I would have to say that cost is the number one factor. Then again; I don't see myself paying for this. Seems like there's cheaper ways to get the information; from my doctor and online videos.",
    "brandPerception": "Something to help \"change me,\" I'm not sure how I feel about that name.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 582,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.833,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.833
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:14 PM UTC",
    "goals": "On low carb diet watching what I eat drinking water",
    "priceObjection": "",
    "wtpFactors": "Good pan",
    "brandPerception": "Let s me know what comes available",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 846,
    "priceDistribution": {
      "499": 9,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 56,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:15 PM UTC",
    "goals": "I need to lose weight because I'm so fat.",
    "priceObjection": "",
    "wtpFactors": "it is a good deal for me. I like that iti s easy to find.",
    "brandPerception": "nothing. It sounds weird.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1639,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 2,
      "1699": 4,
      "1899": 7
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 39,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:15 PM UTC",
    "goals": "Get healthy",
    "priceObjection": "",
    "wtpFactors": "If they work",
    "brandPerception": "Slow pace",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1179,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 4,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 35,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Garmin",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:15 PM UTC",
    "goals": "Lose weight, tone muscles, improve nutrition",
    "priceObjection": "",
    "wtpFactors": "Affordability and features I would actually use",
    "brandPerception": "Changes to my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 1277,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 1,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.556,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:15 PM UTC",
    "goals": "Lose weight, become healthier",
    "priceObjection": "",
    "wtpFactors": "Price and value",
    "brandPerception": "A mental health condition DID",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1106,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 1,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.667
    },
    "gender": "Non-binary / Other",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:16 PM UTC",
    "goals": "i want to manage my stress and lose weight",
    "priceObjection": "too expensive",
    "wtpFactors": "nothing",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:16 PM UTC",
    "goals": "My personal health and wellness goal is to eat a healthy diet, as well as maintain healthy, exercise and weight",
    "priceObjection": "",
    "wtpFactors": "The factors that would influence my willingness to play for a Health plan would be the interest payments is none or a very small percentage also there’s a  discount as well as what is wellness tracking diet maintaining and also having all the perks and benefits of nutritional meals planned out for you for the week. Also a virtual fitness coach would be great addition to me choosing a wellness program",
    "brandPerception": "When I hear alter me means change my self or I become a different version healthwise",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1372,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 4,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:16 PM UTC",
    "goals": "I’d like to be more tone after having a baby",
    "priceObjection": "",
    "wtpFactors": "The cost and if i can do most of it at home",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1152,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.2,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:16 PM UTC",
    "goals": "Get better",
    "priceObjection": "",
    "wtpFactors": "Current state of my body",
    "brandPerception": "A Bluetooth based alert system",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 892,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tempo"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:16 PM UTC",
    "goals": "get more muscles and be bigger.",
    "priceObjection": "",
    "wtpFactors": "if it seems like a good value",
    "brandPerception": "i've never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1239,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:17 PM UTC",
    "goals": "To improve my platelet levels and circulation. To eat better and lose about 10 more pounds. To walk and lift weights more consistently.",
    "priceObjection": "",
    "wtpFactors": "The most analytical data possible",
    "brandPerception": "Not much. Never heard of it. Interesting though!",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 932,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:17 PM UTC",
    "goals": "To lose weight and build muscle and being healthy",
    "priceObjection": "Not ready",
    "wtpFactors": "Not ready",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:17 PM UTC",
    "goals": "Health is good.  Awaiting a knee replacement and then hope to be more active.",
    "priceObjection": "",
    "wtpFactors": "Affordability",
    "brandPerception": "Nothing; never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 3,
      "999": 6,
      "1499": 1,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.867,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 PM UTC",
    "goals": "Want to lose about 60 pounds",
    "priceObjection": "",
    "wtpFactors": "Affordable and DNA analysis on what foods are most optimal",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1286,
    "priceDistribution": {
      "499": 0,
      "999": 8,
      "1499": 3,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 PM UTC",
    "goals": "I work out \nEat better every day",
    "priceObjection": "",
    "wtpFactors": "Nope",
    "brandPerception": "Don't",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 1499,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 PM UTC",
    "goals": "To improve overall health & wellbeing, lose weight, and live a healthier lifestyle.",
    "priceObjection": "",
    "wtpFactors": "None, Health & Wellness shouldn't be behind paywalls!",
    "brandPerception": "Sounds bad, the idea of Alteration is about changing completely",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 812,
    "priceDistribution": {
      "499": 7,
      "999": 7,
      "1499": 0,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 PM UTC",
    "goals": "I would really like to keep up my muscle strength as well as focus on a healthier diet. Instead of just eating, I want to properly fuel and tend to my body. It has been good to me my whole life, I’d like to be good to it also.",
    "priceObjection": "",
    "wtpFactors": "I’d want it to be very comprehensive, not overly fancy but enough to help me build healthy habits",
    "brandPerception": "Very techy tracking, maybe AI. Smart products.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 6,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 32,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 PM UTC",
    "goals": "To stay fit",
    "priceObjection": "",
    "wtpFactors": "Resalta",
    "brandPerception": "What is this",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1286,
    "priceDistribution": {
      "499": 2,
      "999": 6,
      "1499": 2,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:19 PM UTC",
    "goals": "I am trying to be healthy and lose weight",
    "priceObjection": "",
    "wtpFactors": "It has proven results and is good value for the money",
    "brandPerception": "You are changing yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.714,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:20 PM UTC",
    "goals": "None to note here.",
    "priceObjection": "",
    "wtpFactors": "None to note here either.",
    "brandPerception": "None to note here either.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1286,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 1,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 29,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Never",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Polar"
    ]
  },
  {
    "date": "Feb 19, 2026 4:21 PM UTC",
    "goals": "I really want to lose weight and live a long and healthy life, so i am focused on eating right and getting workouts in",
    "priceObjection": "",
    "wtpFactors": "if there were proven results that worked for me and their customer reviews",
    "brandPerception": "alter my mind and body for the better, an improvement",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 3,
      "1699": 5,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:21 PM UTC",
    "goals": "To eat a healthier diet and be more active",
    "priceObjection": "Too expensive to consider",
    "wtpFactors": "My overall budget. I can’t afford a wellness program",
    "brandPerception": "Nothing comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 36,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:22 PM UTC",
    "goals": "I want to stay heart healthy, have more energy, keep my weight down, and improve my sleep.",
    "priceObjection": "",
    "wtpFactors": "If it included a nurtrition tracking progeam",
    "brandPerception": "Change me?",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1139,
    "priceDistribution": {
      "499": 3,
      "999": 6,
      "1499": 3,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:23 PM UTC",
    "goals": "Maintain strength and cardio fitness while eating a balanced diet.",
    "priceObjection": "",
    "wtpFactors": "pricing at 4 figures i must admit gives me great pause, I would say the 900 dollar range would be a limit no matter how wonderful the program is.",
    "brandPerception": "something biometrically has gone wrong.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 721,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.889,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.444,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.444
    },
    "gender": "Male",
    "age": 35,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:24 PM UTC",
    "goals": "Strength training and eating better.",
    "priceObjection": "I mean I really would not purchase.",
    "wtpFactors": "Only if it was free.   I would not pay as a wealth of information is online and free.",
    "brandPerception": "Nothing really important.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1392,
    "priceDistribution": {
      "499": 1,
      "999": 6,
      "1499": 1,
      "1699": 2,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 53,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:25 PM UTC",
    "goals": "I want to participate in Tennis, swimming and yoga",
    "priceObjection": "",
    "wtpFactors": "Reputation, customized",
    "brandPerception": "Customized plan",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 632,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.444,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.556
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:26 PM UTC",
    "goals": "build muscle and heart health",
    "priceObjection": "",
    "wtpFactors": "value vs monthly cost",
    "brandPerception": "not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 4:27 PM UTC",
    "goals": "To lose body fat and gain muscle and take care of my skin.",
    "priceObjection": "",
    "wtpFactors": "If i get body composition and DNA  information that will help me reach my health goals.",
    "brandPerception": "I'm really not sure what that means. Maybe be a gadget that can be customized to my health goals like a smart watch.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:28 PM UTC",
    "goals": "Eat healthier, work out more, drink less alcohol",
    "priceObjection": "",
    "wtpFactors": "I don't want to pay a ton of money for it - especially because a lot of this would be included in a monthly gym membership. I don't need all the bells and whistles",
    "brandPerception": "Changing yourself - it does not necessarily make me think of fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 30,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:28 PM UTC",
    "goals": "My current health and wellness goals focus on reducing stress, protecting my mental health, and creating better balance in my daily life. I’m prioritizing consistent movement, mindful nutrition, and rest to support long-term well-being.",
    "priceObjection": "",
    "wtpFactors": "The biggest factors influencing my willingness to pay for a health and wellness program are proven results, clear value, and how well it fits into my real life. I would be more inclined to invest if the program supports both mental and physical wellness, offers practical guidance rather than overwhelm, and is led by credible, trustworthy professionals. Flexibility, sustainability, and a supportive environment also play a major role.",
    "brandPerception": "Surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 6,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:28 PM UTC",
    "goals": "I'm basically trying to stay in shape by exercising everyday",
    "priceObjection": "",
    "wtpFactors": "Discount prices mostly",
    "brandPerception": "Getting married or improving your body shape",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 1,
      "999": 4,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.357,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.643,
      "Workout Sessions": 0.929,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.357
    },
    "gender": "Male",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:29 PM UTC",
    "goals": "Peace of mind meditation",
    "priceObjection": "",
    "wtpFactors": "Results that are noticeable",
    "brandPerception": "Changing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1406,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 5,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 47,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:30 PM UTC",
    "goals": "Maintain my current healthy weight by taking 15K steps a day",
    "priceObjection": "",
    "wtpFactors": "If it included a plan and a ring to wear",
    "brandPerception": "It helps me change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 4,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.867,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:30 PM UTC",
    "goals": "Eating healthier and more protein is big for me now.  I’m also working out earlier in the morning.",
    "priceObjection": "",
    "wtpFactors": "I think value and use would be big for me",
    "brandPerception": "I haven’t heard of them",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:31 PM UTC",
    "goals": "Lose a couple of pounds",
    "priceObjection": "",
    "wtpFactors": "Quality services u can rely upon to get accurate information",
    "brandPerception": "Success",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1439,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 3,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 56,
    "income": "$200,000 or more",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:31 PM UTC",
    "goals": "i wanna loose 60 lbs and be a fit person that’s my goals",
    "priceObjection": "",
    "wtpFactors": "to actually see results of weight loss would definitely pay it’s hard to loose weight",
    "brandPerception": "think how it works and designed to loose weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:32 PM UTC",
    "goals": "I want to get strong and increase endurance",
    "priceObjection": "",
    "wtpFactors": "effective, has all the stuff i want",
    "brandPerception": "i dont like it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 31,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 4:33 PM UTC",
    "goals": "I want to eat healthier and try to lose some weight.",
    "priceObjection": "",
    "wtpFactors": "If it actuall",
    "brandPerception": "It dmsounds weird to be honest.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 839,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 0,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:35 PM UTC",
    "goals": "good health weight",
    "priceObjection": "",
    "wtpFactors": "My main goal",
    "brandPerception": "Teacher coach",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 5,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.267,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 4:36 PM UTC",
    "goals": "Na",
    "priceObjection": "",
    "wtpFactors": "Na",
    "brandPerception": "Na",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:36 PM UTC",
    "goals": "I am currently losing weight to qualify for a kidney transplant.",
    "priceObjection": "",
    "wtpFactors": "It is important to stay as healthy as possible because I want to live a long time and have a good quality of life.",
    "brandPerception": "Quality",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1039,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 3,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 50,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:36 PM UTC",
    "goals": "i like toi exercise 4 times a week and attend yoga class one a week",
    "priceObjection": "",
    "wtpFactors": "if it was a wellness program that had good reviews and it gives great results for that price",
    "brandPerception": "do not know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.25,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.375,
      "Workout Sessions": 0.375,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.375
    },
    "gender": "Female",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:37 PM UTC",
    "goals": "Tone body & gain muscle",
    "priceObjection": "",
    "wtpFactors": "Real results",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1286,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 4,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 28,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:38 PM UTC",
    "goals": "Just staying consistent with exercise, even if it’s just a 20-minute walk or some stretching after work. Also getting better sleep by actually turning off screens earlier.",
    "priceObjection": "",
    "wtpFactors": "It depends on whether the program feels personalized, because I need specific goals. Also if it's supported by science/evidence-based expertise, and if I can fit it into my schedule",
    "brandPerception": "Science-based personalized fitness.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 2,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:39 PM UTC",
    "goals": "I want to maintain my health and exercise more",
    "priceObjection": "",
    "wtpFactors": "I like that it will track my health and my activity",
    "brandPerception": "It would keep me moving and motivated",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 952,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 0,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:40 PM UTC",
    "goals": "Really trying to take care of my health especially heart ❤️",
    "priceObjection": "",
    "wtpFactors": "I shop around for prices hoping I can recieve great care",
    "brandPerception": "Honestly not",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 2,
      "999": 6,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 1,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:40 PM UTC",
    "goals": "Lose 20lbs and lower cholesterol",
    "priceObjection": "",
    "wtpFactors": "Proven results and possibly a meal",
    "brandPerception": "Body ch",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 48,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:41 PM UTC",
    "goals": "Lose 15 pounds",
    "priceObjection": "Way too expensive",
    "wtpFactors": "One time purchase. No monthly/ yearly fee shit",
    "brandPerception": "Fake",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Never",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:42 PM UTC",
    "goals": "To lose weight",
    "priceObjection": "",
    "wtpFactors": "To be healthy",
    "brandPerception": "To change my body composition",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1382,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.583,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.583,
      "Workout Sessions": 0.167,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Retired",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:43 PM UTC",
    "goals": "Trying to keep weight down. Gym 3-4 times a week. Protein bars and shakes. Vitamins/supplements",
    "priceObjection": "I already buy a gym membership and pay tons of money for protein products, vitamins  and supplements im not paying for anything else",
    "wtpFactors": "Free",
    "brandPerception": "Something that will help change myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:43 PM UTC",
    "goals": "I want to be fit in a way that I have moderate weight gain and a high, large stamina.",
    "priceObjection": "",
    "wtpFactors": "To follow a good health and workout routine.",
    "brandPerception": "A good fitness technology.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1692,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 3,
      "1699": 5,
      "1899": 6
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tempo",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Google Pixel Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:43 PM UTC",
    "goals": "My goal is to lose weight and watch what I eat",
    "priceObjection": "",
    "wtpFactors": "Something that aligns with my goals",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 3,
      "1699": 6,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:44 PM UTC",
    "goals": "Being healthy for as long as I can be",
    "priceObjection": "",
    "wtpFactors": "Quality of program and benefits of program",
    "brandPerception": "Cosmetic surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.857,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.286,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.714
    },
    "gender": "Male",
    "age": 39,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:44 PM UTC",
    "goals": "I am a healthy personel",
    "priceObjection": "",
    "wtpFactors": "Pay in full 36 month no interest",
    "brandPerception": "Fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1392,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 2,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.867,
      "Recovery Sessions": 0.933,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tempo",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:45 PM UTC",
    "goals": "None",
    "priceObjection": "",
    "wtpFactors": "None",
    "brandPerception": "None",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1352,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.267
    },
    "gender": "Female",
    "age": 30,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:47 PM UTC",
    "goals": "I would like to think I’m healthy and I try to eat well and exercise",
    "priceObjection": "",
    "wtpFactors": "How the benefits help offset the cost and benefits really help me progress",
    "brandPerception": "Changing things about you",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 47,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:50 PM UTC",
    "goals": "I am looking to transform myself via body recomposition. Since June, I have dropped 20 pounds, increased weight training and went on a nutrition regime.",
    "priceObjection": "",
    "wtpFactors": "Adaptability to me personally.",
    "brandPerception": "Nothing - I don't know what that is.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 5,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:51 PM UTC",
    "goals": "I'm currently trying to put on muscle mass and lose belly fat.",
    "priceObjection": "",
    "wtpFactors": "Real results that I can see.",
    "brandPerception": "It sounds like a play on words for a Christian health and fitness program",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 30,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 4:51 PM UTC",
    "goals": "Body recomposition. Build muscle, lose body fat, be strong, detox",
    "priceObjection": "This is extremely expensive and I would never consider paying it",
    "wtpFactors": "Price is the biggest factor",
    "brandPerception": "I would first think of some kind of online alternate personality thing. Something I would have no idea what it is and can't even explain. I would not think health and wellness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 33,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:53 PM UTC",
    "goals": "I plan on going for treatment for my legs",
    "priceObjection": "",
    "wtpFactors": "I don't know what to say about this situation",
    "brandPerception": "I don't know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1279,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 5,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:53 PM UTC",
    "goals": "I tried to walk 3 miles a day on my lunch break, doing that under 45 minutes! I believe that is the best I can do while at work.",
    "priceObjection": "I wouldn’t pay that. I try and go the free route.",
    "wtpFactors": "I wouldn’t. It’s not in my budget and I know what works for my body.",
    "brandPerception": "I’ve never heard of this before, so nothing is coming to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:53 PM UTC",
    "goals": "I am trying to maintain a weight loss.",
    "priceObjection": "",
    "wtpFactors": "Perks and buddy passes.",
    "brandPerception": "This seems like something is fundamentally wrong with me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 2,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 28,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:54 PM UTC",
    "goals": "I plan on losing 20lbs. I also would like to build greater muscle mass.",
    "priceObjection": "",
    "wtpFactors": "The attributes and benefits.",
    "brandPerception": "A dramatic change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1606,
    "priceDistribution": {
      "499": 0,
      "999": 2,
      "1499": 4,
      "1699": 5,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 4:54 PM UTC",
    "goals": "I want to lose 15 more lbs even though I feel good healthwise.",
    "priceObjection": "",
    "wtpFactors": "If it’s a last resort.",
    "brandPerception": "Change my body shape.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1279,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 4,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:54 PM UTC",
    "goals": "I would like to lose a few pounds and consistently make healthy food choices without letting it consume my entire life",
    "priceObjection": "That is way to too expensive",
    "wtpFactors": "What it comes with and how well it fits within my budget",
    "brandPerception": "Not much",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 28,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:54 PM UTC",
    "goals": "I have MS so I need to keep my strength up. I focus on healthy organic foods and a well balanced Physical Therapy daily regimen everyday to stay as strong and healthy as I can. I use Fitbit to keep track of my wellness goals as well as my Doctors advice.",
    "priceObjection": "I have insurance that covers my physical therapy for my Multiple Sclerosis. I can not afford any of these plans.",
    "wtpFactors": "If it where covered by Medicaid I would consider one of these.",
    "brandPerception": "To alter a persons wellness solutions and make changes where necessary.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "Improving overall strength and mobility for my whole body so I can stay mobile with my disease progressing.",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Other",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:55 PM UTC",
    "goals": "My health is good. I go to a gym and workout twice a week and walk on other days",
    "priceObjection": "Too expensive",
    "wtpFactors": "The price and location",
    "brandPerception": "Change your life",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 0.625
    },
    "gender": "Male",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:55 PM UTC",
    "goals": "My current health and wellness goals are to maintain my weight, increase sleep and build muscle and stamina.",
    "priceObjection": "",
    "wtpFactors": "How well the device and programming works, durability, warranty, benefits that I don’t already get from other devices",
    "brandPerception": "Altering your lifestyle based on science that will help improve your health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 3,
      "999": 6,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.889,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.444,
      "Recovery Sessions": 0.778,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:55 PM UTC",
    "goals": "To be consistently at 175lbs and lose the belly fat",
    "priceObjection": "",
    "wtpFactors": "Price and what is included in the owckage",
    "brandPerception": "Absolutely nothing.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1239,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:56 PM UTC",
    "goals": "Lose 20 lbs by eating healthy",
    "priceObjection": "Too expensive for my budget .",
    "wtpFactors": "Something simple. A lot of things a person is very capable of doing on their own. That is why I choose the least amount.",
    "brandPerception": "I’ve never heard of AlterMe.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 926,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:56 PM UTC",
    "goals": "I’d love to lose weight and tighten my skin as\nIt’s very loose. I’d love to build muscle also",
    "priceObjection": "",
    "wtpFactors": "Success rates with evidence from clients",
    "brandPerception": "I have never heard of it but it sounds like hanging yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 932,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:57 PM UTC",
    "goals": "My biggest goal is to stabilize my core because of scoliosis and bad lower back. I need to strengthen all muscles and include cardio. I’m meditating and taking daily vitamins. My diet is terrible and needs a ton of work.",
    "priceObjection": "",
    "wtpFactors": "I would need daily personalized plans along with daily workouts. \n\nThe price of the programs was the biggest factor. In this economy, I can’t afford $1,000s programs.",
    "brandPerception": "It’s either an AI company or a luxury plastic surgery clinic",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 33,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:57 PM UTC",
    "goals": "To be strong and lean and healthy eating the right foods",
    "priceObjection": "I won't pay for any of these",
    "wtpFactors": "If they have weights",
    "brandPerception": "Change mind and body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 1899,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:57 PM UTC",
    "goals": "I want to lose maybe 10 pounds, and I would like to gain more strength.",
    "priceObjection": "",
    "wtpFactors": "Guaranteed results",
    "brandPerception": "I am not sure.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.444,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.556,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.778
    },
    "gender": "Female",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 4:57 PM UTC",
    "goals": "I would like to become more active and lose a little weight.  I hope to begin a walking routine soon to start off.",
    "priceObjection": "",
    "wtpFactors": "Price, payment terms, would need to have nutrition tracking and workouts at a minimum",
    "brandPerception": "Big mirror",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 2,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 4:58 PM UTC",
    "goals": "Lose weight and improve blood sugar.",
    "priceObjection": "Every plan you've shown costs too much money.",
    "wtpFactors": "Cost",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:58 PM UTC",
    "goals": "Im starting of with nutritious foods and thinking positive",
    "priceObjection": "",
    "wtpFactors": "A personal nutritionist that i can speak to",
    "brandPerception": "I never heard of this.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1359,
    "priceDistribution": {
      "499": 3,
      "999": 1,
      "1499": 6,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.267,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.2
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 4:58 PM UTC",
    "goals": "I would like to lose some weight",
    "priceObjection": "",
    "wtpFactors": "price",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:00 PM UTC",
    "goals": "I want to lose weight. I’m pre diabetic. I want to have more energy.",
    "priceObjection": "",
    "wtpFactors": "Body mass index, nutrition information",
    "brandPerception": "I don’t know.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 5,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Never",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:00 PM UTC",
    "goals": "To eat better and stop drinking sugary drinks to drink more water and walk daily",
    "priceObjection": "",
    "wtpFactors": "If it’s worth it if it has a lot of benefits like exercise programs, diet and nutrition guide , meal ideas, and helpe me with goals",
    "brandPerception": "Help me comes to my mind like help me alter myself help me fix my self in a positive way",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1079,
    "priceDistribution": {
      "499": 5,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:00 PM UTC",
    "goals": "Lose weight and age gracefully. Be more mobile and active",
    "priceObjection": "",
    "wtpFactors": "Tailored to my needs and helps me achieve my professional goals",
    "brandPerception": "Makes me think of something that would alter or transform my body as well as my way of thinking about fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1312,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.267,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.933,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:03 PM UTC",
    "goals": "I want to lose 10lbs",
    "priceObjection": "",
    "wtpFactors": "A payment plan",
    "brandPerception": "A change or shift",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.375,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.875,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.25
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:05 PM UTC",
    "goals": "To become slim and fit",
    "priceObjection": "",
    "wtpFactors": "To be healthy till e",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1352,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 0,
      "1699": 4,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:05 PM UTC",
    "goals": "My current wellness goals focus on maintaining high-performance energy levels while supporting cognitive health and focus. I aim to find a balance between physical stamina and mental clarity by incorporating functional ingredients like Alpha-GPC for focus and B-Vitamins for metabolism",
    "priceObjection": "",
    "wtpFactors": "Having direct access to licensed medical professionals, such as doctors, registered dietitians, or physical therapists, justifies a higher price point",
    "brandPerception": "\"AlterMe,\" it immediately brings to mind a high-tech, personalized medical wellness ecosystem that shifts the focus from \"one-size-fits-all\" fitness to biological individuality",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1166,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 5,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 31,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Google Pixel Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:05 PM UTC",
    "goals": "I'm trying to get more flexible and stay strong",
    "priceObjection": "",
    "wtpFactors": "The prices seem high but maybe",
    "brandPerception": "Dont know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.25,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:06 PM UTC",
    "goals": "To lose 30 pounds by summer",
    "priceObjection": "",
    "wtpFactors": "If it’s a proven program with good results",
    "brandPerception": "Nothing really good brand",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 7,
      "999": 6,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:06 PM UTC",
    "goals": "I go to the gym and try to workout everyday. I try hard to diet lose weight. I want to lower my cholesterol",
    "priceObjection": "",
    "wtpFactors": "Help with sleep and nutrition tracking, access to nutrition workouts",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 932,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 5,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:06 PM UTC",
    "goals": "My primary goal is to maintain a consistent excersise routine, aiming for at least 30 minutes of moderate activity five days a week. And working on incorporating more whole plant based foods into my diet.",
    "priceObjection": "",
    "wtpFactors": "One size fits all approach is rarely worth a premium. willingness to pay increases significantly when a program uses personal data, such as biometric markets, fitness levels, or dietary restrictions to create a tailored roadmap.",
    "brandPerception": "I think it sounds like a brand name A fitness app. something that helps you alter your body or your habits to get healthier.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 946,
    "priceDistribution": {
      "499": 5,
      "999": 7,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.733
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Student",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:08 PM UTC",
    "goals": "to lose 10 pounds and not go back to smoking",
    "priceObjection": "",
    "wtpFactors": "0",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1386,
    "priceDistribution": {
      "499": 1,
      "999": 5,
      "1499": 4,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 46,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:09 PM UTC",
    "goals": "Trying to lose 20-30 pounds by getting or exceeding my daily calorie burning and walking goals",
    "priceObjection": "Too much for what I am willing to pay",
    "wtpFactors": "If it was a lot more affordable such as 19.99 a month",
    "brandPerception": "Changing your daily routine to successfully achieve your health goals",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:11 PM UTC",
    "goals": "Good healthy",
    "priceObjection": "",
    "wtpFactors": "I like losing weight",
    "brandPerception": "Anything",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1370,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.643,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 45,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tempo",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Google Pixel Watch",
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 5:12 PM UTC",
    "goals": "To get back to pre-pregnancy weight",
    "priceObjection": "Too expensive.",
    "wtpFactors": "Price",
    "brandPerception": "Changing oneself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 3
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:12 PM UTC",
    "goals": "Moving my body daily. Sleeping atleast 7 hours at night and eating healthy",
    "priceObjection": "",
    "wtpFactors": "Affordability",
    "brandPerception": "I don’t know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1172,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:17 PM UTC",
    "goals": "My goal is to eat healthier and exercise regularly",
    "priceObjection": "",
    "wtpFactors": "price and what is included in the program",
    "brandPerception": "It sounds like a plastic surgery service",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.833,
      "Nutrition Tracking": 0.167
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:18 PM UTC",
    "goals": "None, not die",
    "priceObjection": "",
    "wtpFactors": "I was rich.",
    "brandPerception": "After me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 27,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:19 PM UTC",
    "goals": "I just want to move freely with no aches or pains and eat a balanced meal.",
    "priceObjection": "",
    "wtpFactors": "The training pal and are tailored more to my preferences and that I can adjust how long trust they are.",
    "brandPerception": "Give me my best body function possible",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1326,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 6,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Garmin",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:20 PM UTC",
    "goals": "Loose weight and tone up",
    "priceObjection": "",
    "wtpFactors": "It will motivate me to use it more than not having it",
    "brandPerception": "Something that tells you when it’s time to workout",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1219,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.8
    },
    "gender": "Male",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Noom"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:20 PM UTC",
    "goals": "I would like to continue to be more active by walking each day and eat healthier foods.",
    "priceObjection": "",
    "wtpFactors": "Im not really sure",
    "brandPerception": "Changing your lifestyle to improve your health and well-being",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:21 PM UTC",
    "goals": "Run fast and train smart",
    "priceObjection": "",
    "wtpFactors": "Does it come with a gym?",
    "brandPerception": "Sci-fi company",
    "otherBrand": "",
    "otherDevice": "Garmin",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 5:21 PM UTC",
    "goals": "I'm prioritizing a balance lifestyle by focusing on my physical stigma an mental clarity. To keep my energy up, I make sure to jog a few times a week and stay consistent with my hydration.",
    "priceObjection": "",
    "wtpFactors": "I'd pay for personalized plans, expert coaching, and proven result that fit my fitness routine.",
    "brandPerception": "A smart coach designed to \"alter\" my daily routines and psychological trigger to for long-term health.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1346,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.733
    },
    "gender": "Male",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "Fitbit",
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 5:23 PM UTC",
    "goals": "Get stronger.",
    "priceObjection": "",
    "wtpFactors": "If it's motivational enough.",
    "brandPerception": "I've never heard of AlterMe.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 687,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.375,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.375
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:24 PM UTC",
    "goals": "I want to lose weight. I also want to gain strength.",
    "priceObjection": "",
    "wtpFactors": "Having advanced metrics such as dexa scans",
    "brandPerception": "Making big changes to your exterior self",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 32,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 7,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:26 PM UTC",
    "goals": "I am on a road to quit smoking trying to heal my lungs! So making sure that I stay on the straight and narrow especially since I have asthma its extremely important.",
    "priceObjection": "They are all over priced and I would never try any of these",
    "wtpFactors": "There is no program for health and wellness that I feel is worth the prices that were shown just now.",
    "brandPerception": "Fix me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:26 PM UTC",
    "goals": "It is great I’m very much healthy",
    "priceObjection": "",
    "wtpFactors": "I really don’t know at the moment",
    "brandPerception": "I actually don’t know I haven’t heard this before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1619,
    "priceDistribution": {
      "499": 0,
      "999": 2,
      "1499": 4,
      "1699": 4,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 33,
    "income": "$200,000 or more",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:27 PM UTC",
    "goals": "to eat well and to be active",
    "priceObjection": "",
    "wtpFactors": "money back it isn’t effective",
    "brandPerception": "changing your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:28 PM UTC",
    "goals": "My personal health and wellness goals are to be healthy physically, mentally and emotionally. Focusing on staying healthy inside and out.",
    "priceObjection": "",
    "wtpFactors": "If its price is reasonable and it's proven to be good and shows results.",
    "brandPerception": "It seems like a program that helps change your health and wellness for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 906,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 1,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 40,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:28 PM UTC",
    "goals": "I want to gain a little muscle, but I also want to prevent muscle loss as",
    "priceObjection": "",
    "wtpFactors": "I'm willing to pay as long as I feel the price matches what I am getting out of it.",
    "brandPerception": "Weight loss",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1459,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:30 PM UTC",
    "goals": "To lose extra weight and gain muscles.",
    "priceObjection": "",
    "wtpFactors": "Something is good for my body type",
    "brandPerception": "It sounds interesting.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1492,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 2,
      "1699": 6,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.867
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Tonal"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:30 PM UTC",
    "goals": "Losing cholesterol.",
    "priceObjection": "",
    "wtpFactors": "Pay amount and route.",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1359,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 5,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 1,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "AlterMe"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 5:32 PM UTC",
    "goals": "Maintain my weight and improve my metabolism",
    "priceObjection": "No way would I pay that much for something I can do myself",
    "wtpFactors": "Nothing would get me to play",
    "brandPerception": "I’ve never heard of it. Makes me think of unhealthy eating disorder weight loss",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Student",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 5:33 PM UTC",
    "goals": "Lose 10 lbs\nEat healthy \nWear a bikini\nLose body fat",
    "priceObjection": "",
    "wtpFactors": "Results that last a lifetime",
    "brandPerception": "Reshape my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1339,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 5,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 40,
    "income": "$200,000 or more",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:33 PM UTC",
    "goals": "I want to be skinny.  No carbs and no meat.",
    "priceObjection": "",
    "wtpFactors": "Cleanliness and affordable",
    "brandPerception": "Churches",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 5:34 PM UTC",
    "goals": "My health journey is not able looking good. I want the live a healthy life, both physically and emotionally. My goal to live medication and disease free as long as I can.",
    "priceObjection": "",
    "wtpFactors": "seeing results",
    "brandPerception": "give a notification is something happesns",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.375,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Male",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:36 PM UTC",
    "goals": "I've lost a ton of weight but I still have more to lose",
    "priceObjection": "",
    "wtpFactors": "I want to be healthy for myself and my kids",
    "brandPerception": "I'm not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 919,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 0,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 32,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:37 PM UTC",
    "goals": "To become healthy and not get cancer again, eat right and exercise",
    "priceObjection": "It’s too expensive for me",
    "wtpFactors": "The most influence will be in a health and wellness program is a good price",
    "brandPerception": "When I hear Alterme, it sounds like a change in my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 1,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:38 PM UTC",
    "goals": "Lose weight improve flexibility",
    "priceObjection": "",
    "wtpFactors": "Flex spending use, adaptive plan and the appropriate testing.  I can track calories and get workouts.",
    "brandPerception": "Confusion",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:38 PM UTC",
    "goals": "Working on reducing sugar intake and watching portion sizes.",
    "priceObjection": "",
    "wtpFactors": "Price, what's included, payment terms.",
    "brandPerception": "Plastic surgery.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 9,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.222,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.889,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 37,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:40 PM UTC",
    "goals": "Harmony in working out and meditation",
    "priceObjection": "",
    "wtpFactors": "Adaptation into my schedule and life. Easy to understand and easy to follow. Follow through with making sure to stay on track.",
    "brandPerception": "A big change. You aren't happy with who you are.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 779,
    "priceDistribution": {
      "499": 9,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:40 PM UTC",
    "goals": "Obtaining a healthy weight and toning up my body",
    "priceObjection": "",
    "wtpFactors": "Goals and health needs",
    "brandPerception": "Getting in shape",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 963,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 5,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.643,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.357
    },
    "gender": "Female",
    "age": 33,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:42 PM UTC",
    "goals": "maintain weight and Increase energy levels",
    "priceObjection": "",
    "wtpFactors": "Trust on the program. I would want to have confidence that I am paying for something that works",
    "brandPerception": "Mobile app that assists you with your weight loss programs",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:43 PM UTC",
    "goals": "I am looking to maintain my weight but tone my body and make sure I am eating the best I can",
    "priceObjection": "",
    "wtpFactors": "Making sure it has everything that i'm looking for",
    "brandPerception": "Alter my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1752,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 4,
      "1699": 3,
      "1899": 8
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 30,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 5:43 PM UTC",
    "goals": "My main goal is to lose weight and gain muscle.",
    "priceObjection": "Way too expensive",
    "wtpFactors": "It has to be a reasonable price",
    "brandPerception": "I have no idea what that is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.714,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.286,
      "Nutrition Tracking": 0.429
    },
    "gender": "Female",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 5:44 PM UTC",
    "goals": "I want to exercise more often to help me reduce stress",
    "priceObjection": "",
    "wtpFactors": "If it can help to improve my health, it’s worth it",
    "brandPerception": "Change the way I am",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 7,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.867,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 34,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 5:45 PM UTC",
    "goals": "I'm working on losing weight. An trying to take care of my asthma, depression and anxiety.",
    "priceObjection": "",
    "wtpFactors": "The out come",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "Ring",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.143,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 54,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch",
      "Other smart ring or fitness tracker",
      "Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 5:46 PM UTC",
    "goals": "I went to anytime fitness and signed up for a membership.I enjoyed signing up for it.",
    "priceObjection": "",
    "wtpFactors": "Finding the right products that work.Ones that i like that work.",
    "brandPerception": "Health and fitness a program that works for me.One that I like and works for me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1466,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 4,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 31,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:46 PM UTC",
    "goals": "I plan to lose 20 lbs in 6 months.",
    "priceObjection": "The price is too high",
    "wtpFactors": "The total amount.",
    "brandPerception": "I’ve never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:48 PM UTC",
    "goals": "Drinking more water and eating a little bit bet",
    "priceObjection": "",
    "wtpFactors": "It being worth the value rather than being underwhelming for the value",
    "brandPerception": "Nothing about exercising",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:48 PM UTC",
    "goals": "We've started eating healthier, and taking short walks in the evenings after dinner. Trying to cut back on snacking and not  eating so late.",
    "priceObjection": "I would never pay that much.",
    "wtpFactors": "Value and many features included.",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:49 PM UTC",
    "goals": "I want to become active again to a point that I am healthy.  My current sedentary state has had a negative impact on my overall health.",
    "priceObjection": "",
    "wtpFactors": "On demand workouts and support and overall cost.  Ease of use and access of the program would also be an important factor for me.",
    "brandPerception": "I have never heard of it before.  Based on the name it makes me think of an app that is geared towards helping people alter some part of themselves",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 939,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.867,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 44,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:51 PM UTC",
    "goals": "I want to lose weight and get stronger",
    "priceObjection": "",
    "wtpFactors": "The full price",
    "brandPerception": "Changing your body",
    "otherBrand": "",
    "otherDevice": "Coros watch",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 29,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Oura Ring",
      "Other smart ring or fitness tracker",
      "Coros watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:51 PM UTC",
    "goals": "loose about 15 lbs",
    "priceObjection": "still cost to much not worth it in my opinion",
    "wtpFactors": "the price",
    "brandPerception": "alter your thinking or how you workout etc",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:52 PM UTC",
    "goals": "Really healthy",
    "priceObjection": "",
    "wtpFactors": "Motivation",
    "brandPerception": "Body modification",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 1062,
    "priceDistribution": {
      "499": 4,
      "999": 1,
      "1499": 0,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.875,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.875,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.75
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:53 PM UTC",
    "goals": "I am very goal oriented and I place a high value on  personal health. It is something I focus on to stay healthy and in shape. My summer body is 365!",
    "priceObjection": "",
    "wtpFactors": "I like a comprehensive program that is going to fit my needs, goals, as well as align me with new techniques I would have otherwise not considered",
    "brandPerception": "It makes me think what do they want to alter. Might be a great seller for someone getting started with fitness or returning after a long time/injury.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 1359,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 0,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.2,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 29,
    "income": "$200,000 or more",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:54 PM UTC",
    "goals": "good health and peace",
    "priceObjection": "",
    "wtpFactors": "good health",
    "brandPerception": "better health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1228,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 5:55 PM UTC",
    "goals": "Continue to lose weight and get more in shape",
    "priceObjection": "That's more $ than I would like to spend",
    "wtpFactors": "AFFORDABLILTY",
    "brandPerception": "Nothing. Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 5:56 PM UTC",
    "goals": "i would like to be 200lbs at 20% body fat",
    "priceObjection": "",
    "wtpFactors": "price",
    "brandPerception": "nothin never heard before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 5:58 PM UTC",
    "goals": "Currently I am trying to lose weight and be more active. I am trying to be in a calorie deficit and I get a minimum of 13,000 steps a day.",
    "priceObjection": "",
    "wtpFactors": "The price would need to be more reasonable. Ideally, insurance would cover it.",
    "brandPerception": "This is not familiar to me. It sounds like a program that would make some sort of change in its user.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 1349,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 2,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.75,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 51,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:00 PM UTC",
    "goals": "I want to start eating better and getting more exercise.   I want to lose some weight since I turn 50 this year.",
    "priceObjection": "",
    "wtpFactors": "Having disposable income.  I have none right now.",
    "brandPerception": "Transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:01 PM UTC",
    "goals": "I exercise daily for 45 minutes, eat clean, and sleep early",
    "priceObjection": "",
    "wtpFactors": "A virtual program that focuses on weight loss, nutrition and exercise.",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1572,
    "priceDistribution": {
      "499": 1,
      "999": 1,
      "1499": 4,
      "1699": 5,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.267,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 32,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:01 PM UTC",
    "goals": "Current goals is to remain healthy and vibrant.",
    "priceObjection": "",
    "wtpFactors": "It has everything that I'm looking for in a health and wellness program",
    "brandPerception": "Make a change and improve your health.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1059,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 6,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit",
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 6:02 PM UTC",
    "goals": "Relax and be calm",
    "priceObjection": "",
    "wtpFactors": "30",
    "brandPerception": "Health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:03 PM UTC",
    "goals": "need to lose weight",
    "priceObjection": "",
    "wtpFactors": "low cost and support",
    "brandPerception": "fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 9,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.222,
      "Smart Biometrics Ring": 0.556,
      "Personalized Wellness Plan": 0.444,
      "Body Composition Analysis": 0.556,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.778
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Ladder",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:04 PM UTC",
    "goals": "stay strong and healthy",
    "priceObjection": "I do not want to pay so much for this",
    "wtpFactors": "If I get a personal trainer and a dietician.",
    "brandPerception": "I have never heard of this before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:04 PM UTC",
    "goals": "Trying to be a healthy weight and be healthy overall by living an activ",
    "priceObjection": "",
    "wtpFactors": "No interest on payment plan.",
    "brandPerception": "It makes me think of a product that changes me.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1014,
    "priceDistribution": {
      "499": 3,
      "999": 7,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.385,
      "Smart Biometrics Ring": 0.846,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.462,
      "Recovery Sessions": 0.769,
      "Nutrition Tracking": 0.462
    },
    "gender": "Female",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:09 PM UTC",
    "goals": "I want to get toned and loose about 30 pounds.",
    "priceObjection": "",
    "wtpFactors": "How often I go and how close it is to home.",
    "brandPerception": "Nothing, I have never seen it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1446,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 5,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:09 PM UTC",
    "goals": "I would like to loose weight a little bit and also I would exercise for feeling less stressed in my life",
    "priceObjection": "",
    "wtpFactors": "Price and that is something complete worth of it",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:09 PM UTC",
    "goals": "Getting my hamstring healed",
    "priceObjection": "",
    "wtpFactors": "The effectiveness of the programs",
    "brandPerception": "Changing me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1352,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.867,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.867,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 34,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 1,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 6:09 PM UTC",
    "goals": "I am trying to be healthier and lose weight",
    "priceObjection": "",
    "wtpFactors": "Having the ability to be held accountable in meeting my goals",
    "brandPerception": "Make me a better version of myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1206,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.733,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 37,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:12 PM UTC",
    "goals": "I plan to start walkiing at least 4 days a week for a minimum of 30 minutes.  I just need to get moving more.",
    "priceObjection": "",
    "wtpFactors": "The price would influence my willingness to pay for a health and wellness program.",
    "brandPerception": "I don't feel a positive connotation with AlterMe.  It sounds like a photo filter or some kind of AI thing.  I don't like that name.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Student",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:12 PM UTC",
    "goals": "My current goals are to lose weight, eat healthy, and track my steps",
    "priceObjection": "",
    "wtpFactors": "If it was customized to my personal needs",
    "brandPerception": "Something that helps alter your life",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1252,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 6,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 31,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 1,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:12 PM UTC",
    "goals": "I want to work out at least 5 days a week to continue to keep up good health",
    "priceObjection": "",
    "wtpFactors": "I would really have to see how it benefits me from my current process of doing workout at the gym and through apple fitness but not using other tracking outside of what apple watch tracks.",
    "brandPerception": "That it is something to change how I currently am",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 7,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.286,
      "Smart Biometrics Ring": 0.857,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.286,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.571
    },
    "gender": "Male",
    "age": 46,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:12 PM UTC",
    "goals": "Lose weight and gain a little muscle",
    "priceObjection": "I'd never spend that much",
    "wtpFactors": "price",
    "brandPerception": "Why do I need to change",
    "otherBrand": "",
    "otherDevice": "Ring",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 6:15 PM UTC",
    "goals": "I don’t have any goals, per se, but I should lose some weight.",
    "priceObjection": "Too expensive",
    "wtpFactors": "The price point and what is included",
    "brandPerception": "I don’t know what it is",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.2,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:16 PM UTC",
    "goals": "To eat well and exercise. To take care of yourself myself and remember the importance of selfcare.",
    "priceObjection": "",
    "wtpFactors": "Nothing else that I can think of.",
    "brandPerception": "Changing your habits or ways.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:16 PM UTC",
    "goals": "to lose weight, become healthier, stronger, more toned. To start better eating habits.",
    "priceObjection": "",
    "wtpFactors": "The cost and what is offered in that. If it large amoun then it should include everything and also have payment options.",
    "brandPerception": "Changing yourself",
    "otherBrand": "",
    "otherDevice": "Calmi",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 1049,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 1,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.875,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.375
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Calmi"
    ]
  },
  {
    "date": "Feb 19, 2026 6:16 PM UTC",
    "goals": "I stay active by running or jogging 3/4 times per week for at least 90 minutes.",
    "priceObjection": "",
    "wtpFactors": "I depends on the proposed benefits and my judgment as to the actual benefits concerning my physical and mental health.",
    "brandPerception": "DNA kits",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1320,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 5,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.429,
      "Body Composition Analysis": 0.643,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.714
    },
    "gender": "Male",
    "age": 54,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:17 PM UTC",
    "goals": "i want to stay strong and feel strong",
    "priceObjection": "",
    "wtpFactors": "if the benefits outweigh the costs and there are insights into my health that i could not determine myself",
    "brandPerception": "i think of the fact that it might change me and it has a negative connotation to me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 40,
    "income": "$200,000 or more",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:21 PM UTC",
    "goals": "I want to lose weight.",
    "priceObjection": "",
    "wtpFactors": "price",
    "brandPerception": "Nothing,",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1379,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 31,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:22 PM UTC",
    "goals": "I would like to be stronger and weigh a little less.",
    "priceObjection": "",
    "wtpFactors": "If I could get something reimbursed by insurance.",
    "brandPerception": "I’ve never heard it before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 930,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.692,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.615,
      "Body Composition Analysis": 0.692,
      "Workout Sessions": 0.385,
      "Recovery Sessions": 0.385,
      "Nutrition Tracking": 0.615
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:22 PM UTC",
    "goals": "Lose a few pounds, gain mobility, flexibility and stamina",
    "priceObjection": "",
    "wtpFactors": "The value of the product or program",
    "brandPerception": "It sounds like a subscription",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 41,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:22 PM UTC",
    "goals": "Eat healthier, reduce sugar, experiment with new treatment options.",
    "priceObjection": "Because I wouldn't pay for that type of benefit",
    "wtpFactors": "If it was a matter of life and death and my insurance didn't pay for it",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "Smart Watch with fitness tracker.",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 50,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Smart Watch with fitness tracker."
    ]
  },
  {
    "date": "Feb 19, 2026 6:22 PM UTC",
    "goals": "I have a lot of personal goals",
    "priceObjection": "",
    "wtpFactors": "I wil pay for it if it helps me lead a healthy lifestyle",
    "brandPerception": "I think of altering clothes and having them fit your body better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1112,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 4,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 46,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:25 PM UTC",
    "goals": "lose 10 pounds",
    "priceObjection": "",
    "wtpFactors": "if it is guarenteed to work",
    "brandPerception": "change it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1446,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 4,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:26 PM UTC",
    "goals": "plan to loose more weight and get in better health",
    "priceObjection": "",
    "wtpFactors": "since I am only self employed no full time job commission only",
    "brandPerception": "A way to transform my health and weight loss",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1007,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.385,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.615,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.308,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.769
    },
    "gender": "Male",
    "age": 54,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 7,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:26 PM UTC",
    "goals": "To maintain and continue to be healthy from the inside out.",
    "priceObjection": "",
    "wtpFactors": "Proven results that are shown, recommendations from doctors or fitness experts.",
    "brandPerception": "Never heard of it to be honest b",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 1156,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.714,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.571,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.571,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 49,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:28 PM UTC",
    "goals": "I don't want to be sick every day anymore.",
    "priceObjection": "",
    "wtpFactors": "i don't know",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:28 PM UTC",
    "goals": "i aspire to grow muscle mass in a couple of months for healthy body.",
    "priceObjection": "",
    "wtpFactors": "quality of service and comfortable to pay for  a long-term period",
    "brandPerception": "changing its quality",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1239,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "WHOOP"
    ],
    "wearableDevices": [
      "Garmin",
      "WHOOP",
      "Polar"
    ]
  },
  {
    "date": "Feb 19, 2026 6:28 PM UTC",
    "goals": "I would like  to eat better and workout more consistently.",
    "priceObjection": "",
    "wtpFactors": "My willingness to pay would depend on the proven results, affordability and personalized support of the program.",
    "brandPerception": "Personal transformation  and self improvement",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1352,
    "priceDistribution": {
      "499": 1,
      "999": 6,
      "1499": 1,
      "1699": 5,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:29 PM UTC",
    "goals": "I want to lose weight and get stronger. I don't have a lot of time to dedicate to it so small changes are going to be big for me.",
    "priceObjection": "",
    "wtpFactors": "That I can adapt it to my life.",
    "brandPerception": "Sounds like it changes your whole self. Not in a very positive way.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1009,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 2,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.7,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.7
    },
    "gender": "Female",
    "age": 39,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tonal",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:30 PM UTC",
    "goals": "I want to have longevity and good health",
    "priceObjection": "It’s too expensive",
    "wtpFactors": "Convenience and results",
    "brandPerception": "It seems rude",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 37,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:32 PM UTC",
    "goals": "I am maintaining my weight right now. Focused on losing inches and not pounds. Im focused on keeping my blood pressure down because I have a history with hypertension. And I wish to become more purposefully active in my everyday life",
    "priceObjection": "",
    "wtpFactors": "DNA report \nMeal plan \nWorkout plan \nWeekly weigh ins\nApp tracker for stats",
    "brandPerception": "A button for old folks to press when they fall and can't get up and need help",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 910,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.778,
      "Smart Biometrics Ring": 0.778,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.556,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 27,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Student",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:32 PM UTC",
    "goals": "My will help those aren't to stay fit by exercising and eating organic pure healthy foods",
    "priceObjection": "",
    "wtpFactors": "A very low reasonable price",
    "brandPerception": "Changing the way you look at the moment physically",
    "otherBrand": "",
    "otherDevice": "I use a digital skill that monitors my body mass and muscle mass and so on",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 3,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "I use a digital skill that monitors my body mass and muscle mass and so on"
    ]
  },
  {
    "date": "Feb 19, 2026 6:32 PM UTC",
    "goals": "One of my personal health goals is to gain more muscle.",
    "priceObjection": "",
    "wtpFactors": "How effective is the wellness program for all body types.",
    "brandPerception": "It sounds like something that is significant in changing your life, with a huge focus on the use of science.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 31,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:33 PM UTC",
    "goals": "To maintain my wight and stay healthy",
    "priceObjection": "",
    "wtpFactors": "If it included everything I need",
    "brandPerception": "I don't know",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1066,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.933
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tonal",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:33 PM UTC",
    "goals": "Stay hydrated, get enough sleep, eat healthy",
    "priceObjection": "I would not pay any money for a program",
    "wtpFactors": "If it is covered by my employer or reimburseable through a HSA",
    "brandPerception": "It seems like something DNA based or something about changing myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$200,000 or more",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:35 PM UTC",
    "goals": "I want to be healthy  and loose weight",
    "priceObjection": "",
    "wtpFactors": "the cost",
    "brandPerception": "change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 2,
      "999": 7,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Ladder",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:35 PM UTC",
    "goals": "I would like to loose a few pounds",
    "priceObjection": "",
    "wtpFactors": "If it's affordable and works well",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.625,
      "Smart Biometrics Ring": 0.375,
      "Personalized Wellness Plan": 0.25,
      "Body Composition Analysis": 0.625,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.125,
      "Nutrition Tracking": 0.375
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:36 PM UTC",
    "goals": "my personal health goal is to build my endurance and strength for muscle building",
    "priceObjection": "",
    "wtpFactors": "if the program is customised and have tangible benefits",
    "brandPerception": "A product or device which helps to change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 40,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Polar"
    ]
  },
  {
    "date": "Feb 19, 2026 6:39 PM UTC",
    "goals": "I would like to reduce my blood sugar a1c, maintain a healthy weight, and sleep better.",
    "priceObjection": "",
    "wtpFactors": "Proven effectiveness while not making a huge dent in my paycheck per month.",
    "brandPerception": "It means that change is a big factor and emphasis.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 759,
    "priceDistribution": {
      "499": 9,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:40 PM UTC",
    "goals": "Want to lose weight and firm up",
    "priceObjection": "",
    "wtpFactors": "I'm looking more for a structured workout plan and balancing hormones.",
    "brandPerception": "nothing, never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:43 PM UTC",
    "goals": "I would like to build muscle and lose some fat.",
    "priceObjection": "",
    "wtpFactors": "The benefits included and the things it offers.",
    "brandPerception": "Change Hange",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 562,
    "priceDistribution": {
      "499": 7,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.375,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.625,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:43 PM UTC",
    "goals": "I have been following a yoga class on YouTube.I try to be active in motion and I have added multi vitamins to my healthy diet .",
    "priceObjection": "",
    "wtpFactors": "To pay for any health plans would need to include monthly payments and all the features helpful nutrition plans a work out session and daily tips motivation",
    "brandPerception": "Alter me would mean a helpful tool to help change you into the goals you are seeking",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1137,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 4,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.462,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.692,
      "Workout Sessions": 0.769,
      "Recovery Sessions": 0.692,
      "Nutrition Tracking": 0.615
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:43 PM UTC",
    "goals": "Lowering my blood pressure and heart rate. Lose 30 lbs by summer.",
    "priceObjection": "",
    "wtpFactors": "Tailored work out programs for my goals i stated in the first few questions.",
    "brandPerception": "Not good. Sounds like a transgender factory, or at least a bedroom sexual suggestion.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 916,
    "priceDistribution": {
      "499": 1,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 7,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:43 PM UTC",
    "goals": "My current wellness goal is to lose weight by calorie deficit. Also, to eat low fat, low cal foods.",
    "priceObjection": "",
    "wtpFactors": "The ability to track health functions like sleep, BP, walking distance, body mass index, calories burned",
    "brandPerception": "To change myself somehow",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 8,
      "999": 3,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.8,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Tempo",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:44 PM UTC",
    "goals": "Looking to improve my overall health by adding muscle before cutting fat",
    "priceObjection": "",
    "wtpFactors": "Value is the most important thing. I won't pay for a gimmick; I'm looking for a tried and true plan that can guarantee results.",
    "brandPerception": "Never heard of them.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 939,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 32,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 6:45 PM UTC",
    "goals": "Reduce weight from a peak of 310 last May to ultimately 180.",
    "priceObjection": "",
    "wtpFactors": "I can’t see paying anywhere close to the amounts proposed here.  I have a FitBit, and a Smart Scale.  That along with MyFitnessPal is plenty.  And it’s under $250 for all.",
    "brandPerception": "Sounds like an ad for LSD.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1152,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 5,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:45 PM UTC",
    "goals": "Working on reaching and maintaining a healthy body weight",
    "priceObjection": "The cost is more than I would want to pay.",
    "wtpFactors": "The cost",
    "brandPerception": "Not much, I’ve never heard of it.",
    "otherBrand": "My fitness pal",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 0,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 1
    },
    "gender": "Female",
    "age": 49,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Other",
      "My fitness pal"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:45 PM UTC",
    "goals": "I want to lose weight this year. I want to consume healthier foods that cleanse and nourish my body and organs. I will also detox.",
    "priceObjection": "",
    "wtpFactors": "Work out plan, work out videos, calorie calculator, DNA makeup",
    "brandPerception": "Altering your body, reshaping your body, cleansing your body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.833,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:46 PM UTC",
    "goals": "My health or wellness goals are to be regulated in moderation of sugary snacks and bad or processed",
    "priceObjection": "",
    "wtpFactors": "The features",
    "brandPerception": "Maybe changes the body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1006,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.733,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:49 PM UTC",
    "goals": "I want to try and start exercising more",
    "priceObjection": "I can’t afford these",
    "wtpFactors": "I don’t know",
    "brandPerception": "I don’t know what this means",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:51 PM UTC",
    "goals": "My goal is to slowly gain weight as I build muscle. I want to maximize my one rep max on bench press, deadlift, and squat.",
    "priceObjection": "",
    "wtpFactors": "It has to work for my personal goals. If it's just some generalized \"get fit\" program, then I'm not interested. It has to be laser focused on what I'm trying to achieve.",
    "brandPerception": "It sounds like a trendy fitness studio or boutique plastic surgery company. It doesn't sound like something for the serious strength athelete.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.2,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 56,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "WHOOP"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:52 PM UTC",
    "goals": "I don't have any.",
    "priceObjection": "",
    "wtpFactors": "They were all way too expensive & I wouldn't actually get any of them. If I were in the market, I see which one protects my cash flow the longest, but I also HATE paying interest & would choose whichever one offered the best deal.",
    "brandPerception": "Never heard of it before.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 899,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 4,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 57,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Never",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:54 PM UTC",
    "goals": "I want to cut down on my sugar as well as caffeine intake",
    "priceObjection": "",
    "wtpFactors": "Positive reviews on the program from people that have used it",
    "brandPerception": "B health and fitness platform that personalizes wellness journey behavioral data and DNA",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1519,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 5,
      "1699": 0,
      "1899": 7
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 6:55 PM UTC",
    "goals": "Stretch more and less junk food.",
    "priceObjection": "",
    "wtpFactors": "Low cost",
    "brandPerception": "Unknown",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 932,
    "priceDistribution": {
      "499": 5,
      "999": 7,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.6
    },
    "gender": "Male",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 6:56 PM UTC",
    "goals": "I am trying to build strength and lose a little body fat.",
    "priceObjection": "The price is too high.",
    "wtpFactors": "Proven results and a recommendation from someone I trust.",
    "brandPerception": "I think of changes a person can make.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:57 PM UTC",
    "goals": "I go to the gym three times a week and I exercise at home. I tried to eat healthy and drink a lot of protein shakes.",
    "priceObjection": "",
    "wtpFactors": "If it’s a good program and it works and I get results",
    "brandPerception": "Custom weight loss",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1328,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.643,
      "Personalized Wellness Plan": 0.357,
      "Body Composition Analysis": 0.643,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.714,
      "Nutrition Tracking": 0.357
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 6:59 PM UTC",
    "goals": "I want to get nuild up some muscle and tone up my look. i also wasnt to build muscles up in my legss and back to help with past injuries.",
    "priceObjection": "",
    "wtpFactors": "THe DNa report, the workout sessions and the price",
    "brandPerception": "I think of changing one's body shape.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:01 PM UTC",
    "goals": "Navigating perimenopause and how to look my best for my age",
    "priceObjection": "",
    "wtpFactors": "Results driven is a must",
    "brandPerception": "Help me change my body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1252,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.267,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.867,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:02 PM UTC",
    "goals": "I need to get back in shape. It's more difficult to exercise now that we live in Minnesota. I also need to lose weight, which is also more difficult at my age.",
    "priceObjection": "",
    "wtpFactors": "If I knew it would actually work and would fit in to my schedule.",
    "brandPerception": "It sounds like a church app",
    "otherBrand": "",
    "otherDevice": "I have a generic one and am not sure the brand. It works very well for the price.",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "I have a generic one and am not sure the brand. It works very well for the price."
    ]
  },
  {
    "date": "Feb 19, 2026 7:04 PM UTC",
    "goals": "Maintain strength and muscle growth",
    "priceObjection": "I prefer to do my own research and create my plan",
    "wtpFactors": "I do it myself, no interest",
    "brandPerception": "I guess some sort of help program to shape body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:05 PM UTC",
    "goals": "To move more throughout the day",
    "priceObjection": "",
    "wtpFactors": "Insurance covers part or gives benefits.\n\nDoes not automatically share information.",
    "brandPerception": "It sounds like something from Black Mirror",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:05 PM UTC",
    "goals": "to tighten muscles",
    "priceObjection": "",
    "wtpFactors": "50% if I pay up-front for 4 months",
    "brandPerception": "nothing right now",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 1121,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 3,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.556,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.556,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.556,
      "Nutrition Tracking": 0.556
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:05 PM UTC",
    "goals": "Live long and be healthy.",
    "priceObjection": "No interest in paying for something like this.",
    "wtpFactors": "None",
    "brandPerception": "Nothing.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 53,
    "income": "$200,000 or more",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:07 PM UTC",
    "goals": "Keeping my fitness and achieving better rulers with my stamina along with growing more muscle",
    "priceObjection": "",
    "wtpFactors": "The benefits I can get any where else or part of another plan that works good for my fitness",
    "brandPerception": "Great plan trying help me achieve my forneesn",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1339,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 4,
      "1699": 2,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.8,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 38,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:09 PM UTC",
    "goals": "Sustainable weight loss and increased muscle tone",
    "priceObjection": "I would never pay that much for something I can do on my own",
    "wtpFactors": "Increased benefits",
    "brandPerception": "An alteration shop but I guess it could be used for wellness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 10,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 5,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.8,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:09 PM UTC",
    "goals": "I want to loose weight and feel healthy",
    "priceObjection": "",
    "wtpFactors": "Making sure the deal is conv",
    "brandPerception": "The type of ad",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1192,
    "priceDistribution": {
      "499": 4,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.867,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 30,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:09 PM UTC",
    "goals": "Lose weight and Mobility",
    "priceObjection": "",
    "wtpFactors": "Price is affordable",
    "brandPerception": "Never heard of it before",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:09 PM UTC",
    "goals": "I want to keep dancing and lose weight but feel good",
    "priceObjection": "",
    "wtpFactors": "If I have money to spare. For now I exercise at home",
    "brandPerception": "Alter my weight",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1212,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 2,
      "1699": 1,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 7:10 PM UTC",
    "goals": "I want to maintain my current health and fitness.",
    "priceObjection": "",
    "wtpFactors": "Whether or not I could afford it and if I would use it.",
    "brandPerception": "it certainly sounds sinister like a DNA experiment.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1439,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 31,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:11 PM UTC",
    "goals": "to lose 15 lbs",
    "priceObjection": "",
    "wtpFactors": "the price",
    "brandPerception": "not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1272,
    "priceDistribution": {
      "499": 3,
      "999": 4,
      "1499": 2,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 1,
      "User reviews/ratings": 7,
      "Technology used": 5,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:12 PM UTC",
    "goals": "I try my best to eat well an to exercise regularly",
    "priceObjection": "",
    "wtpFactors": "If it came specifically with technology such as the smart ring",
    "brandPerception": "It almost sounds like a prosthetic surgery clinic",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1472,
    "priceDistribution": {
      "499": 2,
      "999": 2,
      "1499": 3,
      "1699": 3,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 36,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:13 PM UTC",
    "goals": "To lose 12 pounds but gain more muscles for energy purposes",
    "priceObjection": "",
    "wtpFactors": "Not interest and more for dollar",
    "brandPerception": "Changing you from the outside in",
    "otherBrand": "",
    "otherDevice": "Fitness smartwatch",
    "otherGoal": "",
    "noneCount": 8,
    "segment": "selective",
    "avgChosenPrice": 570,
    "priceDistribution": {
      "499": 6,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.857,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.857,
      "Recovery Sessions": 0.429,
      "Nutrition Tracking": 0.429
    },
    "gender": "Male",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Other smart ring or fitness tracker",
      "Fitness smartwatch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:13 PM UTC",
    "goals": "I'm trying to become healthier to have more energy and lose weight",
    "priceObjection": "",
    "wtpFactors": "The overall value of the package",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1132,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 2,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 1,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:14 PM UTC",
    "goals": "I’d like to lose 50 pounds",
    "priceObjection": "",
    "wtpFactors": "If there is physical health involved such as diet and exercise regime",
    "brandPerception": "Surgery",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1492,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 3,
      "1699": 4,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.267,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 41,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "WHOOP"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 7:14 PM UTC",
    "goals": "It’s okay my wellness not that bad",
    "priceObjection": "",
    "wtpFactors": "It’s okay but it can better",
    "brandPerception": "Idk",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1566,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 2,
      "1699": 5,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 31,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:14 PM UTC",
    "goals": "Health is good, need to reduce weight",
    "priceObjection": "",
    "wtpFactors": "Monthly payment and coverage",
    "brandPerception": "Nope",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1435,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 2,
      "1699": 1,
      "1899": 6
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.643,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.357,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 4,
      "Technology used": 2,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Oura Ring",
      "Amazfit",
      "Polar"
    ]
  },
  {
    "date": "Feb 19, 2026 7:15 PM UTC",
    "goals": "Idk tbh",
    "priceObjection": "",
    "wtpFactors": "Idk tbh",
    "brandPerception": "Idk",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1379,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.2,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 27,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:15 PM UTC",
    "goals": "\"My primary health and wellness goals are centered on maintaining the physical stamina and hormonal stability required to manage Addison’s disease while balancing the demands of daily life. I am focused on strict medication adherence and stress management to prevent an adrenal crisis, especially as I navigate physical challenges related to my mobility and lung health. Additionally, because I am a consumer with low vision, a major wellness goal is to maintain a safe, high-contrast, and organized environment that allows me to navigate my home independently and efficiently. Ultimately, I am striving for a balance of physical health, restorative rest, and mental resilience to ensure I can manage my chronic conditions without compromising my overall quality of life.\"",
    "priceObjection": "",
    "wtpFactors": "\"My willingness to invest in a health and wellness program is primarily driven by its level of personalization and accessibility regarding my chronic conditions. I prioritize programs that offer individualized care plans specifically tailored to managing Addison’s disease and hormonal stability, rather than a general fitness approach. Accessibility is equally critical; as a low-vision consumer, I am most willing to pay for services that feature high-contrast digital interfaces and audio-supported coaching that I can use independently . Furthermore, I value programs that utilize telehealth and digital monitoring to help me conserve physical energy , as well as those led by specialized medical professionals who can help me prevent secondary complications like adrenal crises or respiratory issues . Ultimately, I am looking for a program that balances clinical expertise with the practical flexibility needed to maintain my health and independence at home. \"",
    "brandPerception": "\"When I hear 'AlterMe,' I think of a radically personalized health system that moves away from the 'one-size-fits-all' model by tailoring wellness directly to my unique biology. The name suggests an empowering, data-driven experience where DNA testing and real-time biometrics from the AlterMe Ring remove the guesswork from managing my health, allowing me to understand how my body handles stress and recovery. I particularly associate the brand with a 'work-in' philosophy —prioritizing restorative practices like breathwork and readiness over pure intensity—which is vital for someone like me who needs to carefully budget physical energy while managing chronic conditions. Additionally, the concept of a single, integrated wearable and app signals a level of independent monitoring that is highly accessible for a low-vision consumer. Ultimately, 'AlterMe' represents a science-backed partnership that helps me build long-term physical and mental resilience through expert-guided, personalized insights.\"",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1279,
    "priceDistribution": {
      "499": 5,
      "999": 1,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 29,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 7:16 PM UTC",
    "goals": "I want to tone my muscles and get in better shape. I would like to lose a few pounds, but am really focused on toning. I also want to get my flexibility back (former professional dancer) and just have more energy.",
    "priceObjection": "",
    "wtpFactors": "I think price is a main factor for sure, but then it would need to have actual workouts/classes I could do. That would be the main reason to use it at home instead of going somewhere, so that would be a must for me.",
    "brandPerception": "It makes me think of changing something about myself.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 726,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.727,
      "Smart Biometrics Ring": 0.545,
      "Personalized Wellness Plan": 0.455,
      "Body Composition Analysis": 0.727,
      "Workout Sessions": 0.636,
      "Recovery Sessions": 0.364,
      "Nutrition Tracking": 0.455
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:16 PM UTC",
    "goals": "i want to be happy in my own body",
    "priceObjection": "",
    "wtpFactors": "if it was affordable",
    "brandPerception": "nothing comes to mind",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 27,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:18 PM UTC",
    "goals": "My personal health goal is to moderate what I eat so I’m not eating too much junk but also eat things I love",
    "priceObjection": "",
    "wtpFactors": "If I wanted to lose weight or had a health issue that required exercise",
    "brandPerception": "I don’t know that brand so I’m not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 992,
    "priceDistribution": {
      "499": 6,
      "999": 4,
      "1499": 3,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 50,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:18 PM UTC",
    "goals": "Weight loss is like to get off preventative medication for high blood pressure",
    "priceObjection": "",
    "wtpFactors": "Expense and time",
    "brandPerception": "Change myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1372,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 4,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 35,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Amazfit",
      "Polar"
    ]
  },
  {
    "date": "Feb 19, 2026 7:18 PM UTC",
    "goals": "To loose 30 lbs in the next months",
    "priceObjection": "",
    "wtpFactors": "The deals included in the bundle",
    "brandPerception": "A fitness app but it’s a weird name",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1366,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.933,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 28,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 6,
      "Pricing": 5,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Ladder",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:20 PM UTC",
    "goals": "Trying to find motivation to stick to a diet and energy to exercise more",
    "priceObjection": "I wouldn’t spend the money",
    "wtpFactors": "Price",
    "brandPerception": "Body transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 51,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:20 PM UTC",
    "goals": "My personal health goals are to lose weight, work out, and continue to meditate and practice mindfulness.",
    "priceObjection": "",
    "wtpFactors": "The factors that would most influence my willingness to pay for a health and wellness program is a program that offered personal services related specifically to my needs.",
    "brandPerception": "When I hear \"AlterMe\" I think of a service that provides change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 957,
    "priceDistribution": {
      "499": 4,
      "999": 5,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.583
    },
    "gender": "Female",
    "age": 53,
    "income": "$200,000 or more",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 7,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:21 PM UTC",
    "goals": "To get onto a consistent exercise schedule and to eat more healthy with a reasonable portion",
    "priceObjection": "",
    "wtpFactors": "If I felt like it would actually help and not just hype up a program that is no better than YouTube videos",
    "brandPerception": "Sounds like a shortcut to exercising and is unhealthy",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1032,
    "priceDistribution": {
      "499": 7,
      "999": 2,
      "1499": 3,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:25 PM UTC",
    "goals": "i want to try to be healthier and gain more muscle",
    "priceObjection": "",
    "wtpFactors": "just long term results that are proven",
    "brandPerception": "makes me think of altering yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1299,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 5,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 1,
      "Pricing": 5,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 7:25 PM UTC",
    "goals": "To not be on any medications until absolutely necessary.",
    "priceObjection": "",
    "wtpFactors": "I would have to make payment’s.",
    "brandPerception": "Getting into shape “changing” how I look",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:26 PM UTC",
    "goals": "Walking 10000 steps daily, eating healthy and avoiding alc",
    "priceObjection": "",
    "wtpFactors": "Lower prices and more food",
    "brandPerception": "A different new and changing me and transformative version",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 839,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 1,
      "1699": 1,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 52,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:28 PM UTC",
    "goals": "being more active staying consistent with the treadmill or walking outside and incorporating some small weights for muscle tone.",
    "priceObjection": "",
    "wtpFactors": "To be honest I don't think I would consider any of them if the lowest priced one is 499   It is too easy to find the info online to have to pay that much for one",
    "brandPerception": "surgery to change you from a woman to a man",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 914,
    "priceDistribution": {
      "499": 7,
      "999": 2,
      "1499": 3,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.615,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.615,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.385,
      "Recovery Sessions": 0.692,
      "Nutrition Tracking": 0.385
    },
    "gender": "Female",
    "age": 48,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:29 PM UTC",
    "goals": "Na",
    "priceObjection": "",
    "wtpFactors": "Na",
    "brandPerception": "Na",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1259,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 4,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.733,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 37,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 2,
      "Payment terms": 5,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:34 PM UTC",
    "goals": "My current health/wellness goals are to nourish my body with whole foods, reduce stress and get in more movement.",
    "priceObjection": "",
    "wtpFactors": "I personally wouldn't because I can't afford it.",
    "brandPerception": "Make you different than you are now, hopefully healthier overall.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 1,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:35 PM UTC",
    "goals": "I want to be more cardiovascularly fit and lose a bit of weight. I want to sleep better",
    "priceObjection": "",
    "wtpFactors": "Paying in full and having access to wellness products and recovery services",
    "brandPerception": "Never heard of it. Change my body",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 1291,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 0,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.583,
      "Personalized Wellness Plan": 0.417,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 1,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.417
    },
    "gender": "Male",
    "age": 35,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 7:38 PM UTC",
    "goals": "My goal is to lose more weight and gain more muscle mass",
    "priceObjection": "",
    "wtpFactors": "If it's not subscription based",
    "brandPerception": "Something that helps me change.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1399,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 3,
      "1699": 4,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 4
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:38 PM UTC",
    "goals": "I am currently trying to lose 70 pounds within a year. I have a gym membership, I have exercise equipment at home, I attend workout classes, I have home workout videos, and I have an iWatch to track my fitness goals.",
    "priceObjection": "",
    "wtpFactors": "Nutrition that helps with meal plans so that I didn't have to think about what to cook or eat. I am just following a meal plan designed to help me lose weight.",
    "brandPerception": "I am not familiar with this, but it sounds like you will be altering how you look.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1190,
    "priceDistribution": {
      "499": 2,
      "999": 4,
      "1499": 2,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.818,
      "Smart Biometrics Ring": 0.636,
      "Personalized Wellness Plan": 0.636,
      "Body Composition Analysis": 0.818,
      "Workout Sessions": 0.818,
      "Recovery Sessions": 0.364,
      "Nutrition Tracking": 0.545
    },
    "gender": "Female",
    "age": 43,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:39 PM UTC",
    "goals": "I want to be a healthy weight for my age. I want to lower my blood pressure. I want to set a good example for my kids.",
    "priceObjection": "",
    "wtpFactors": "Monthly payment options, plans that have convenience included, easy to follow workouts and instructions, a nutrition plan that is easy to purchase.",
    "brandPerception": "Seems like it doesn't make",
    "otherBrand": "Garmin",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 7,
    "segment": "selective",
    "avgChosenPrice": 749,
    "priceDistribution": {
      "499": 5,
      "999": 2,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.875,
      "Personalized Wellness Plan": 0.625,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.625,
      "Recovery Sessions": 0.75,
      "Nutrition Tracking": 0.625
    },
    "gender": "Male",
    "age": 37,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 4,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 4
    },
    "brandConsideration": [
      "WHOOP",
      "Noom",
      "Other",
      "Garmin"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 7:40 PM UTC",
    "goals": "My goal is to begin an exercise program to hopefully lose 50+ pounds and look for supplements to help with weightloss.",
    "priceObjection": "",
    "wtpFactors": "The cost is most important.  I need something very affordable as the cost of living is so high right now.",
    "brandPerception": "Changing a person in some form ie: mentally or physically.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:41 PM UTC",
    "goals": "my goals are to maintain strength and cardio fitness so I can stay active for many decades",
    "priceObjection": "this is more than I would spend on a wellness program",
    "wtpFactors": "If I felt I could not put together a fitness program on my own and was wealthy I might consider a product like this",
    "brandPerception": "it makes me think I am not ok as I am and it is not appealing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 34,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:41 PM UTC",
    "goals": "Lose a lot of weight through diet and exercise.",
    "priceObjection": "I don't have that kind of money",
    "wtpFactors": "Much lower price",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:43 PM UTC",
    "goals": "To",
    "priceObjection": "",
    "wtpFactors": "Price vs amenities",
    "brandPerception": "New me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1419,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 1,
      "1699": 4,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 36,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 2,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:45 PM UTC",
    "goals": "I have started trying to gain weight because my weight dropped down to 119 pounds and that is way too low for my physical height and frame. I have successfully gained 40 pounds.",
    "priceObjection": "",
    "wtpFactors": "If it helps me achieve my  health goals, I’ll gladly pay for it.",
    "brandPerception": "Change…changing your body in a positive way",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 4,
      "1699": 3,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.733,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 53,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 5,
      "Device integration": 1
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 7:47 PM UTC",
    "goals": "Mainly to have more overall energy to walk longer distances",
    "priceObjection": "",
    "wtpFactors": "Mainly if there were the option to pick specialists in the direct medical issues I have so we would get the exercise or medical treatments that would directly impact and improve the most problematic areas of my body.",
    "brandPerception": "Possibly some needless surgery based additions to the already existing fitness regimen",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 739,
    "priceDistribution": {
      "499": 7,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.3,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.8,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.7,
      "Nutrition Tracking": 0.8
    },
    "gender": "Male",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:48 PM UTC",
    "goals": "Lose another 30 lbs",
    "priceObjection": "",
    "wtpFactors": "I do t have 1500bucks 5o sp3nd on much of anything",
    "brandPerception": "No idea",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 799,
    "priceDistribution": {
      "499": 8,
      "999": 5,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 42,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Fitbit",
      "Noom"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:48 PM UTC",
    "goals": "To lose at leastv40 lbs by mid-summer and to maintain and remain healthy and active!",
    "priceObjection": "TOO EXPENSIVE I AM NOT PAYING FOR NONE OF IT.",
    "wtpFactors": "Nothing!!!",
    "brandPerception": "Change your appearance",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 52,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:49 PM UTC",
    "goals": "I am now in my mid-40s and have entered into perimenopause, so my goals are trying to eat healthier, get back to working out more, and watching my sodium, sugar, and fat intake. Lastly, I'm still focusing on making sure I'm physically, mentally, and emotionally taking care of myself.",
    "priceObjection": "I am not interested in an expensive program like this",
    "wtpFactors": "I want to pay a one time, affordable price for ongoing monthly data about my health and wellness.",
    "brandPerception": "I think of something that will change you (hopefully for the better).",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Student",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:54 PM UTC",
    "goals": "Get my diabetes under control.",
    "priceObjection": "",
    "wtpFactors": "Price",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1306,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 4,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.933
    },
    "gender": "Female",
    "age": 44,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 4,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:54 PM UTC",
    "goals": "Lose 5 pounds, and get in better cardio shape.",
    "priceObjection": "All plans are too expensive for me.",
    "wtpFactors": "trial period, or cheaper price",
    "brandPerception": "Changing perspectives",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 14,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 1,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 1,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 57,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 7,
      "Workout Sessions": 6,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 7:54 PM UTC",
    "goals": "Lose weight and exercise more",
    "priceObjection": "I wouldn’t pay that much for any plan",
    "wtpFactors": "Cost and success record",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 52,
    "income": "$200,000 or more",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 3,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:55 PM UTC",
    "goals": "I don't really have any personal health or Wellness goals.",
    "priceObjection": "I wouldn't spend anywhere near that much.",
    "wtpFactors": "It would have to be free.",
    "brandPerception": "I've never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 49,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 7,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:55 PM UTC",
    "goals": "I am exercising more frequently and trying to eat somewhat healthier. I am working out at least three days a week . I also am cutting out more soda and drinking more water.",
    "priceObjection": "Way to expensive",
    "wtpFactors": "If it was really cheap like ten dollars",
    "brandPerception": "Get me fit . Get me to look better",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:56 PM UTC",
    "goals": "I want to lose weight and gain muscle.",
    "priceObjection": "",
    "wtpFactors": "The recovery process and overall program\nThe food thats offered.",
    "brandPerception": "Nothing ive never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 49,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 2,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Fitbit",
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:56 PM UTC",
    "goals": "Stay fit",
    "priceObjection": "Too expensive",
    "wtpFactors": "For in person only",
    "brandPerception": "nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 40,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:56 PM UTC",
    "goals": "I want to lose weight and greatly improve my stress tolerance and mental health.",
    "priceObjection": "",
    "wtpFactors": "A proven track record of results.",
    "brandPerception": "Some sort of future tech that alters one's body composition.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1445,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 3,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.462,
      "Smart Biometrics Ring": 0.692,
      "Personalized Wellness Plan": 0.462,
      "Body Composition Analysis": 0.538,
      "Workout Sessions": 0.462,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.615
    },
    "gender": "Male",
    "age": 29,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 7:57 PM UTC",
    "goals": "Stay strong and well",
    "priceObjection": "",
    "wtpFactors": "Good reviews",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 812,
    "priceDistribution": {
      "499": 9,
      "999": 3,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.667
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 7:58 PM UTC",
    "goals": "I wish I felt better and had an appetite",
    "priceObjection": "",
    "wtpFactors": "The price",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 879,
    "priceDistribution": {
      "499": 7,
      "999": 5,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.2,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Female",
    "age": 37,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Never",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 6
    },
    "brandConsideration": [
      "Tonal"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 7:59 PM UTC",
    "goals": "My personal health goals is to lose 5 pounds and become more healthy by exercising and fasting more",
    "priceObjection": "",
    "wtpFactors": "The yuttors that would influence me is the one that specializes in the field as Mr x and the ones that have the most experience in the results I want",
    "brandPerception": "What comes to mind is that to take me from the state I'm I. To a higher energy state",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 2,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 51,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 3,
      "Pricing": 4,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Noom"
    ],
    "wearableDevices": [
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 8:02 PM UTC",
    "goals": "I want to be healthier and have more energy",
    "priceObjection": "",
    "wtpFactors": "Because it’s priceless",
    "brandPerception": "Become better version of yourself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1492,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 3,
      "1699": 6,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.733,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 28,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 7,
      "Pricing": 3,
      "Payment terms": 5,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 4
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:02 PM UTC",
    "goals": "Not to die.  To have a decent quality of life and stay in shape.",
    "priceObjection": "That’s ridiculous for what can be found for free",
    "wtpFactors": "Overall health",
    "brandPerception": "Bad acid trip",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 57,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:02 PM UTC",
    "goals": "I want to get more fit and lose a little more weight. I started a small health journey but want to be better",
    "priceObjection": "I wouldn't pay that much for a wellness report",
    "wtpFactors": "If it was guaranteed results to get to my goal weight within a certain timeframe.",
    "brandPerception": "Make changes to yourself with help",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 44,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 4,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 8:03 PM UTC",
    "goals": "My goal currently is to have functional strength and endurance to do the daily things in life without feeling winded.",
    "priceObjection": "I would not spend that amount of money on any health and wellness program.",
    "wtpFactors": "Affordability, and the inclusion of a well-rounded regimen that includes recovery, nutrition, and guided workouts as a part of the program.",
    "brandPerception": "It sounds like changing me in a way that does not sound like health and wellness honestly.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 11,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 4,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.75,
      "Smart Biometrics Ring": 0.75,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.75,
      "Workout Sessions": 0.25,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 2,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:03 PM UTC",
    "goals": "I want to find movement that is sustainable and fits into my life naturally without grinding or having analytical",
    "priceObjection": "",
    "wtpFactors": "Personalization and planning customized",
    "brandPerception": "Nothing",
    "otherBrand": "Aura",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1026,
    "priceDistribution": {
      "499": 6,
      "999": 3,
      "1499": 4,
      "1699": 2,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.733,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.867,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 29,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 6,
      "Payment terms": 3,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Other",
      "Aura"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:04 PM UTC",
    "goals": "Loose weight",
    "priceObjection": "",
    "wtpFactors": "Good apps that",
    "brandPerception": "Fix my bod",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1126,
    "priceDistribution": {
      "499": 5,
      "999": 4,
      "1499": 1,
      "1699": 3,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 48,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 8:04 PM UTC",
    "goals": "I health goals are to lose over 100 pounds and keep it off. By eating healthier and also working out a lot more and keeping stress down as well.",
    "priceObjection": "",
    "wtpFactors": "Just depends on the price and how long I am going to have to pay for it",
    "brandPerception": "To me it means altering my body for how it should be",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 989,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.1,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.5,
      "Workout Sessions": 0.8,
      "Recovery Sessions": 0.7,
      "Nutrition Tracking": 0.1
    },
    "gender": "Female",
    "age": 46,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 1,
      "Technology used": 5,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:06 PM UTC",
    "goals": "Strength training and adding muscle",
    "priceObjection": "",
    "wtpFactors": "Proven results",
    "brandPerception": "Changing myself",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 946,
    "priceDistribution": {
      "499": 6,
      "999": 5,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.6,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 56,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 7,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 6
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:07 PM UTC",
    "goals": "To lose weight and stop smoking.",
    "priceObjection": "",
    "wtpFactors": "If it  actually works",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 1461,
    "priceDistribution": {
      "499": 2,
      "999": 1,
      "1499": 4,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.462,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.923,
      "Recovery Sessions": 0.462,
      "Nutrition Tracking": 0.538
    },
    "gender": "Female",
    "age": 43,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 1,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 3,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:08 PM UTC",
    "goals": "To lose all the weight I don't want",
    "priceObjection": "",
    "wtpFactors": "Because it has the lowest payment",
    "brandPerception": "Change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Male",
    "age": 40,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 2,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:09 PM UTC",
    "goals": "better well being",
    "priceObjection": "",
    "wtpFactors": "better living",
    "brandPerception": "change my fitness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 912,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 3,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 44,
    "income": "$200,000 or more",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 7,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 3
    },
    "brandConsideration": [
      "Tonal",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:10 PM UTC",
    "goals": "Losing the stomach pouch and tightening up loose skin",
    "priceObjection": "I rather work out on my own then to pay that amount of money.",
    "wtpFactors": "There aren't any",
    "brandPerception": "Sculpting the body",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:11 PM UTC",
    "goals": "I just want to be healthier overall",
    "priceObjection": "",
    "wtpFactors": "How effective it is",
    "brandPerception": "That it's really",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1346,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 2,
      "1699": 3,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "NorthEast",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 7,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 2,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Garmin",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 8:12 PM UTC",
    "goals": "I go the gym and I calorie count but not currently at this time.",
    "priceObjection": "",
    "wtpFactors": "If there was an affordable plan that would specialize around my diet as I am gluten free. Also I like the specialized workputs",
    "brandPerception": "To change something about you.",
    "otherBrand": "I now have a tracker that isn't bluetooth. It tracks calories, steps and miles. I like that I don't have to worry about it for health reasons.",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 6,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.5,
      "Personalized Wellness Plan": 0.833,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.167,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Other",
      "I now have a tracker that isn't bluetooth. It tracks calories, steps and miles. I like that I don't have to worry about it for health reasons."
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:15 PM UTC",
    "goals": "I look forward to loose weight",
    "priceObjection": "",
    "wtpFactors": "Affordability",
    "brandPerception": "Change me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 2,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.6,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.8
    },
    "gender": "Female",
    "age": 31,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 5,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 5,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 4,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Oura Ring"
    ]
  },
  {
    "date": "Feb 19, 2026 8:15 PM UTC",
    "goals": "I would like to be more active, and lose some weight. I would like to join a gym or a fitness class to get extra motivation. I am interested in improving my diet, with new healthy and nutritious recipes.",
    "priceObjection": "",
    "wtpFactors": "It needs to be a program that I actually use and stick with ,and it provides me with reliable results that help improve my overall fitness and health.",
    "brandPerception": "Body transformation through nutrition and exercise.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 9,
    "segment": "selective",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.667,
      "Body Composition Analysis": 0.667,
      "Workout Sessions": 0.833,
      "Recovery Sessions": 0.833,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 2,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Fitbit",
      "WHOOP",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:15 PM UTC",
    "goals": "None",
    "priceObjection": "",
    "wtpFactors": "None",
    "brandPerception": "None",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 1089,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.3,
      "Smart Biometrics Ring": 0.3,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.2,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.3,
      "Nutrition Tracking": 0.5
    },
    "gender": "Male",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "I don't have a specific goal right now",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 2,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 5,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:16 PM UTC",
    "goals": "I would like to move around more, eat healthier by watching my calorie intake and lose weight.",
    "priceObjection": "",
    "wtpFactors": "The most benefits at the best price and payment plan or pay over time options",
    "brandPerception": "Change me and my lifestyle",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 999,
    "priceDistribution": {
      "499": 3,
      "999": 3,
      "1499": 3,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.889,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.778,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.778
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:20 PM UTC",
    "goals": "Walking and using a Google watch",
    "priceObjection": "Too expensive",
    "wtpFactors": "How I am feeling",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 807,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 2,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.385,
      "Smart Biometrics Ring": 0.462,
      "Personalized Wellness Plan": 0.615,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.615,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.462
    },
    "gender": "Male",
    "age": 53,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "Not sure",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 5,
      "Technology used": 1,
      "Device integration": 6
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:20 PM UTC",
    "goals": "I would like to get strong and toned. I would also like to be healthy",
    "priceObjection": "",
    "wtpFactors": "The price and whether I can pay monthly rather than all at once.",
    "brandPerception": "Something that allows you to alter your body.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 3,
    "segment": "selective",
    "avgChosenPrice": 666,
    "priceDistribution": {
      "499": 8,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.583,
      "Smart Biometrics Ring": 0.417,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.583,
      "Workout Sessions": 0.75,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.583
    },
    "gender": "Female",
    "age": 44,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 3,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 7,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 3,
      "Technology used": 6,
      "Device integration": 5
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:21 PM UTC",
    "goals": "Eat optimally for this new stage of life (post menopause). Slowly get back to good health after current surgery recovery.",
    "priceObjection": "",
    "wtpFactors": "Types of workouts available",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "Recovering from major surgery",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1185,
    "priceDistribution": {
      "499": 4,
      "999": 2,
      "1499": 5,
      "1699": 3,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.429,
      "Smart Biometrics Ring": 0.643,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.571,
      "Workout Sessions": 0.571,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.714
    },
    "gender": "Female",
    "age": 47,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Other",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 7,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 8:23 PM UTC",
    "goals": "Good personal health \nExercise everyday",
    "priceObjection": "",
    "wtpFactors": "Time and money",
    "brandPerception": "Change how I look",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1699,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 5,
      "1699": 5,
      "1899": 5
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.533,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.467
    },
    "gender": "Male",
    "age": 47,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 6,
      "Pricing": 1,
      "Payment terms": 3,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 2
    },
    "brandConsideration": [
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Garmin",
      "Amazfit"
    ]
  },
  {
    "date": "Feb 19, 2026 8:24 PM UTC",
    "goals": "I’m building a sustainable home exercise routine. We have a home gym system along with free weights and a recumbent bike. I want to maintain my weight loss and possibly lose another 10 pounds.",
    "priceObjection": "",
    "wtpFactors": "It would have to include individual personalizations. I would purchase a program today if it offered a personalized training regimen, help creating personalized, simple, nutritious meals that taste good to me and are easy to make. And help with any questions that would arise along the way.",
    "brandPerception": "Maybe a program designed to help me change myself for the better.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 55,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 7,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 8:25 PM UTC",
    "goals": "Maintain weight, become toned and firm",
    "priceObjection": "Cost too much",
    "wtpFactors": "The cost and effectiveness",
    "brandPerception": "Smart devices",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 13,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 2,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 0.5
    },
    "gender": "Female",
    "age": 38,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 3,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 4,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 5,
      "Technology used": 7,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit"
    ],
    "wearableDevices": [
      "Google Pixel Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:27 PM UTC",
    "goals": "lose 20 pounds this year. 7.5k steps daily.",
    "priceObjection": "",
    "wtpFactors": "price, cancellation policy.",
    "brandPerception": "sex change",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 38,
    "income": "$100,000 - $199,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 8:28 PM UTC",
    "goals": "Healthy lifestyle along with goals to maintain fitness.",
    "priceObjection": "Working out shouldn't cost",
    "wtpFactors": "None. I workout for free and do my own research",
    "brandPerception": "Get ready to mimic a workout routine you were shown",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 34,
    "income": "$50,000 - $74,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 4,
      "Brand reputation": 2,
      "Pricing": 7,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tempo"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:30 PM UTC",
    "goals": "Less calories more protein trying to lose 20 pounds",
    "priceObjection": "",
    "wtpFactors": "Cost and reduction in price if paid in full",
    "brandPerception": "Changing my style, habits",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 946,
    "priceDistribution": {
      "499": 7,
      "999": 3,
      "1499": 4,
      "1699": 1,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 53,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Retired",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Not very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 4,
      "User reviews/ratings": 5,
      "Technology used": 6,
      "Device integration": 1
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:32 PM UTC",
    "goals": "keeping my weight down &try to stay fit.",
    "priceObjection": "",
    "wtpFactors": "I would not pay this much.",
    "brandPerception": "not sure",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 5,
    "segment": "selective",
    "avgChosenPrice": 549,
    "priceDistribution": {
      "499": 9,
      "999": 1,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.5,
      "Smart Biometrics Ring": 0.4,
      "Personalized Wellness Plan": 0.4,
      "Body Composition Analysis": 0.4,
      "Workout Sessions": 0.7,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.3
    },
    "gender": "Female",
    "age": 42,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 4,
      "Pricing": 5,
      "Payment terms": 7,
      "User reviews/ratings": 6,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Tonal",
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:32 PM UTC",
    "goals": "I want to sleep better.",
    "priceObjection": "",
    "wtpFactors": "unsure",
    "brandPerception": "change my behaviors",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$200,000 or more",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:34 PM UTC",
    "goals": "Get strong and lose weight",
    "priceObjection": "",
    "wtpFactors": "To assure accountability.",
    "brandPerception": "Changing something about me permanently.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1199,
    "priceDistribution": {
      "499": 4,
      "999": 3,
      "1499": 5,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.467,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.4,
      "Nutrition Tracking": 0.467
    },
    "gender": "Female",
    "age": 55,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Improving sleep and recovery",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 3,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 6,
      "Workout Sessions": 1,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 3,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Fitbit"
    ]
  },
  {
    "date": "Feb 19, 2026 8:34 PM UTC",
    "goals": "I want to feel better overall.",
    "priceObjection": "",
    "wtpFactors": "I think if it was more personal",
    "brandPerception": "I think of wellness",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1332,
    "priceDistribution": {
      "499": 2,
      "999": 3,
      "1499": 7,
      "1699": 1,
      "1899": 2
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.467,
      "Smart Biometrics Ring": 0.667,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 35,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 5,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 1,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Tempo",
      "Tonal",
      "Ladder",
      "Fitbit",
      "WHOOP",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers",
      "AlterMe"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:35 PM UTC",
    "goals": "I would like to get back my insurance as well as told my body",
    "priceObjection": "",
    "wtpFactors": "Having no interest and a lot of time to pay",
    "brandPerception": "It sounds weird",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1119,
    "priceDistribution": {
      "499": 7,
      "999": 1,
      "1499": 1,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.533,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.6,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 37,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 7,
      "Workout Sessions": 1,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 1,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 4
    },
    "brandConsideration": [
      "Peloton",
      "Ladder",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:39 PM UTC",
    "goals": "It's to go out more",
    "priceObjection": "",
    "wtpFactors": "The price",
    "brandPerception": "None",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1378,
    "priceDistribution": {
      "499": 1,
      "999": 5,
      "1499": 2,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.571,
      "Smart Biometrics Ring": 0.571,
      "Personalized Wellness Plan": 0.5,
      "Body Composition Analysis": 0.429,
      "Workout Sessions": 0.429,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Professional degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 7,
      "Body Composition Analysis": 5,
      "Workout Sessions": 2,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 1
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Disagree",
      "Recovery content is important for my fitness routine": "Disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 2,
      "Payment terms": 4,
      "User reviews/ratings": 6,
      "Technology used": 7,
      "Device integration": 1
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:39 PM UTC",
    "goals": "Exercise, healthy eating",
    "priceObjection": "",
    "wtpFactors": "If it would be beneficial",
    "brandPerception": "Transformation",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 681,
    "priceDistribution": {
      "499": 7,
      "999": 4,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.364,
      "Smart Biometrics Ring": 0.455,
      "Personalized Wellness Plan": 0.636,
      "Body Composition Analysis": 0.636,
      "Workout Sessions": 0.545,
      "Recovery Sessions": 0.364,
      "Nutrition Tracking": 0.455
    },
    "gender": "Female",
    "age": 50,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Disabled",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Increasing daily activity or movement",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 2,
      "Recovery Sessions": 6,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 1,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 3,
      "Technology used": 5,
      "Device integration": 7
    },
    "brandConsideration": [
      "Fitbit"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:40 PM UTC",
    "goals": "I'm trying to deal with diabetes.",
    "priceObjection": "",
    "wtpFactors": "It needs to be cheaper.",
    "brandPerception": "Never heard of it.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 53,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Homemaker / Stay-at-home parent",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Never",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Somewhat important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 3
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:40 PM UTC",
    "goals": "it is good",
    "priceObjection": "",
    "wtpFactors": "to be healthy",
    "brandPerception": "timing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1319,
    "priceDistribution": {
      "499": 2,
      "999": 5,
      "1499": 3,
      "1699": 1,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.8,
      "Smart Biometrics Ring": 0.533,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.6,
      "Nutrition Tracking": 0.533
    },
    "gender": "Male",
    "age": 41,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "No college",
    "employmentStatus": "Employed, part-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Reducing stress and improving mental wellness",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 5,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 5,
      "Pricing": 3,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 1,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 8:40 PM UTC",
    "goals": "I am trying to lose at least 18 pounds. I also want to.",
    "priceObjection": "",
    "wtpFactors": "If it would be 1/3 off I think its worth it to pay in cull",
    "brandPerception": "It sounds like you want a transformation.",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 1,
    "segment": "selective",
    "avgChosenPrice": 1306,
    "priceDistribution": {
      "499": 1,
      "999": 5,
      "1499": 5,
      "1699": 2,
      "1899": 1
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.357,
      "Smart Biometrics Ring": 0.429,
      "Personalized Wellness Plan": 0.714,
      "Body Composition Analysis": 0.357,
      "Workout Sessions": 0.357,
      "Recovery Sessions": 0.5,
      "Nutrition Tracking": 0.571
    },
    "gender": "Female",
    "age": 35,
    "income": "$100,000 - $199,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "South",
    "monthlySpend": "$100–$199/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 2,
      "Body Composition Analysis": 4,
      "Workout Sessions": 5,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Neither agree nor disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 1,
      "Pricing": 6,
      "Payment terms": 4,
      "User reviews/ratings": 3,
      "Technology used": 2,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Noom",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:43 PM UTC",
    "goals": "Keep healthy",
    "priceObjection": "I wouldn't pay for this",
    "wtpFactors": "If I will stick to it",
    "brandPerception": "Another expensive fitness thing that will fade",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 832,
    "priceDistribution": {
      "499": 1,
      "999": 2,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.333,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 1,
      "Workout Sessions": 0.667,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Somewhat important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Not very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 7,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 2,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 4,
      "Device integration": 3
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:45 PM UTC",
    "goals": "Weight loss",
    "priceObjection": "",
    "wtpFactors": "Weight",
    "brandPerception": "Nothing",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 6,
    "segment": "selective",
    "avgChosenPrice": 610,
    "priceDistribution": {
      "499": 8,
      "999": 0,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.556,
      "Smart Biometrics Ring": 0.556,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.444,
      "Workout Sessions": 0.556,
      "Recovery Sessions": 0.444,
      "Nutrition Tracking": 0.333
    },
    "gender": "Female",
    "age": 51,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "36 monthly payments (lowest monthly, interest applies)",
    "featureImportance": {
      "DNA Health Report": "Somewhat important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 5,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 3,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 6
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 7,
      "Pricing": 1,
      "Payment terms": 6,
      "User reviews/ratings": 2,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Peloton",
      "Apple Fitness+",
      "Weight Watchers"
    ],
    "wearableDevices": [
      "Apple Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:47 PM UTC",
    "goals": "I would like to become more active and lose some weight",
    "priceObjection": "",
    "wtpFactors": "If it actually seem b worth it",
    "brandPerception": "Never heard of it",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 4,
    "segment": "selective",
    "avgChosenPrice": 1244,
    "priceDistribution": {
      "499": 3,
      "999": 2,
      "1499": 3,
      "1699": 0,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.636,
      "Smart Biometrics Ring": 0.727,
      "Personalized Wellness Plan": 0.545,
      "Body Composition Analysis": 0.364,
      "Workout Sessions": 0.636,
      "Recovery Sessions": 0.818,
      "Nutrition Tracking": 0.273
    },
    "gender": "Male",
    "age": 38,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "Midwest",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Not very important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 6,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 1,
      "Workout Sessions": 5,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Disagree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 7,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 3,
      "Technology used": 4,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "Samsung Galaxy Watch"
    ]
  },
  {
    "date": "Feb 19, 2026 8:47 PM UTC",
    "goals": "I want to stay healthy and fit through healthy eating and being physically active.",
    "priceObjection": "There's no way I would be hoodwinked into paying for one of these ripoff schemes.",
    "wtpFactors": "None",
    "brandPerception": "I'm not good enough, fix me",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 46,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Self-employed / Freelancer",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I prefer simple, straightforward options",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Very frequently (weekly)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Not at all important",
      "Body Composition Analysis": "Not at all important",
      "Workout Sessions": "Not at all important",
      "Recovery Sessions": "Not at all important",
      "Nutrition Tracking": "Not at all important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 4,
      "Recovery Sessions": 2,
      "Nutrition Tracking": 3
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Strongly disagree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly disagree",
      "Recovery content is important for my fitness routine": "Strongly disagree",
      "Nutrition guidance is essential for health and wellness": "Strongly disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 2,
      "Payment terms": 6,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:47 PM UTC",
    "goals": "Lose weight keep A1C down.",
    "priceObjection": "I would never want to pay 1499 for a workout program.",
    "wtpFactors": "no interest monthly payments.",
    "brandPerception": "I would say, excuse me what?",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 12,
    "segment": "selective",
    "avgChosenPrice": 499,
    "priceDistribution": {
      "499": 3,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 1,
      "Smart Biometrics Ring": 0.333,
      "Personalized Wellness Plan": 0.333,
      "Body Composition Analysis": 0.333,
      "Workout Sessions": 0.333,
      "Recovery Sessions": 0.333,
      "Nutrition Tracking": 0.667
    },
    "gender": "Female",
    "age": 42,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Grad school degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "Nothing / I don't currently spend on these",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Rarely (less than once a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Not at all important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Somewhat important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 3,
      "Smart Biometrics Ring": 7,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Neither agree nor disagree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 1,
      "Payment terms": 2,
      "User reviews/ratings": 4,
      "Technology used": 6,
      "Device integration": 7
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 8:49 PM UTC",
    "goals": "Continue taking care of my health internally and phy",
    "priceObjection": "",
    "wtpFactors": "Quality and accuracy of information",
    "brandPerception": "Transformation of health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1166,
    "priceDistribution": {
      "499": 6,
      "999": 2,
      "1499": 1,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.467,
      "Personalized Wellness Plan": 0.267,
      "Body Composition Analysis": 0.6,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.533,
      "Nutrition Tracking": 0.533
    },
    "gender": "Female",
    "age": 43,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "West",
    "monthlySpend": "$200 or more/month",
    "purchaseApproach": "I seek products with advanced features",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Extremely important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Extremely important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 5,
      "Personalized Wellness Plan": 1,
      "Body Composition Analysis": 2,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 4
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Strongly agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 3,
      "Brand reputation": 5,
      "Pricing": 4,
      "Payment terms": 6,
      "User reviews/ratings": 7,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+",
      "Noom"
    ],
    "wearableDevices": [
      "Apple Watch",
      "Fitbit",
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 8:51 PM UTC",
    "goals": "To lose weight",
    "priceObjection": "",
    "wtpFactors": "How well it works",
    "brandPerception": "Emergnecy",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1266,
    "priceDistribution": {
      "499": 3,
      "999": 5,
      "1499": 1,
      "1699": 2,
      "1899": 4
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.4,
      "Smart Biometrics Ring": 0.6,
      "Personalized Wellness Plan": 0.533,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.4,
      "Recovery Sessions": 0.667,
      "Nutrition Tracking": 0.4
    },
    "gender": "Male",
    "age": 44,
    "income": "$75,000 - $99,999",
    "race": "",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "West",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I rely on recommendations from others",
    "primaryGoal": "Building strength or improving athletic performance",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "Pay in full — save 32% (no interest)",
    "featureImportance": {
      "DNA Health Report": "Extremely important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Not very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Very important"
    },
    "featureRanking": {
      "DNA Health Report": 4,
      "Smart Biometrics Ring": 2,
      "Personalized Wellness Plan": 5,
      "Body Composition Analysis": 1,
      "Workout Sessions": 6,
      "Recovery Sessions": 3,
      "Nutrition Tracking": 7
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Disagree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 2,
      "Pricing": 3,
      "Payment terms": 7,
      "User reviews/ratings": 1,
      "Technology used": 4,
      "Device integration": 5
    },
    "brandConsideration": [
      "Apple Fitness+",
      "AlterMe"
    ],
    "wearableDevices": [
      "WHOOP"
    ]
  },
  {
    "date": "Feb 19, 2026 9:28 PM UTC",
    "goals": "I would like to lose some weight and also eat healthier",
    "priceObjection": "",
    "wtpFactors": "If it really works and I can see resutls from it",
    "brandPerception": "CHANE ME AND MY BODY",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 2,
    "segment": "selective",
    "avgChosenPrice": 807,
    "priceDistribution": {
      "499": 6,
      "999": 6,
      "1499": 1,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.538,
      "Smart Biometrics Ring": 0.615,
      "Personalized Wellness Plan": 0.538,
      "Body Composition Analysis": 0.462,
      "Workout Sessions": 0.385,
      "Recovery Sessions": 0.538,
      "Nutrition Tracking": 0.462
    },
    "gender": "Male",
    "age": 48,
    "income": "$50,000 - $74,999",
    "race": "White",
    "education": "4yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "Single",
    "region": "South",
    "monthlySpend": "$50–$99/month",
    "purchaseApproach": "I look for customization/personalization",
    "primaryGoal": "Improving nutrition or eating habits",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Very important",
      "Personalized Wellness Plan": "Very important",
      "Body Composition Analysis": "Extremely important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Extremely important",
      "Nutrition Tracking": "Extremely important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 4,
      "Personalized Wellness Plan": 3,
      "Body Composition Analysis": 6,
      "Workout Sessions": 5,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 2
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Agree",
      "Biometric tracking is vital for improving wellness": "Strongly agree",
      "Personalized wellness plans are more effective than generic approaches": "Strongly agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Strongly agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 6,
      "Brand reputation": 7,
      "Pricing": 4,
      "Payment terms": 5,
      "User reviews/ratings": 3,
      "Technology used": 1,
      "Device integration": 2
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  },
  {
    "date": "Feb 19, 2026 9:37 PM UTC",
    "goals": "Make more time each day for aerobic exercise and mindfullness",
    "priceObjection": "",
    "wtpFactors": "If there was access to real, qualified professionals",
    "brandPerception": "Weight loss program",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 0,
    "segment": "never-none",
    "avgChosenPrice": 1452,
    "priceDistribution": {
      "499": 1,
      "999": 3,
      "1499": 5,
      "1699": 3,
      "1899": 3
    },
    "featureChoiceRates": {
      "DNA Health Report": 0.667,
      "Smart Biometrics Ring": 0.933,
      "Personalized Wellness Plan": 0.467,
      "Body Composition Analysis": 0.533,
      "Workout Sessions": 0.467,
      "Recovery Sessions": 0.467,
      "Nutrition Tracking": 0.6
    },
    "gender": "Female",
    "age": 29,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "2yr degree",
    "employmentStatus": "Employed, full-time",
    "relationshipStatus": "",
    "region": "Midwest",
    "monthlySpend": "Less than $25/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "General health and longevity",
    "seekFrequency": "Frequently (monthly)",
    "paymentPreference": "12 monthly payments (no interest)",
    "featureImportance": {
      "DNA Health Report": "Very important",
      "Smart Biometrics Ring": "Extremely important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Not very important",
      "Recovery Sessions": "Somewhat important",
      "Nutrition Tracking": "Somewhat important"
    },
    "featureRanking": {
      "DNA Health Report": 2,
      "Smart Biometrics Ring": 1,
      "Personalized Wellness Plan": 6,
      "Body Composition Analysis": 3,
      "Workout Sessions": 7,
      "Recovery Sessions": 4,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Neither agree nor disagree",
      "Biometric tracking is vital for improving wellness": "Agree",
      "Personalized wellness plans are more effective than generic approaches": "Agree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 1,
      "Brand reputation": 4,
      "Pricing": 3,
      "Payment terms": 6,
      "User reviews/ratings": 5,
      "Technology used": 2,
      "Device integration": 7
    },
    "brandConsideration": [
      "Peloton",
      "Fitbit",
      "Apple Fitness+"
    ],
    "wearableDevices": [
      "Garmin"
    ]
  },
  {
    "date": "Feb 19, 2026 9:44 PM UTC",
    "goals": "I would like to lose some weight and just be healthier overall",
    "priceObjection": "I would never purchase a program for that much money",
    "wtpFactors": "It has to be cost-friendly",
    "brandPerception": "Altering your health",
    "otherBrand": "",
    "otherDevice": "",
    "otherGoal": "",
    "noneCount": 15,
    "segment": "always-none",
    "avgChosenPrice": null,
    "priceDistribution": {
      "499": 0,
      "999": 0,
      "1499": 0,
      "1699": 0,
      "1899": 0
    },
    "featureChoiceRates": {
      "DNA Health Report": 0,
      "Smart Biometrics Ring": 0,
      "Personalized Wellness Plan": 0,
      "Body Composition Analysis": 0,
      "Workout Sessions": 0,
      "Recovery Sessions": 0,
      "Nutrition Tracking": 0
    },
    "gender": "Female",
    "age": 45,
    "income": "$75,000 - $99,999",
    "race": "White",
    "education": "Some college",
    "employmentStatus": "Temporarily unemployed",
    "relationshipStatus": "",
    "region": "NorthEast",
    "monthlySpend": "$25–$49/month",
    "purchaseApproach": "I try to find the best value for my money",
    "primaryGoal": "Losing weight or managing body composition",
    "seekFrequency": "Occasionally (a few times a year)",
    "paymentPreference": "None of these",
    "featureImportance": {
      "DNA Health Report": "Not at all important",
      "Smart Biometrics Ring": "Not very important",
      "Personalized Wellness Plan": "Somewhat important",
      "Body Composition Analysis": "Very important",
      "Workout Sessions": "Very important",
      "Recovery Sessions": "Very important",
      "Nutrition Tracking": "Not very important"
    },
    "featureRanking": {
      "DNA Health Report": 7,
      "Smart Biometrics Ring": 6,
      "Personalized Wellness Plan": 4,
      "Body Composition Analysis": 2,
      "Workout Sessions": 3,
      "Recovery Sessions": 1,
      "Nutrition Tracking": 5
    },
    "attitudes": {
      "DNA-based fitness solutions help me achieve better health outcomes": "Strongly disagree",
      "Biometric tracking is vital for improving wellness": "Neither agree nor disagree",
      "Personalized wellness plans are more effective than generic approaches": "Neither agree nor disagree",
      "Recovery content is important for my fitness routine": "Agree",
      "Nutrition guidance is essential for health and wellness": "Agree"
    },
    "purchaseFactorRanking": {
      "Specific features offered": 5,
      "Brand reputation": 3,
      "Pricing": 1,
      "Payment terms": 4,
      "User reviews/ratings": 2,
      "Technology used": 7,
      "Device integration": 6
    },
    "brandConsideration": [
      "None of these"
    ],
    "wearableDevices": [
      "None of the above"
    ]
  }
];
